!function (root, factory) {
  "object" == typeof exports && "object" == typeof module ? module.exports = factory(require("react")) : "function" == typeof define && define.amd ? define(["react"], factory) : "object" == typeof exports ? exports.ReactD3Treemap = factory(require("react")) : root.ReactD3Treemap = factory(root.React);
}(window, function (__WEBPACK_EXTERNAL_MODULE__1__) {
  return modules = [function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    function define(constructor, factory, prototype) {
      constructor.prototype = factory.prototype = prototype, prototype.constructor = constructor;
    }

    function extend(parent, definition) {
      var prototype = Object.create(parent.prototype);

      for (var key in definition) {
        prototype[key] = definition[key];
      }

      return prototype;
    }

    function Color() {}

    var reI = "\\s*([+-]?\\d+)\\s*",
        reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        reHex3 = /^#([0-9a-f]{3})$/,
        reHex6 = /^#([0-9a-f]{6})$/,
        reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
        reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
        reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
        reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
        reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
        reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$"),
        named = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function color(format) {
      var m;
      return format = (format + "").trim().toLowerCase(), (m = reHex3.exec(format)) ? new Rgb((m = parseInt(m[1], 16)) >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | 240 & m, (15 & m) << 4 | 15 & m, 1) : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format)) ? new Rgb(255 * m[1] / 100, 255 * m[2] / 100, 255 * m[3] / 100, 1) : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format)) ? rgba(255 * m[1] / 100, 255 * m[2] / 100, 255 * m[3] / 100, m[4]) : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format) ? rgbn(named[format]) : "transparent" === format ? new Rgb(NaN, NaN, NaN, 0) : null;
    }

    function rgbn(n) {
      return new Rgb(n >> 16 & 255, n >> 8 & 255, 255 & n, 1);
    }

    function rgba(r, g, b, a) {
      return a <= 0 && (r = g = b = NaN), new Rgb(r, g, b, a);
    }

    function rgbConvert(o) {
      return o instanceof Color || (o = color(o)), o ? new Rgb((o = o.rgb()).r, o.g, o.b, o.opacity) : new Rgb();
    }

    function rgb(r, g, b, opacity) {
      return 1 === arguments.length ? rgbConvert(r) : new Rgb(r, g, b, null == opacity ? 1 : opacity);
    }

    function Rgb(r, g, b, opacity) {
      this.r = +r, this.g = +g, this.b = +b, this.opacity = +opacity;
    }

    function _hex(value) {
      return ((value = Math.max(0, Math.min(255, Math.round(value) || 0))) < 16 ? "0" : "") + value.toString(16);
    }

    function hsla(h, s, l, a) {
      return a <= 0 ? h = s = l = NaN : l <= 0 || 1 <= l ? h = s = NaN : s <= 0 && (h = NaN), new Hsl(h, s, l, a);
    }

    function hsl(h, s, l, opacity) {
      return 1 === arguments.length ? function (o) {
        if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
        if (o instanceof Color || (o = color(o)), !o) return new Hsl();
        if (o instanceof Hsl) return o;
        var r = (o = o.rgb()).r / 255,
            g = o.g / 255,
            b = o.b / 255,
            min = Math.min(r, g, b),
            max = Math.max(r, g, b),
            h = NaN,
            s = max - min,
            l = (max + min) / 2;
        return s ? (h = r === max ? (g - b) / s + 6 * (g < b) : g === max ? (b - r) / s + 2 : (r - g) / s + 4, s /= l < .5 ? max + min : 2 - max - min, h *= 60) : s = 0 < l && l < 1 ? 0 : h, new Hsl(h, s, l, o.opacity);
      }(h) : new Hsl(h, s, l, null == opacity ? 1 : opacity);
    }

    function Hsl(h, s, l, opacity) {
      this.h = +h, this.s = +s, this.l = +l, this.opacity = +opacity;
    }

    function hsl2rgb(h, m1, m2) {
      return 255 * (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1);
    }

    define(Color, color, {
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: function hex() {
        return this.rgb().hex();
      },
      toString: function toString() {
        return this.rgb() + "";
      }
    }), define(Rgb, rgb, extend(Color, {
      brighter: function brighter(k) {
        return k = null == k ? 1 / .7 : Math.pow(1 / .7, k), new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
      },
      darker: function darker(k) {
        return k = null == k ? .7 : Math.pow(.7, k), new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: function hex() {
        return "#" + _hex(this.r) + _hex(this.g) + _hex(this.b);
      },
      toString: function toString() {
        var a = this.opacity;
        return (1 === (a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === a ? ")" : ", " + a + ")");
      }
    })), define(Hsl, hsl, extend(Color, {
      brighter: function brighter(k) {
        return k = null == k ? 1 / .7 : Math.pow(1 / .7, k), new Hsl(this.h, this.s, this.l * k, this.opacity);
      },
      darker: function darker(k) {
        return k = null == k ? .7 : Math.pow(.7, k), new Hsl(this.h, this.s, this.l * k, this.opacity);
      },
      rgb: function rgb() {
        var h = this.h % 360 + 360 * (this.h < 0),
            s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
            l = this.l,
            m2 = l + (l < .5 ? l : 1 - l) * s,
            m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(240 <= h ? h - 240 : 120 + h, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? 240 + h : h - 120, m1, m2), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      }
    }));
    var deg2rad = Math.PI / 180,
        rad2deg = 180 / Math.PI,
        Xn = .96422,
        Yn = 1,
        Zn = .82521,
        t0 = 4 / 29,
        t1 = 6 / 29,
        t2 = 3 * t1 * t1,
        t3 = t1 * t1 * t1;

    function labConvert(o) {
      if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);

      if (o instanceof Hcl) {
        if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
        var h = o.h * deg2rad;
        return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
      }

      o instanceof Rgb || (o = rgbConvert(o));
      var x,
          z,
          r = rgb2lrgb(o.r),
          g = rgb2lrgb(o.g),
          b = rgb2lrgb(o.b),
          y = xyz2lab((.2225045 * r + .7168786 * g + .0606169 * b) / Yn);
      return r === g && g === b ? x = z = y : (x = xyz2lab((.4360747 * r + .3850649 * g + .1430804 * b) / Xn), z = xyz2lab((.0139322 * r + .0971045 * g + .7141733 * b) / Zn)), new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
    }

    function lab(l, a, b, opacity) {
      return 1 === arguments.length ? labConvert(l) : new Lab(l, a, b, null == opacity ? 1 : opacity);
    }

    function Lab(l, a, b, opacity) {
      this.l = +l, this.a = +a, this.b = +b, this.opacity = +opacity;
    }

    function xyz2lab(t) {
      return t3 < t ? Math.pow(t, 1 / 3) : t / t2 + t0;
    }

    function lab2xyz(t) {
      return t1 < t ? t * t * t : t2 * (t - t0);
    }

    function lrgb2rgb(x) {
      return 255 * (x <= .0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - .055);
    }

    function rgb2lrgb(x) {
      return (x /= 255) <= .04045 ? x / 12.92 : Math.pow((x + .055) / 1.055, 2.4);
    }

    function hclConvert(o) {
      if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
      if (o instanceof Lab || (o = labConvert(o)), 0 === o.a && 0 === o.b) return new Hcl(NaN, 0, o.l, o.opacity);
      var h = Math.atan2(o.b, o.a) * rad2deg;
      return new Hcl(h < 0 ? 360 + h : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
    }

    function hcl(h, c, l, opacity) {
      return 1 === arguments.length ? hclConvert(h) : new Hcl(h, c, l, null == opacity ? 1 : opacity);
    }

    function Hcl(h, c, l, opacity) {
      this.h = +h, this.c = +c, this.l = +l, this.opacity = +opacity;
    }

    define(Lab, lab, extend(Color, {
      brighter: function brighter(k) {
        return new Lab(this.l + 18 * (null == k ? 1 : k), this.a, this.b, this.opacity);
      },
      darker: function darker(k) {
        return new Lab(this.l - 18 * (null == k ? 1 : k), this.a, this.b, this.opacity);
      },
      rgb: function rgb() {
        var y = (this.l + 16) / 116,
            x = isNaN(this.a) ? y : y + this.a / 500,
            z = isNaN(this.b) ? y : y - this.b / 200;
        return new Rgb(lrgb2rgb(3.1338561 * (x = Xn * lab2xyz(x)) - 1.6168667 * (y = Yn * lab2xyz(y)) - .4906146 * (z = Zn * lab2xyz(z))), lrgb2rgb(-.9787684 * x + 1.9161415 * y + .033454 * z), lrgb2rgb(.0719453 * x - .2289914 * y + 1.4052427 * z), this.opacity);
      }
    })), define(Hcl, hcl, extend(Color, {
      brighter: function brighter(k) {
        return new Hcl(this.h, this.c, this.l + 18 * (null == k ? 1 : k), this.opacity);
      },
      darker: function darker(k) {
        return new Hcl(this.h, this.c, this.l - 18 * (null == k ? 1 : k), this.opacity);
      },
      rgb: function rgb() {
        return labConvert(this).rgb();
      }
    }));
    var A = -.14861,
        B = 1.78277,
        C = -.29227,
        D = -.90649,
        E = 1.97294,
        ED = E * D,
        EB = E * B,
        BC_DA = B * C - D * A;

    function cubehelix(h, s, l, opacity) {
      return 1 === arguments.length ? function (o) {
        if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
        o instanceof Rgb || (o = rgbConvert(o));
        var r = o.r / 255,
            g = o.g / 255,
            b = o.b / 255,
            l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
            bl = b - l,
            k = (E * (g - l) - C * bl) / D,
            s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
            h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
        return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
      }(h) : new Cubehelix(h, s, l, null == opacity ? 1 : opacity);
    }

    function Cubehelix(h, s, l, opacity) {
      this.h = +h, this.s = +s, this.l = +l, this.opacity = +opacity;
    }

    define(Cubehelix, cubehelix, extend(Color, {
      brighter: function brighter(k) {
        return k = null == k ? 1 / .7 : Math.pow(1 / .7, k), new Cubehelix(this.h, this.s, this.l * k, this.opacity);
      },
      darker: function darker(k) {
        return k = null == k ? .7 : Math.pow(.7, k), new Cubehelix(this.h, this.s, this.l * k, this.opacity);
      },
      rgb: function rgb() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
            l = +this.l,
            a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
            cosh = Math.cos(h),
            sinh = Math.sin(h);
        return new Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + E * cosh * a), this.opacity);
      }
    })), __webpack_require__.d(__webpack_exports__, "a", function () {
      return color;
    }), __webpack_require__.d(__webpack_exports__, "f", function () {
      return rgb;
    }), __webpack_require__.d(__webpack_exports__, "d", function () {
      return hsl;
    }), __webpack_require__.d(__webpack_exports__, "e", function () {
      return lab;
    }), __webpack_require__.d(__webpack_exports__, "c", function () {
      return hcl;
    }), __webpack_require__.d(__webpack_exports__, "b", function () {
      return cubehelix;
    });
  }, function (module, exports) {
    module.exports = __WEBPACK_EXTERNAL_MODULE__1__;
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);

    function ascending(a, b) {
      return a < b ? -1 : b < a ? 1 : b <= a ? 0 : NaN;
    }

    function bisector(compare) {
      return 1 === compare.length && (compare = function (f) {
        return function (d, x) {
          return ascending(f(d), x);
        };
      }(compare)), {
        left: function left(a, x, lo, hi) {
          for (null == lo && (lo = 0), null == hi && (hi = a.length); lo < hi;) {
            var mid = lo + hi >>> 1;
            compare(a[mid], x) < 0 ? lo = 1 + mid : hi = mid;
          }

          return lo;
        },
        right: function right(a, x, lo, hi) {
          for (null == lo && (lo = 0), null == hi && (hi = a.length); lo < hi;) {
            var mid = lo + hi >>> 1;
            0 < compare(a[mid], x) ? hi = mid : lo = 1 + mid;
          }

          return lo;
        }
      };
    }

    var ascendingBisect = bisector(ascending),
        bisectRight = ascendingBisect.right,
        bisectLeft = ascendingBisect.left,
        bisect = bisectRight,
        pairs = function pairs(array, f) {
      null == f && (f = pair);

      for (var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n); i < n;) {
        pairs[i] = f(p, p = array[++i]);
      }

      return pairs;
    };

    function pair(a, b) {
      return [a, b];
    }

    function cross(values0, values1, reduce) {
      var i0,
          i1,
          i,
          value0,
          n0 = values0.length,
          n1 = values1.length,
          values = new Array(n0 * n1);

      for (null == reduce && (reduce = pair), i0 = i = 0; i0 < n0; ++i0) {
        for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
          values[i] = reduce(value0, values1[i1]);
        }
      }

      return values;
    }

    function descending(a, b) {
      return b < a ? -1 : a < b ? 1 : a <= b ? 0 : NaN;
    }

    function number(x) {
      return null === x ? NaN : +x;
    }

    function variance(values, valueof) {
      var value,
          delta,
          n = values.length,
          m = 0,
          i = -1,
          mean = 0,
          sum = 0;
      if (null == valueof) for (; ++i < n;) {
        isNaN(value = number(values[i])) || (sum += (delta = value - mean) * (value - (mean += delta / ++m)));
      } else for (; ++i < n;) {
        isNaN(value = number(valueof(values[i], i, values))) || (sum += (delta = value - mean) * (value - (mean += delta / ++m)));
      }
      if (1 < m) return sum / (m - 1);
    }

    function deviation(array, f) {
      var v = variance(array, f);
      return v ? Math.sqrt(v) : v;
    }

    function extent(values, valueof) {
      var value,
          min,
          max,
          n = values.length,
          i = -1;

      if (null == valueof) {
        for (; ++i < n;) {
          if (null != (value = values[i]) && value <= value) for (min = max = value; ++i < n;) {
            null != (value = values[i]) && (value < min && (min = value), max < value && (max = value));
          }
        }
      } else for (; ++i < n;) {
        if (null != (value = valueof(values[i], i, values)) && value <= value) for (min = max = value; ++i < n;) {
          null != (value = valueof(values[i], i, values)) && (value < min && (min = value), max < value && (max = value));
        }
      }

      return [min, max];
    }

    function constant(x) {
      return function () {
        return x;
      };
    }

    function identity(x) {
      return x;
    }

    var array_array = Array.prototype,
        slice = array_array.slice,
        map = array_array.map,
        range = function range(start, stop, step) {
      start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

      for (var i = -1, n = 0 | Math.max(0, Math.ceil((stop - start) / step)), range = new Array(n); ++i < n;) {
        range[i] = start + i * step;
      }

      return range;
    },
        e10 = Math.sqrt(50),
        e5 = Math.sqrt(10),
        e2 = Math.sqrt(2),
        ticks = function ticks(start, stop, count) {
      var reverse,
          n,
          ticks,
          step,
          i = -1;
      if (count = +count, (start = +start) === (stop = +stop) && 0 < count) return [start];
      if ((reverse = stop < start) && (n = start, start = stop, stop = n), 0 === (step = tickIncrement(start, stop, count)) || !isFinite(step)) return [];
      if (0 < step) for (start = Math.ceil(start / step), stop = Math.floor(stop / step), ticks = new Array(n = Math.ceil(stop - start + 1)); ++i < n;) {
        ticks[i] = (start + i) * step;
      } else for (start = Math.floor(start * step), stop = Math.ceil(stop * step), ticks = new Array(n = Math.ceil(start - stop + 1)); ++i < n;) {
        ticks[i] = (start - i) / step;
      }
      return reverse && ticks.reverse(), ticks;
    };

    function tickIncrement(start, stop, count) {
      var step = (stop - start) / Math.max(0, count),
          power = Math.floor(Math.log(step) / Math.LN10),
          error = step / Math.pow(10, power);
      return 0 <= power ? (e10 <= error ? 10 : e5 <= error ? 5 : e2 <= error ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (e10 <= error ? 10 : e5 <= error ? 5 : e2 <= error ? 2 : 1);
    }

    function tickStep(start, stop, count) {
      var step0 = Math.abs(stop - start) / Math.max(0, count),
          step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
          error = step0 / step1;
      return e10 <= error ? step1 *= 10 : e5 <= error ? step1 *= 5 : e2 <= error && (step1 *= 2), stop < start ? -step1 : step1;
    }

    function sturges(values) {
      return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
    }

    function src_histogram() {
      var value = identity,
          domain = extent,
          threshold = sturges;

      function histogram(data) {
        var i,
            x,
            n = data.length,
            values = new Array(n);

        for (i = 0; i < n; ++i) {
          values[i] = value(data[i], i, data);
        }

        var xz = domain(values),
            x0 = xz[0],
            x1 = xz[1],
            tz = threshold(values, x0, x1);
        Array.isArray(tz) || (tz = tickStep(x0, x1, tz), tz = range(Math.ceil(x0 / tz) * tz, x1, tz));

        for (var m = tz.length; tz[0] <= x0;) {
          tz.shift(), --m;
        }

        for (; tz[m - 1] > x1;) {
          tz.pop(), --m;
        }

        var bin,
            bins = new Array(m + 1);

        for (i = 0; i <= m; ++i) {
          (bin = bins[i] = []).x0 = 0 < i ? tz[i - 1] : x0, bin.x1 = i < m ? tz[i] : x1;
        }

        for (i = 0; i < n; ++i) {
          x0 <= (x = values[i]) && x <= x1 && bins[bisect(tz, x, 0, m)].push(data[i]);
        }

        return bins;
      }

      return histogram.value = function (_) {
        return arguments.length ? (value = "function" == typeof _ ? _ : constant(_), histogram) : value;
      }, histogram.domain = function (_) {
        return arguments.length ? (domain = "function" == typeof _ ? _ : constant([_[0], _[1]]), histogram) : domain;
      }, histogram.thresholds = function (_) {
        return arguments.length ? (threshold = "function" == typeof _ ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
      }, histogram;
    }

    function quantile(values, p, valueof) {
      if (null == valueof && (valueof = number), n = values.length) {
        if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (1 <= p) return +valueof(values[n - 1], n - 1, values);
        var n,
            i = (n - 1) * p,
            i0 = Math.floor(i),
            value0 = +valueof(values[i0], i0, values);
        return value0 + (+valueof(values[i0 + 1], i0 + 1, values) - value0) * (i - i0);
      }
    }

    function freedmanDiaconis(values, min, max) {
      return values = map.call(values, number).sort(ascending), Math.ceil((max - min) / (2 * (quantile(values, .75) - quantile(values, .25)) * Math.pow(values.length, -1 / 3)));
    }

    function scott(values, min, max) {
      return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
    }

    function src_max(values, valueof) {
      var value,
          max,
          n = values.length,
          i = -1;

      if (null == valueof) {
        for (; ++i < n;) {
          if (null != (value = values[i]) && value <= value) for (max = value; ++i < n;) {
            null != (value = values[i]) && max < value && (max = value);
          }
        }
      } else for (; ++i < n;) {
        if (null != (value = valueof(values[i], i, values)) && value <= value) for (max = value; ++i < n;) {
          null != (value = valueof(values[i], i, values)) && max < value && (max = value);
        }
      }

      return max;
    }

    function src_mean(values, valueof) {
      var value,
          n = values.length,
          m = n,
          i = -1,
          sum = 0;
      if (null == valueof) for (; ++i < n;) {
        isNaN(value = number(values[i])) ? --m : sum += value;
      } else for (; ++i < n;) {
        isNaN(value = number(valueof(values[i], i, values))) ? --m : sum += value;
      }
      if (m) return sum / m;
    }

    function median(values, valueof) {
      var value,
          n = values.length,
          i = -1,
          numbers = [];
      if (null == valueof) for (; ++i < n;) {
        isNaN(value = number(values[i])) || numbers.push(value);
      } else for (; ++i < n;) {
        isNaN(value = number(valueof(values[i], i, values))) || numbers.push(value);
      }
      return quantile(numbers.sort(ascending), .5);
    }

    function merge(arrays) {
      for (var m, merged, array, n = arrays.length, i = -1, j = 0; ++i < n;) {
        j += arrays[i].length;
      }

      for (merged = new Array(j); 0 <= --n;) {
        for (m = (array = arrays[n]).length; 0 <= --m;) {
          merged[--j] = array[m];
        }
      }

      return merged;
    }

    function src_min(values, valueof) {
      var value,
          min,
          n = values.length,
          i = -1;

      if (null == valueof) {
        for (; ++i < n;) {
          if (null != (value = values[i]) && value <= value) for (min = value; ++i < n;) {
            null != (value = values[i]) && value < min && (min = value);
          }
        }
      } else for (; ++i < n;) {
        if (null != (value = valueof(values[i], i, values)) && value <= value) for (min = value; ++i < n;) {
          null != (value = valueof(values[i], i, values)) && value < min && (min = value);
        }
      }

      return min;
    }

    function permute(array, indexes) {
      for (var i = indexes.length, permutes = new Array(i); i--;) {
        permutes[i] = array[indexes[i]];
      }

      return permutes;
    }

    function scan(values, compare) {
      if (n = values.length) {
        var n,
            xi,
            i = 0,
            j = 0,
            xj = values[j];

        for (null == compare && (compare = ascending); ++i < n;) {
          (compare(xi = values[i], xj) < 0 || 0 !== compare(xj, xj)) && (xj = xi, j = i);
        }

        return 0 === compare(xj, xj) ? j : void 0;
      }
    }

    function shuffle(array, i0, i1) {
      for (var t, i, m = (null == i1 ? array.length : i1) - (i0 = null == i0 ? 0 : +i0); m;) {
        i = Math.random() * m-- | 0, t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
      }

      return array;
    }

    function src_sum(values, valueof) {
      var value,
          n = values.length,
          i = -1,
          sum = 0;
      if (null == valueof) for (; ++i < n;) {
        (value = +values[i]) && (sum += value);
      } else for (; ++i < n;) {
        (value = +valueof(values[i], i, values)) && (sum += value);
      }
      return sum;
    }

    function src_transpose(matrix) {
      if (!(n = matrix.length)) return [];

      for (var i = -1, m = src_min(matrix, transpose_length), transpose = new Array(m); ++i < m;) {
        for (var n, j = -1, row = transpose[i] = new Array(n); ++j < n;) {
          row[j] = matrix[j][i];
        }
      }

      return transpose;
    }

    function transpose_length(d) {
      return d.length;
    }

    function zip() {
      return src_transpose(arguments);
    }

    __webpack_require__.d(__webpack_exports__, "bisect", function () {
      return bisect;
    }), __webpack_require__.d(__webpack_exports__, "bisectRight", function () {
      return bisectRight;
    }), __webpack_require__.d(__webpack_exports__, "bisectLeft", function () {
      return bisectLeft;
    }), __webpack_require__.d(__webpack_exports__, "ascending", function () {
      return ascending;
    }), __webpack_require__.d(__webpack_exports__, "bisector", function () {
      return bisector;
    }), __webpack_require__.d(__webpack_exports__, "cross", function () {
      return cross;
    }), __webpack_require__.d(__webpack_exports__, "descending", function () {
      return descending;
    }), __webpack_require__.d(__webpack_exports__, "deviation", function () {
      return deviation;
    }), __webpack_require__.d(__webpack_exports__, "extent", function () {
      return extent;
    }), __webpack_require__.d(__webpack_exports__, "histogram", function () {
      return src_histogram;
    }), __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function () {
      return freedmanDiaconis;
    }), __webpack_require__.d(__webpack_exports__, "thresholdScott", function () {
      return scott;
    }), __webpack_require__.d(__webpack_exports__, "thresholdSturges", function () {
      return sturges;
    }), __webpack_require__.d(__webpack_exports__, "max", function () {
      return src_max;
    }), __webpack_require__.d(__webpack_exports__, "mean", function () {
      return src_mean;
    }), __webpack_require__.d(__webpack_exports__, "median", function () {
      return median;
    }), __webpack_require__.d(__webpack_exports__, "merge", function () {
      return merge;
    }), __webpack_require__.d(__webpack_exports__, "min", function () {
      return src_min;
    }), __webpack_require__.d(__webpack_exports__, "pairs", function () {
      return pairs;
    }), __webpack_require__.d(__webpack_exports__, "permute", function () {
      return permute;
    }), __webpack_require__.d(__webpack_exports__, "quantile", function () {
      return quantile;
    }), __webpack_require__.d(__webpack_exports__, "range", function () {
      return range;
    }), __webpack_require__.d(__webpack_exports__, "scan", function () {
      return scan;
    }), __webpack_require__.d(__webpack_exports__, "shuffle", function () {
      return shuffle;
    }), __webpack_require__.d(__webpack_exports__, "sum", function () {
      return src_sum;
    }), __webpack_require__.d(__webpack_exports__, "ticks", function () {
      return ticks;
    }), __webpack_require__.d(__webpack_exports__, "tickIncrement", function () {
      return tickIncrement;
    }), __webpack_require__.d(__webpack_exports__, "tickStep", function () {
      return tickStep;
    }), __webpack_require__.d(__webpack_exports__, "transpose", function () {
      return src_transpose;
    }), __webpack_require__.d(__webpack_exports__, "variance", function () {
      return variance;
    }), __webpack_require__.d(__webpack_exports__, "zip", function () {
      return zip;
    });
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);

    var src = __webpack_require__(0);

    function basis(t1, v0, v1, v2, v3) {
      var t2 = t1 * t1,
          t3 = t2 * t1;
      return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
    }

    function src_basis(values) {
      var n = values.length - 1;
      return function (t) {
        var i = t <= 0 ? t = 0 : 1 <= t ? n - (t = 1) : Math.floor(t * n),
            v1 = values[i],
            v2 = values[i + 1],
            v0 = 0 < i ? values[i - 1] : 2 * v1 - v2,
            v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return basis((t - i / n) * n, v0, v1, v2, v3);
      };
    }

    function basisClosed(values) {
      var n = values.length;
      return function (t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
            v0 = values[(i + n - 1) % n],
            v1 = values[i % n],
            v2 = values[(i + 1) % n],
            v3 = values[(i + 2) % n];
        return basis((t - i / n) * n, v0, v1, v2, v3);
      };
    }

    var constant = function constant(x) {
      return function () {
        return x;
      };
    };

    function linear(a, d) {
      return function (t) {
        return a + t * d;
      };
    }

    function color_hue(a, b) {
      var d = b - a;
      return d ? linear(a, 180 < d || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
    }

    function gamma(y) {
      return 1 == (y = +y) ? nogamma : function (a, b) {
        return b - a ? function (a, b, y) {
          return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
            return Math.pow(a + t * b, y);
          };
        }(a, b, y) : constant(isNaN(a) ? b : a);
      };
    }

    function nogamma(a, b) {
      var d = b - a;
      return d ? linear(a, d) : constant(isNaN(a) ? b : a);
    }

    var src_rgb = function rgbGamma(y) {
      var color = gamma(y);

      function rgb(start, end) {
        var r = color((start = Object(src.f)(start)).r, (end = Object(src.f)(end)).r),
            g = color(start.g, end.g),
            b = color(start.b, end.b),
            opacity = nogamma(start.opacity, end.opacity);
        return function (t) {
          return start.r = r(t), start.g = g(t), start.b = b(t), start.opacity = opacity(t), start + "";
        };
      }

      return rgb.gamma = rgbGamma, rgb;
    }(1);

    function rgbSpline(spline) {
      return function (colors) {
        var i,
            color,
            n = colors.length,
            r = new Array(n),
            g = new Array(n),
            b = new Array(n);

        for (i = 0; i < n; ++i) {
          color = Object(src.f)(colors[i]), r[i] = color.r || 0, g[i] = color.g || 0, b[i] = color.b || 0;
        }

        return r = spline(r), g = spline(g), b = spline(b), color.opacity = 1, function (t) {
          return color.r = r(t), color.g = g(t), color.b = b(t), color + "";
        };
      };
    }

    function array(a, b) {
      var i,
          nb = b ? b.length : 0,
          na = a ? Math.min(nb, a.length) : 0,
          x = new Array(na),
          c = new Array(nb);

      for (i = 0; i < na; ++i) {
        x[i] = src_value(a[i], b[i]);
      }

      for (; i < nb; ++i) {
        c[i] = b[i];
      }

      return function (t) {
        for (i = 0; i < na; ++i) {
          c[i] = x[i](t);
        }

        return c;
      };
    }

    function date(a, b) {
      var d = new Date();
      return b -= a = +a, function (t) {
        return d.setTime(a + b * t), d;
      };
    }

    function number(a, b) {
      return b -= a = +a, function (t) {
        return a + b * t;
      };
    }

    function object(a, b) {
      var k,
          i = {},
          c = {};

      for (k in null !== a && "object" == typeof a || (a = {}), null !== b && "object" == typeof b || (b = {}), b) {
        k in a ? i[k] = src_value(a[k], b[k]) : c[k] = b[k];
      }

      return function (t) {
        for (k in i) {
          c[k] = i[k](t);
        }

        return c;
      };
    }

    var rgbBasis = rgbSpline(src_basis),
        rgbBasisClosed = rgbSpline(basisClosed),
        reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        reB = new RegExp(reA.source, "g");

    function string(a, b) {
      var am,
          bm,
          bs,
          bi = reA.lastIndex = reB.lastIndex = 0,
          i = -1,
          s = [],
          q = [];

      for (a += "", b += ""; (am = reA.exec(a)) && (bm = reB.exec(b));) {
        (bs = bm.index) > bi && (bs = b.slice(bi, bs), s[i] ? s[i] += bs : s[++i] = bs), (am = am[0]) === (bm = bm[0]) ? s[i] ? s[i] += bm : s[++i] = bm : (s[++i] = null, q.push({
          i: i,
          x: number(am, bm)
        })), bi = reB.lastIndex;
      }

      return bi < b.length && (bs = b.slice(bi), s[i] ? s[i] += bs : s[++i] = bs), s.length < 2 ? q[0] ? function (b) {
        return function (t) {
          return b(t) + "";
        };
      }(q[0].x) : function (b) {
        return function () {
          return b;
        };
      }(b) : (b = q.length, function (t) {
        for (var o, i = 0; i < b; ++i) {
          s[(o = q[i]).i] = o.x(t);
        }

        return s.join("");
      });
    }

    function discrete(range) {
      var n = range.length;
      return function (t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
      };
    }

    function src_hue(a, b) {
      var i = color_hue(+a, +b);
      return function (t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
      };
    }

    function round(a, b) {
      return b -= a = +a, function (t) {
        return Math.round(a + b * t);
      };
    }

    function decompose(a, b, c, d, e, f) {
      var scaleX, scaleY, skewX;
      return (scaleX = Math.sqrt(a * a + b * b)) && (a /= scaleX, b /= scaleX), (skewX = a * c + b * d) && (c -= a * skewX, d -= b * skewX), (scaleY = Math.sqrt(c * c + d * d)) && (c /= scaleY, d /= scaleY, skewX /= scaleY), a * d < b * c && (a = -a, b = -b, skewX = -skewX, scaleX = -scaleX), {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * degrees,
        skewX: Math.atan(skewX) * degrees,
        scaleX: scaleX,
        scaleY: scaleY
      };
    }

    var cssNode,
        cssRoot,
        cssView,
        svgNode,
        src_value = function src_value(a, b) {
      var c,
          t = typeof b;
      return null == b || "boolean" == t ? constant(b) : ("number" == t ? number : "string" == t ? (c = Object(src.a)(b)) ? (b = c, src_rgb) : string : b instanceof src.a ? src_rgb : b instanceof Date ? date : Array.isArray(b) ? array : "function" != typeof b.valueOf && "function" != typeof b.toString || isNaN(b) ? object : number)(a, b);
    },
        degrees = 180 / Math.PI,
        identity = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    };

    function interpolateTransform(parse, pxComma, pxParen, degParen) {
      function pop(s) {
        return s.length ? s.pop() + " " : "";
      }

      return function (a, b) {
        var s = [],
            q = [];
        return a = parse(a), b = parse(b), function (xa, ya, xb, yb, s, q) {
          if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
              i: i - 4,
              x: number(xa, xb)
            }, {
              i: i - 2,
              x: number(ya, yb)
            });
          } else (xb || yb) && s.push("translate(" + xb + pxComma + yb + pxParen);
        }(a.translateX, a.translateY, b.translateX, b.translateY, s, q), function (a, b, s, q) {
          a !== b ? (180 < a - b ? b += 360 : 180 < b - a && (a += 360), q.push({
            i: s.push(pop(s) + "rotate(", null, degParen) - 2,
            x: number(a, b)
          })) : b && s.push(pop(s) + "rotate(" + b + degParen);
        }(a.rotate, b.rotate, s, q), function (a, b, s, q) {
          a !== b ? q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: number(a, b)
          }) : b && s.push(pop(s) + "skewX(" + b + degParen);
        }(a.skewX, b.skewX, s, q), function (xa, ya, xb, yb, s, q) {
          if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
              i: i - 4,
              x: number(xa, xb)
            }, {
              i: i - 2,
              x: number(ya, yb)
            });
          } else 1 === xb && 1 === yb || s.push(pop(s) + "scale(" + xb + "," + yb + ")");
        }(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q), a = b = null, function (t) {
          for (var o, i = -1, n = q.length; ++i < n;) {
            s[(o = q[i]).i] = o.x(t);
          }

          return s.join("");
        };
      };
    }

    var interpolateTransformCss = interpolateTransform(function (value) {
      return "none" === value ? identity : (cssNode || (cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView), cssNode.style.transform = value, value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform"), cssRoot.removeChild(cssNode), value = value.slice(7, -1).split(","), decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]));
    }, "px, ", "px)", "deg)"),
        interpolateTransformSvg = interpolateTransform(function (value) {
      return null == value ? identity : ((svgNode = svgNode || document.createElementNS("http://www.w3.org/2000/svg", "g")).setAttribute("transform", value), (value = svgNode.transform.baseVal.consolidate()) ? (value = value.matrix, decompose(value.a, value.b, value.c, value.d, value.e, value.f)) : identity);
    }, ", ", ")", ")"),
        rho = Math.SQRT2;

    function cosh(x) {
      return ((x = Math.exp(x)) + 1 / x) / 2;
    }

    function zoom(p0, p1) {
      var i,
          S,
          ux0 = p0[0],
          uy0 = p0[1],
          w0 = p0[2],
          ux1 = p1[0],
          uy1 = p1[1],
          w1 = p1[2],
          dx = ux1 - ux0,
          dy = uy1 - uy0,
          d2 = dx * dx + dy * dy;
      if (d2 < 1e-12) S = Math.log(w1 / w0) / rho, i = function i(t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };else {
        var d1 = Math.sqrt(d2),
            b0 = (w1 * w1 - w0 * w0 + 4 * d2) / (2 * w0 * 2 * d1),
            b1 = (w1 * w1 - w0 * w0 - 4 * d2) / (2 * w1 * 2 * d1),
            r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
            r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / rho, i = function i(t) {
          var s = t * S,
              coshr0 = cosh(r0),
              u = w0 / (2 * d1) * (coshr0 * function (x) {
            return ((x = Math.exp(2 * x)) - 1) / (x + 1);
          }(rho * s + r0) - function (x) {
            return ((x = Math.exp(x)) - 1 / x) / 2;
          }(r0));

          return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
        };
      }
      return i.duration = 1e3 * S, i;
    }

    function hsl(hue) {
      return function (start, end) {
        var h = hue((start = Object(src.d)(start)).h, (end = Object(src.d)(end)).h),
            s = nogamma(start.s, end.s),
            l = nogamma(start.l, end.l),
            opacity = nogamma(start.opacity, end.opacity);
        return function (t) {
          return start.h = h(t), start.s = s(t), start.l = l(t), start.opacity = opacity(t), start + "";
        };
      };
    }

    var src_hsl = hsl(color_hue),
        hslLong = hsl(nogamma);

    function lab(start, end) {
      var l = nogamma((start = Object(src.e)(start)).l, (end = Object(src.e)(end)).l),
          a = nogamma(start.a, end.a),
          b = nogamma(start.b, end.b),
          opacity = nogamma(start.opacity, end.opacity);
      return function (t) {
        return start.l = l(t), start.a = a(t), start.b = b(t), start.opacity = opacity(t), start + "";
      };
    }

    function hcl(hue) {
      return function (start, end) {
        var h = hue((start = Object(src.c)(start)).h, (end = Object(src.c)(end)).h),
            c = nogamma(start.c, end.c),
            l = nogamma(start.l, end.l),
            opacity = nogamma(start.opacity, end.opacity);
        return function (t) {
          return start.h = h(t), start.c = c(t), start.l = l(t), start.opacity = opacity(t), start + "";
        };
      };
    }

    var src_hcl = hcl(color_hue),
        hclLong = hcl(nogamma);

    function cubehelix_cubehelix(hue) {
      return function cubehelixGamma(y) {
        function cubehelix(start, end) {
          var h = hue((start = Object(src.b)(start)).h, (end = Object(src.b)(end)).h),
              s = nogamma(start.s, end.s),
              l = nogamma(start.l, end.l),
              opacity = nogamma(start.opacity, end.opacity);
          return function (t) {
            return start.h = h(t), start.s = s(t), start.l = l(Math.pow(t, y)), start.opacity = opacity(t), start + "";
          };
        }

        return y = +y, cubehelix.gamma = cubehelixGamma, cubehelix;
      }(1);
    }

    var src_cubehelix = cubehelix_cubehelix(color_hue),
        cubehelixLong = cubehelix_cubehelix(nogamma);

    function piecewise(interpolate, values) {
      for (var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n); i < n;) {
        I[i] = interpolate(v, v = values[++i]);
      }

      return function (t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
      };
    }

    function quantize(interpolator, n) {
      for (var samples = new Array(n), i = 0; i < n; ++i) {
        samples[i] = interpolator(i / (n - 1));
      }

      return samples;
    }

    __webpack_require__.d(__webpack_exports__, "interpolate", function () {
      return src_value;
    }), __webpack_require__.d(__webpack_exports__, "interpolateArray", function () {
      return array;
    }), __webpack_require__.d(__webpack_exports__, "interpolateBasis", function () {
      return src_basis;
    }), __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function () {
      return basisClosed;
    }), __webpack_require__.d(__webpack_exports__, "interpolateDate", function () {
      return date;
    }), __webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function () {
      return discrete;
    }), __webpack_require__.d(__webpack_exports__, "interpolateHue", function () {
      return src_hue;
    }), __webpack_require__.d(__webpack_exports__, "interpolateNumber", function () {
      return number;
    }), __webpack_require__.d(__webpack_exports__, "interpolateObject", function () {
      return object;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRound", function () {
      return round;
    }), __webpack_require__.d(__webpack_exports__, "interpolateString", function () {
      return string;
    }), __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function () {
      return interpolateTransformCss;
    }), __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function () {
      return interpolateTransformSvg;
    }), __webpack_require__.d(__webpack_exports__, "interpolateZoom", function () {
      return zoom;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRgb", function () {
      return src_rgb;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function () {
      return rgbBasis;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function () {
      return rgbBasisClosed;
    }), __webpack_require__.d(__webpack_exports__, "interpolateHsl", function () {
      return src_hsl;
    }), __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function () {
      return hslLong;
    }), __webpack_require__.d(__webpack_exports__, "interpolateLab", function () {
      return lab;
    }), __webpack_require__.d(__webpack_exports__, "interpolateHcl", function () {
      return src_hcl;
    }), __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function () {
      return hclLong;
    }), __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function () {
      return src_cubehelix;
    }), __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function () {
      return cubehelixLong;
    }), __webpack_require__.d(__webpack_exports__, "piecewise", function () {
      return piecewise;
    }), __webpack_require__.d(__webpack_exports__, "quantize", function () {
      return quantize;
    });
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);

    function formatDecimal(x, p) {
      if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
      var i,
          coefficient = x.slice(0, i);
      return [1 < coefficient.length ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
    }

    function src_exponent(x) {
      return (x = formatDecimal(Math.abs(x))) ? x[1] : NaN;
    }

    var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

    function formatSpecifier(specifier) {
      return new FormatSpecifier(specifier);
    }

    function FormatSpecifier(specifier) {
      if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
      var match;
      this.fill = match[1] || " ", this.align = match[2] || ">", this.sign = match[3] || "-", this.symbol = match[4] || "", this.zero = !!match[5], this.width = match[6] && +match[6], this.comma = !!match[7], this.precision = match[8] && +match[8].slice(1), this.trim = !!match[9], this.type = match[10] || "";
    }

    formatSpecifier.prototype = FormatSpecifier.prototype, FormatSpecifier.prototype.toString = function () {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (null == this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (null == this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
    };

    function formatRounded(x, p) {
      var d = formatDecimal(x, p);
      if (!d) return x + "";
      var coefficient = d[0],
          exponent = d[1];
      return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    }

    function identity(x) {
      return x;
    }

    function src_locale(locale) {
      var group = locale.grouping && locale.thousands ? function (grouping, thousands) {
        return function (value, width) {
          for (var i = value.length, t = [], j = 0, g = grouping[0], length = 0; 0 < i && 0 < g && (width < length + g + 1 && (g = Math.max(1, width - length)), t.push(value.substring(i -= g, i + g)), !((length += g + 1) > width));) {
            g = grouping[j = (j + 1) % grouping.length];
          }

          return t.reverse().join(thousands);
        };
      }(locale.grouping, locale.thousands) : identity,
          currency = locale.currency,
          decimal = locale.decimal,
          numerals = locale.numerals ? function (numerals) {
        return function (value) {
          return value.replace(/[0-9]/g, function (i) {
            return numerals[+i];
          });
        };
      }(locale.numerals) : identity,
          percent = locale.percent || "%";

      function newFormat(specifier) {
        var fill = (specifier = formatSpecifier(specifier)).fill,
            align = specifier.align,
            sign = specifier.sign,
            symbol = specifier.symbol,
            zero = specifier.zero,
            width = specifier.width,
            comma = specifier.comma,
            precision = specifier.precision,
            trim = specifier.trim,
            type = specifier.type;
        "n" === type ? (comma = !0, type = "g") : formatTypes[type] || (null == precision && (precision = 12), trim = !0, type = "g"), (zero || "0" === fill && "=" === align) && (zero = !0, fill = "0", align = "=");
        var prefix = "$" === symbol ? currency[0] : "#" === symbol && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
            suffix = "$" === symbol ? currency[1] : /[%p]/.test(type) ? percent : "",
            formatType = formatTypes[type],
            maybeSuffix = /[defgprs%]/.test(type);

        function format(value) {
          var i,
              n,
              c,
              valuePrefix = prefix,
              valueSuffix = suffix;
          if ("c" === type) valueSuffix = formatType(value) + valueSuffix, value = "";else {
            var valueNegative = (value = +value) < 0;
            if (value = formatType(Math.abs(value), precision), trim && (value = function (s) {
              out: for (var i1, n = s.length, i = 1, i0 = -1; i < n; ++i) {
                switch (s[i]) {
                  case ".":
                    i0 = i1 = i;
                    break;

                  case "0":
                    0 === i0 && (i0 = i), i1 = i;
                    break;

                  default:
                    if (0 < i0) {
                      if (!+s[i]) break out;
                      i0 = 0;
                    }

                }
              }

              return 0 < i0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
            }(value)), valueNegative && 0 == +value && (valueNegative = !1), valuePrefix = (valueNegative ? "(" === sign ? sign : "-" : "-" === sign || "(" === sign ? "" : sign) + valuePrefix, valueSuffix = ("s" === type ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && "(" === sign ? ")" : ""), maybeSuffix) for (i = -1, n = value.length; ++i < n;) {
              if ((c = value.charCodeAt(i)) < 48 || 57 < c) {
                valueSuffix = (46 === c ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix, value = value.slice(0, i);
                break;
              }
            }
          }
          comma && !zero && (value = group(value, 1 / 0));
          var length = valuePrefix.length + value.length + valueSuffix.length,
              padding = length < width ? new Array(width - length + 1).join(fill) : "";

          switch (comma && zero && (value = group(padding + value, padding.length ? width - valueSuffix.length : 1 / 0), padding = ""), align) {
            case "<":
              value = valuePrefix + value + valueSuffix + padding;
              break;

            case "=":
              value = valuePrefix + padding + value + valueSuffix;
              break;

            case "^":
              value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
              break;

            default:
              value = padding + valuePrefix + value + valueSuffix;
          }

          return numerals(value);
        }

        return precision = null == precision ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision)), format.toString = function () {
          return specifier + "";
        }, format;
      }

      return {
        format: newFormat,
        formatPrefix: function formatPrefix(specifier, value) {
          var f = newFormat(((specifier = formatSpecifier(specifier)).type = "f", specifier)),
              e = 3 * Math.max(-8, Math.min(8, Math.floor(src_exponent(value) / 3))),
              k = Math.pow(10, -e),
              prefix = prefixes[8 + e / 3];
          return function (value) {
            return f(k * value) + prefix;
          };
        }
      };
    }

    var prefixExponent,
        defaultLocale_locale,
        defaultLocale_format,
        defaultLocale_formatPrefix,
        formatTypes = {
      "%": function _(x, p) {
        return (100 * x).toFixed(p);
      },
      b: function b(x) {
        return Math.round(x).toString(2);
      },
      c: function c(x) {
        return x + "";
      },
      d: function d(x) {
        return Math.round(x).toString(10);
      },
      e: function e(x, p) {
        return x.toExponential(p);
      },
      f: function f(x, p) {
        return x.toFixed(p);
      },
      g: function g(x, p) {
        return x.toPrecision(p);
      },
      o: function o(x) {
        return Math.round(x).toString(8);
      },
      p: function p(x, _p) {
        return formatRounded(100 * x, _p);
      },
      r: formatRounded,
      s: function s(x, p) {
        var d = formatDecimal(x, p);
        if (!d) return x + "";
        var coefficient = d[0],
            exponent = d[1],
            i = exponent - (prefixExponent = 3 * Math.max(-8, Math.min(8, Math.floor(exponent / 3)))) + 1,
            n = coefficient.length;
        return i === n ? coefficient : n < i ? coefficient + new Array(i - n + 1).join("0") : 0 < i ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0];
      },
      X: function X(x) {
        return Math.round(x).toString(16).toUpperCase();
      },
      x: function x(_x) {
        return Math.round(_x).toString(16);
      }
    },
        prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

    function defaultLocale(definition) {
      return defaultLocale_locale = src_locale(definition), defaultLocale_format = defaultLocale_locale.format, defaultLocale_formatPrefix = defaultLocale_locale.formatPrefix, defaultLocale_locale;
    }

    defaultLocale({
      decimal: ".",
      thousands: ",",
      grouping: [3],
      currency: ["$", ""]
    });

    function precisionFixed(step) {
      return Math.max(0, -src_exponent(Math.abs(step)));
    }

    function precisionPrefix(step, value) {
      return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(src_exponent(value) / 3))) - src_exponent(Math.abs(step)));
    }

    function precisionRound(step, max) {
      return step = Math.abs(step), max = Math.abs(max) - step, Math.max(0, src_exponent(max) - src_exponent(step)) + 1;
    }

    __webpack_require__.d(__webpack_exports__, "formatDefaultLocale", function () {
      return defaultLocale;
    }), __webpack_require__.d(__webpack_exports__, "format", function () {
      return defaultLocale_format;
    }), __webpack_require__.d(__webpack_exports__, "formatPrefix", function () {
      return defaultLocale_formatPrefix;
    }), __webpack_require__.d(__webpack_exports__, "formatLocale", function () {
      return src_locale;
    }), __webpack_require__.d(__webpack_exports__, "formatSpecifier", function () {
      return formatSpecifier;
    }), __webpack_require__.d(__webpack_exports__, "precisionFixed", function () {
      return precisionFixed;
    }), __webpack_require__.d(__webpack_exports__, "precisionPrefix", function () {
      return precisionPrefix;
    }), __webpack_require__.d(__webpack_exports__, "precisionRound", function () {
      return precisionRound;
    });
  }, function (module, exports, __webpack_require__) {
    module.exports = function e(a) {
      "use strict";

      var r = /^\0+/g,
          c = /[\0\r\f]/g,
          s = /: */g,
          t = /zoo|gra/,
          i = /([,: ])(transform)/g,
          f = /,+\s*(?![^(]*[)])/g,
          n = / +\s*(?![^(]*[)])/g,
          l = / *[\0] */g,
          o = /,\r+?/g,
          h = /([\t\r\n ])*\f?&/g,
          u = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
          d = /\W+/g,
          b = /@(k\w+)\s*(\S*)\s*/,
          p = /::(place)/g,
          k = /:(read-only)/g,
          g = /\s+(?=[{\];=:>])/g,
          A = /([[}=:>])\s+/g,
          C = /(\{[^{]+?);(?=\})/g,
          w = /\s{2,}/g,
          v = /([^\(])(:+) */g,
          m = /[svh]\w+-[tblr]{2}/,
          x = /\(\s*(.*)\s*\)/g,
          $ = /([\s\S]*?);/g,
          y = /-self|flex-/g,
          O = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
          j = /stretch|:\s*\w+\-(?:conte|avail)/,
          z = /([^-])(image-set\()/,
          N = "-webkit-",
          S = "-moz-",
          F = "-ms-",
          W = 59,
          q = 125,
          B = 123,
          D = 40,
          E = 41,
          G = 91,
          H = 93,
          I = 10,
          J = 13,
          K = 9,
          L = 64,
          M = 32,
          P = 38,
          Q = 45,
          R = 95,
          T = 42,
          U = 44,
          V = 58,
          X = 39,
          Y = 34,
          Z = 47,
          _ = 62,
          ee = 43,
          ae = 126,
          re = 0,
          ce = 12,
          se = 11,
          te = 107,
          ie = 109,
          fe = 115,
          ne = 112,
          le = 111,
          oe = 105,
          he = 99,
          ue = 100,
          de = 112,
          be = 1,
          pe = 1,
          ke = 0,
          ge = 1,
          Ae = 1,
          Ce = 1,
          we = 0,
          ve = 0,
          me = 0,
          xe = [],
          $e = [],
          ye = 0,
          Oe = null,
          je = -2,
          ze = -1,
          Ne = 0,
          Se = 1,
          Fe = 2,
          We = 3,
          qe = 0,
          Be = 1,
          De = "",
          Ee = "",
          Ge = "";

      function He(e, a, s, t, i) {
        for (var f, n, o = 0, h = 0, u = 0, d = 0, g = 0, A = 0, C = 0, w = 0, m = 0, $ = 0, y = 0, O = 0, j = 0, z = 0, R = 0, we = 0, $e = 0, Oe = 0, je = 0, ze = s.length, Je = ze - 1, Re = "", Te = "", Ue = "", Ve = "", Xe = "", Ye = ""; R < ze;) {
          if (C = s.charCodeAt(R), R !== Je || h + d + u + o !== 0 && (0 !== h && (C = h === Z ? I : Z), d = u = o = 0, ze++, Je++), h + d + u + o === 0) {
            if (R === Je && (0 < we && (Te = Te.replace(c, "")), 0 < Te.trim().length)) {
              switch (C) {
                case M:
                case K:
                case W:
                case J:
                case I:
                  break;

                default:
                  Te += s.charAt(R);
              }

              C = W;
            }

            if (1 === $e) switch (C) {
              case B:
              case q:
              case W:
              case Y:
              case X:
              case D:
              case E:
              case U:
                $e = 0;

              case K:
              case J:
              case I:
              case M:
                break;

              default:
                for ($e = 0, je = R, g = C, R--, C = W; je < ze;) {
                  switch (s.charCodeAt(je++)) {
                    case I:
                    case J:
                    case W:
                      ++R, C = g, je = ze;
                      break;

                    case V:
                      0 < we && (++R, C = g);

                    case B:
                      je = ze;
                  }
                }

            }

            switch (C) {
              case B:
                for (g = (Te = Te.trim()).charCodeAt(0), y = 1, je = ++R; R < ze;) {
                  switch (C = s.charCodeAt(R)) {
                    case B:
                      y++;
                      break;

                    case q:
                      y--;
                      break;

                    case Z:
                      switch (A = s.charCodeAt(R + 1)) {
                        case T:
                        case Z:
                          R = Qe(A, R, Je, s);
                      }

                      break;

                    case G:
                      C++;

                    case D:
                      C++;

                    case Y:
                    case X:
                      for (; R++ < Je && s.charCodeAt(R) !== C;) {
                        ;
                      }

                  }

                  if (0 === y) break;
                  R++;
                }

                switch (Ue = s.substring(je, R), g === re && (g = (Te = Te.replace(r, "").trim()).charCodeAt(0)), g) {
                  case L:
                    switch (0 < we && (Te = Te.replace(c, "")), A = Te.charCodeAt(1)) {
                      case ue:
                      case ie:
                      case fe:
                      case Q:
                        f = a;
                        break;

                      default:
                        f = xe;
                    }

                    if (je = (Ue = He(a, f, Ue, A, i + 1)).length, 0 < me && 0 === je && (je = Te.length), 0 < ye && (f = Ie(xe, Te, Oe), n = Pe(We, Ue, f, a, pe, be, je, A, i, t), Te = f.join(""), void 0 === n || 0 === (je = (Ue = n.trim()).length) && (A = 0, Ue = "")), 0 < je) switch (A) {
                      case fe:
                        Te = Te.replace(x, Me);

                      case ue:
                      case ie:
                      case Q:
                        Ue = Te + "{" + Ue + "}";
                        break;

                      case te:
                        Ue = (Te = Te.replace(b, "$1 $2" + (0 < Be ? De : ""))) + "{" + Ue + "}", Ue = 1 === Ae || 2 === Ae && Le("@" + Ue, 3) ? "@" + N + Ue + "@" + Ue : "@" + Ue;
                        break;

                      default:
                        Ue = Te + Ue, t === de && (Ve += Ue, Ue = "");
                    } else Ue = "";
                    break;

                  default:
                    Ue = He(a, Ie(a, Te, Oe), Ue, t, i + 1);
                }

                Xe += Ue, j = Oe = we = z = $e = O = 0, Ue = Te = "", C = s.charCodeAt(++R);
                break;

              case q:
              case W:
                if (1 < (je = (Te = (0 < we ? Te.replace(c, "") : Te).trim()).length)) switch (0 === z && ((g = Te.charCodeAt(0)) === Q || 96 < g && g < 123) && (je = (Te = Te.replace(" ", ":")).length), 0 < ye && void 0 !== (n = Pe(Se, Te, a, e, pe, be, Ve.length, t, i, t)) && 0 === (je = (Te = n.trim()).length) && (Te = "\0\0"), g = Te.charCodeAt(0), A = Te.charCodeAt(1), g) {
                  case re:
                    break;

                  case L:
                    if (A === oe || A === he) {
                      Ye += Te + s.charAt(R);
                      break;
                    }

                  default:
                    if (Te.charCodeAt(je - 1) === V) break;
                    Ve += Ke(Te, g, A, Te.charCodeAt(2));
                }
                Oe = we = z = $e = O = 0, Te = "", C = s.charCodeAt(++R);
            }
          }

          switch (C) {
            case J:
            case I:
              if (h + d + u + o + ve === 0) switch ($) {
                case E:
                case X:
                case Y:
                case L:
                case ae:
                case _:
                case T:
                case ee:
                case Z:
                case Q:
                case V:
                case U:
                case W:
                case B:
                case q:
                  break;

                default:
                  0 < z && ($e = 1);
              }
              h === Z ? h = 0 : ge + O === 0 && t !== te && 0 < Te.length && (we = 1, Te += "\0"), 0 < ye * qe && Pe(Ne, Te, a, e, pe, be, Ve.length, t, i, t), be = 1, pe++;
              break;

            case W:
            case q:
              if (h + d + u + o === 0) {
                be++;
                break;
              }

            default:
              switch (be++, Re = s.charAt(R), C) {
                case K:
                case M:
                  if (d + o + h === 0) switch (w) {
                    case U:
                    case V:
                    case K:
                    case M:
                      Re = "";
                      break;

                    default:
                      C !== M && (Re = " ");
                  }
                  break;

                case re:
                  Re = "\\0";
                  break;

                case ce:
                  Re = "\\f";
                  break;

                case se:
                  Re = "\\v";
                  break;

                case P:
                  d + h + o === 0 && 0 < ge && (we = Oe = 1, Re = "\f" + Re);
                  break;

                case 108:
                  if (d + h + o + ke === 0 && 0 < z) switch (R - z) {
                    case 2:
                      w === ne && s.charCodeAt(R - 3) === V && (ke = w);

                    case 8:
                      m === le && (ke = m);
                  }
                  break;

                case V:
                  d + h + o === 0 && (z = R);
                  break;

                case U:
                  h + u + d + o === 0 && (we = 1, Re += "\r");
                  break;

                case Y:
                case X:
                  0 === h && (d = d === C ? 0 : 0 === d ? C : d);
                  break;

                case G:
                  d + h + u === 0 && o++;
                  break;

                case H:
                  d + h + u === 0 && o--;
                  break;

                case E:
                  d + h + o === 0 && u--;
                  break;

                case D:
                  if (d + h + o === 0) {
                    if (0 === O) switch (2 * w + 3 * m) {
                      case 533:
                        break;

                      default:
                        y = 0, O = 1;
                    }
                    u++;
                  }

                  break;

                case L:
                  h + u + d + o + z + j === 0 && (j = 1);
                  break;

                case T:
                case Z:
                  if (0 < d + o + u) break;

                  switch (h) {
                    case 0:
                      switch (2 * C + 3 * s.charCodeAt(R + 1)) {
                        case 235:
                          h = Z;
                          break;

                        case 220:
                          je = R, h = T;
                      }

                      break;

                    case T:
                      C === Z && w === T && je + 2 !== R && (33 === s.charCodeAt(je + 2) && (Ve += s.substring(je, R + 1)), Re = "", h = 0);
                  }

              }

              if (0 === h) {
                if (ge + d + o + j === 0 && t !== te && C !== W) switch (C) {
                  case U:
                  case ae:
                  case _:
                  case ee:
                  case E:
                  case D:
                    if (0 === O) {
                      switch (w) {
                        case K:
                        case M:
                        case I:
                        case J:
                          Re += "\0";
                          break;

                        default:
                          Re = "\0" + Re + (C === U ? "" : "\0");
                      }

                      we = 1;
                    } else switch (C) {
                      case D:
                        z + 7 === R && 108 === w && (z = 0), O = ++y;
                        break;

                      case E:
                        0 == (O = --y) && (we = 1, Re += "\0");
                    }

                    break;

                  case K:
                  case M:
                    switch (w) {
                      case re:
                      case B:
                      case q:
                      case W:
                      case U:
                      case ce:
                      case K:
                      case M:
                      case I:
                      case J:
                        break;

                      default:
                        0 === O && (we = 1, Re += "\0");
                    }

                }
                Te += Re, C !== M && C !== K && ($ = C);
              }

          }

          m = w, w = C, R++;
        }

        if (je = Ve.length, 0 < me && 0 === je && 0 === Xe.length && 0 === a[0].length == 0 && (t !== ie || 1 === a.length && (0 < ge ? Ee : Ge) === a[0]) && (je = a.join(",").length + 2), 0 < je) {
          if (f = 0 === ge && t !== te ? function (e) {
            for (var a, r, s = 0, t = e.length, i = Array(t); s < t; ++s) {
              for (var f = e[s].split(l), n = "", o = 0, h = 0, u = 0, d = 0, b = f.length; o < b; ++o) {
                if (!(0 === (h = (r = f[o]).length) && 1 < b)) {
                  if (u = n.charCodeAt(n.length - 1), d = r.charCodeAt(0), a = "", 0 !== o) switch (u) {
                    case T:
                    case ae:
                    case _:
                    case ee:
                    case M:
                    case D:
                      break;

                    default:
                      a = " ";
                  }

                  switch (d) {
                    case P:
                      r = a + Ee;

                    case ae:
                    case _:
                    case ee:
                    case M:
                    case E:
                    case D:
                      break;

                    case G:
                      r = a + r + Ee;
                      break;

                    case V:
                      switch (2 * r.charCodeAt(1) + 3 * r.charCodeAt(2)) {
                        case 530:
                          if (0 < Ce) {
                            r = a + r.substring(8, h - 1);
                            break;
                          }

                        default:
                          (o < 1 || f[o - 1].length < 1) && (r = a + Ee + r);
                      }

                      break;

                    case U:
                      a = "";

                    default:
                      r = 1 < h && 0 < r.indexOf(":") ? a + r.replace(v, "$1" + Ee + "$2") : a + r + Ee;
                  }

                  n += r;
                }
              }

              i[s] = n.replace(c, "").trim();
            }

            return i;
          }(a) : a, 0 < ye && void 0 !== (n = Pe(Fe, Ve, f, e, pe, be, je, t, i, t)) && 0 === (Ve = n).length) return Ye + Ve + Xe;

          if (Ve = f.join(",") + "{" + Ve + "}", Ae * ke != 0) {
            switch (2 !== Ae || Le(Ve, 2) || (ke = 0), ke) {
              case le:
                Ve = Ve.replace(k, ":" + S + "$1") + Ve;
                break;

              case ne:
                Ve = Ve.replace(p, "::" + N + "input-$1") + Ve.replace(p, "::" + S + "$1") + Ve.replace(p, ":" + F + "input-$1") + Ve;
            }

            ke = 0;
          }
        }

        return Ye + Ve + Xe;
      }

      function Ie(e, a, r) {
        var c = a.trim().split(o),
            s = c,
            t = c.length,
            i = e.length;

        switch (i) {
          case 0:
          case 1:
            for (var f = 0, n = 0 === i ? "" : e[0] + " "; f < t; ++f) {
              s[f] = Je(n, s[f], r, i).trim();
            }

            break;

          default:
            var l = f = 0;

            for (s = []; f < t; ++f) {
              for (var h = 0; h < i; ++h) {
                s[l++] = Je(e[h] + " ", c[f], r, i).trim();
              }
            }

        }

        return s;
      }

      function Je(e, a, r, c) {
        var s = a,
            t = s.charCodeAt(0);

        switch (t < 33 && (t = (s = s.trim()).charCodeAt(0)), t) {
          case P:
            switch (ge + c) {
              case 0:
              case 1:
                if (0 === e.trim().length) break;

              default:
                return s.replace(h, "$1" + e.trim());
            }

            break;

          case V:
            switch (s.charCodeAt(1)) {
              case 103:
                if (0 < Ce && 0 < ge) return s.replace(u, "$1").replace(h, "$1" + Ge);
                break;

              default:
                return e.trim() + s.replace(h, "$1" + e.trim());
            }

          default:
            if (0 < r * ge && 0 < s.indexOf("\f")) return s.replace(h, (e.charCodeAt(0) === V ? "" : "$1") + e.trim());
        }

        return e + s;
      }

      function Ke(e, a, r, c) {
        var l,
            o = 0,
            h = e + ";",
            u = 2 * a + 3 * r + 4 * c;
        if (944 === u) return function (e) {
          var a = e.length,
              r = e.indexOf(":", 9) + 1,
              c = e.substring(0, r).trim(),
              s = e.substring(r, a - 1).trim();

          switch (e.charCodeAt(9) * Be) {
            case 0:
              break;

            case Q:
              if (110 !== e.charCodeAt(10)) break;

            default:
              for (var t = s.split((s = "", f)), i = 0, r = 0, a = t.length; i < a; r = 0, ++i) {
                for (var l = t[i], o = l.split(n); l = o[r];) {
                  var h = l.charCodeAt(0);
                  if (1 === Be && (L < h && h < 90 || 96 < h && h < 123 || h === R || h === Q && l.charCodeAt(1) !== Q)) switch (isNaN(parseFloat(l)) + (-1 !== l.indexOf("("))) {
                    case 1:
                      switch (l) {
                        case "infinite":
                        case "alternate":
                        case "backwards":
                        case "running":
                        case "normal":
                        case "forwards":
                        case "both":
                        case "none":
                        case "linear":
                        case "ease":
                        case "ease-in":
                        case "ease-out":
                        case "ease-in-out":
                        case "paused":
                        case "reverse":
                        case "alternate-reverse":
                        case "inherit":
                        case "initial":
                        case "unset":
                        case "step-start":
                        case "step-end":
                          break;

                        default:
                          l += De;
                      }

                  }
                  o[r++] = l;
                }

                s += (0 === i ? "" : ",") + o.join(" ");
              }

          }

          return s = c + s + ";", 1 === Ae || 2 === Ae && Le(s, 1) ? N + s + s : s;
        }(h);
        if (0 === Ae || 2 === Ae && !Le(h, 1)) return h;

        switch (u) {
          case 1015:
            return 97 === h.charCodeAt(10) ? N + h + h : h;

          case 951:
            return 116 === h.charCodeAt(3) ? N + h + h : h;

          case 963:
            return 110 === h.charCodeAt(5) ? N + h + h : h;

          case 1009:
            if (100 !== h.charCodeAt(4)) break;

          case 969:
          case 942:
            return N + h + h;

          case 978:
            return N + h + S + h + h;

          case 1019:
          case 983:
            return N + h + S + h + F + h + h;

          case 883:
            return h.charCodeAt(8) === Q ? N + h + h : 0 < h.indexOf("image-set(", 11) ? h.replace(z, "$1" + N + "$2") + h : h;

          case 932:
            if (h.charCodeAt(4) === Q) switch (h.charCodeAt(5)) {
              case 103:
                return N + "box-" + h.replace("-grow", "") + N + h + F + h.replace("grow", "positive") + h;

              case 115:
                return N + h + F + h.replace("shrink", "negative") + h;

              case 98:
                return N + h + F + h.replace("basis", "preferred-size") + h;
            }
            return N + h + F + h + h;

          case 964:
            return N + h + F + "flex-" + h + h;

          case 1023:
            if (99 !== h.charCodeAt(8)) break;
            return l = h.substring(h.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), N + "box-pack" + l + N + h + F + "flex-pack" + l + h;

          case 1005:
            return t.test(h) ? h.replace(s, ":" + N) + h.replace(s, ":" + S) + h : h;

          case 1e3:
            switch (o = (l = h.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(o)) {
              case 226:
                l = h.replace(m, "tb");
                break;

              case 232:
                l = h.replace(m, "tb-rl");
                break;

              case 220:
                l = h.replace(m, "lr");
                break;

              default:
                return h;
            }

            return N + h + F + l + h;

          case 1017:
            if (-1 === h.indexOf("sticky", 9)) return h;

          case 975:
            switch (o = (h = e).length - 10, u = (l = (33 === h.charCodeAt(o) ? h.substring(0, o) : h).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))) {
              case 203:
                if (l.charCodeAt(8) < 111) break;

              case 115:
                h = h.replace(l, N + l) + ";" + h;
                break;

              case 207:
              case 102:
                h = h.replace(l, N + (102 < u ? "inline-" : "") + "box") + ";" + h.replace(l, N + l) + ";" + h.replace(l, F + l + "box") + ";" + h;
            }

            return h + ";";

          case 938:
            if (h.charCodeAt(5) === Q) switch (h.charCodeAt(6)) {
              case 105:
                return l = h.replace("-items", ""), N + h + N + "box-" + l + F + "flex-" + l + h;

              case 115:
                return N + h + F + "flex-item-" + h.replace(y, "") + h;

              default:
                return N + h + F + "flex-line-pack" + h.replace("align-content", "").replace(y, "") + h;
            }
            break;

          case 973:
          case 989:
            if (h.charCodeAt(3) !== Q || 122 === h.charCodeAt(4)) break;

          case 931:
          case 953:
            if (!0 === j.test(e)) return 115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? Ke(e.replace("stretch", "fill-available"), a, r, c).replace(":fill-available", ":stretch") : h.replace(l, N + l) + h.replace(l, S + l.replace("fill-", "")) + h;
            break;

          case 962:
            if (h = N + h + (102 === h.charCodeAt(5) ? F + h : "") + h, r + c === 211 && 105 === h.charCodeAt(13) && 0 < h.indexOf("transform", 10)) return h.substring(0, h.indexOf(";", 27) + 1).replace(i, "$1" + N + "$2") + h;
        }

        return h;
      }

      function Le(e, a) {
        var r = e.indexOf(1 === a ? ":" : "{"),
            c = e.substring(0, 3 !== a ? r : 10),
            s = e.substring(r + 1, e.length - 1);
        return Oe(2 !== a ? c : c.replace(O, "$1"), s, a);
      }

      function Me(e, a) {
        var r = Ke(a, a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2));
        return r !== a + ";" ? r.replace($, " or ($1)").substring(4) : "(" + a + ")";
      }

      function Pe(e, a, r, c, s, t, i, f, n, l) {
        for (var o, h = 0, u = a; h < ye; ++h) {
          switch (o = $e[h].call(Te, e, u, r, c, s, t, i, f, n, l)) {
            case void 0:
            case !1:
            case !0:
            case null:
              break;

            default:
              u = o;
          }
        }

        if (u !== a) return u;
      }

      function Qe(e, a, r, c) {
        for (var s = a + 1; s < r; ++s) {
          switch (c.charCodeAt(s)) {
            case Z:
              if (e === T && c.charCodeAt(s - 1) === T && a + 2 !== s) return s + 1;
              break;

            case I:
              if (e === Z) return s + 1;
          }
        }

        return s;
      }

      function Re(e) {
        for (var a in e) {
          var r = e[a];

          switch (a) {
            case "keyframe":
              Be = 0 | r;
              break;

            case "global":
              Ce = 0 | r;
              break;

            case "cascade":
              ge = 0 | r;
              break;

            case "compress":
              we = 0 | r;
              break;

            case "semicolon":
              ve = 0 | r;
              break;

            case "preserve":
              me = 0 | r;
              break;

            case "prefix":
              Oe = null, r ? "function" != typeof r ? Ae = 1 : (Ae = 2, Oe = r) : Ae = 0;
          }
        }

        return Re;
      }

      function Te(a, r) {
        if (void 0 !== this && this.constructor === Te) return e(a);
        var s = a,
            t = s.charCodeAt(0);
        t < 33 && (t = (s = s.trim()).charCodeAt(0)), 0 < Be && (De = s.replace(d, t === G ? "" : "-")), (t = 1) === ge ? Ge = s : Ee = s;
        var i,
            f = [Ge];
        0 < ye && void 0 !== (i = Pe(ze, r, f, f, pe, be, 0, 0, 0, 0)) && "string" == typeof i && (r = i);
        var n = He(xe, f, r, 0, 0);
        return 0 < ye && void 0 !== (i = Pe(je, n, f, f, pe, be, n.length, 0, 0, 0)) && "string" != typeof (n = i) && (t = 0), Ee = Ge = De = "", be = pe = 1, we * t == (ke = 0) ? n : n.replace(c, "").replace(g, "").replace(A, "$1").replace(C, "$1").replace(w, " ");
      }

      return Te.use = function e(a) {
        switch (a) {
          case void 0:
          case null:
            ye = $e.length = 0;
            break;

          default:
            if ("function" == typeof a) $e[ye++] = a;else if ("object" == typeof a) for (var r = 0, c = a.length; r < c; ++r) {
              e(a[r]);
            } else qe = 0 | !!a;
        }

        return e;
      }, Te.set = Re, void 0 !== a && Re(a), Te;
    }(null);
  }, function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = __webpack_require__(22);
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    function areInputsEqual(newInputs, lastInputs) {
      if (newInputs.length !== lastInputs.length) return !1;

      for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) return !1;
      }

      return !0;
    }

    __webpack_exports__.a = function (resultFn, isEqual) {
      var lastThis;
      void 0 === isEqual && (isEqual = areInputsEqual);
      var lastResult,
          lastArgs = [],
          calledOnce = !1;
      return function () {
        for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
          newArgs[_key] = arguments[_key];
        }

        return calledOnce && lastThis === this && isEqual(newArgs, lastArgs) || (lastResult = resultFn.apply(this, newArgs), calledOnce = !0, lastThis = this, lastArgs = newArgs), lastResult;
      };
    };
  }, function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    }), function (ColorModel) {
      ColorModel[ColorModel.Depth = 0] = "Depth", ColorModel[ColorModel.Value = 1] = "Value", ColorModel[ColorModel.NumberOfChildren = 2] = "NumberOfChildren";
    }(exports.ColorModel || (exports.ColorModel = {}));
  }, function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var Utils = function () {
      function Utils() {}

      return Utils.getDepth = function (obj) {
        var _this = this,
            depth = 0;

        return obj.children && obj.children.forEach(function (d) {
          var tmpDepth = _this.getDepth(d);

          depth < tmpDepth && (depth = tmpDepth);
        }), 1 + depth;
      }, Utils.getRGBColor = function (color) {
        if ("white" === color || "papayawhip" === color) return {
          r: 255,
          g: 255,
          b: 255
        };
        if ("black" === color) return {
          r: 0,
          g: 0,
          b: 0
        };
        var ret = color.replace(/[^\d,]/g, "").split(",");
        return ret && 3 === ret.length ? {
          r: parseInt(ret[0], 10),
          g: parseInt(ret[1], 10),
          b: parseInt(ret[2], 10)
        } : void 0;
      }, Utils.getHighContrastColor = function (r, g, b) {
        for (var c = [r / 255, g / 255, b / 255], i = 0; i < c.length; ++i) {
          c[i] <= .03928 ? c[i] = c[i] / 12.92 : c[i] = Math.pow((c[i] + .055) / 1.055, 2.4);
        }

        return .179 < .2126 * c[0] + .7152 * c[1] + .0722 * c[2] ? "black" : "white";
      }, Utils.getHighContrastColorFromString = function (backgroundColor) {
        var rgbColor = Utils.getRGBColor(backgroundColor);
        if (rgbColor) return Utils.getHighContrastColor(rgbColor.r, rgbColor.g, rgbColor.b);
      }, Utils;
    }();

    exports.Utils = Utils;
  }, function (module, exports, __webpack_require__) {
    module.exports = function () {
      "use strict";

      return function (insertRule) {
        function toSheet(block) {
          if (block) try {
            insertRule(block + "}");
          } catch (e) {}
        }

        return function (context, content, selectors, parents, line, column, length, ns, depth, at) {
          switch (context) {
            case 1:
              if (0 === depth && 64 === content.charCodeAt(0)) return insertRule(content + ";"), "";
              break;

            case 2:
              if (0 === ns) return content + "/*|*/";
              break;

            case 3:
              switch (ns) {
                case 102:
                case 112:
                  return insertRule(selectors[0] + content), "";

                default:
                  return content + (0 === at ? "/*|*/" : "");
              }

            case -2:
              content.split("/*|*/}").forEach(toSheet);
          }
        };
      };
    }();
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_exports__.a = {
      animationIterationCount: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    };
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
        index = function (fn) {
      var cache = {};
      return function (arg) {
        return void 0 === cache[arg] && (cache[arg] = fn(arg)), cache[arg];
      };
    }(function (prop) {
      return reactPropsRegex.test(prop) || 111 === prop.charCodeAt(0) && 110 === prop.charCodeAt(1) && prop.charCodeAt(2) < 91;
    });

    __webpack_exports__.a = index;
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    function getType(payload) {
      return Object.prototype.toString.call(payload).slice(8, -1);
    }

    function isPlainObject(payload) {
      return "Object" === getType(payload) && payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
    }

    function isArray(payload) {
      return "Array" === getType(payload);
    }

    __webpack_exports__.a = function (origin) {
      for (var newComers = [], _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
      }

      var extensions = null,
          base = origin;
      return isPlainObject(origin) && origin.extensions && 1 === Object.keys(origin).length && (base = {}, extensions = origin.extensions), newComers.reduce(function (result, newComer) {
        return function mergeRecursively(origin, newComer, extensions) {
          if (!isPlainObject(newComer)) return extensions && isArray(extensions) && extensions.forEach(function (extend) {
            newComer = extend(origin, newComer);
          }), newComer;
          var newObject = isPlainObject(origin) ? Object.keys(origin).reduce(function (carry, key) {
            var targetVal = origin[key];
            return Object.keys(newComer).includes(key) || (carry[key] = targetVal), carry;
          }, {}) : {};
          return Object.keys(newComer).reduce(function (carry, key) {
            var newVal = newComer[key],
                targetVal = isPlainObject(origin) ? origin[key] : void 0;
            return extensions && isArray(extensions) && extensions.forEach(function (extend) {
              newVal = extend(targetVal, newVal);
            }), void 0 === targetVal ? carry[key] = newVal : isPlainObject(newVal) ? carry[key] = mergeRecursively(targetVal, newVal, extensions) : carry[key] = newVal, carry;
          }, newObject);
        }(result, newComer, extensions);
      }, base);
    };
  }, function (module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var ITreeMapProps_1 = __webpack_require__(8);

    exports.ColorModel = ITreeMapProps_1.ColorModel;

    var TreeMap_1 = __webpack_require__(15);

    exports.default = TreeMap_1.default;
  }, function (module, exports, __webpack_require__) {
    "use strict";

    var _extendStatics,
        __extends = this && this.__extends || (_extendStatics = function extendStatics(d, b) {
      return (_extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          b.hasOwnProperty(p) && (d[p] = b[p]);
        }
      })(d, b);
    }, function (d, b) {
      function __() {
        this.constructor = d;
      }

      _extendStatics(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
    }),
        __assign = this && this.__assign || function () {
      return (__assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          for (var p in s = arguments[i]) {
            Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var React = __webpack_require__(1),
        NodeContainer_1 = __webpack_require__(16),
        Utils_1 = __webpack_require__(9),
        d3_format_1 = __webpack_require__(4),
        d3_hierarchy_1 = __webpack_require__(29),
        d3_scale_1 = __webpack_require__(27),
        d3_array_1 = __webpack_require__(2),
        chromatic = __webpack_require__(28),
        d3_interpolate_1 = __webpack_require__(3),
        Breadcrumb_1 = __webpack_require__(19),
        styles = __webpack_require__(26),
        ITreeMapProps_1 = __webpack_require__(8),
        TreeMap = function (_super) {
      function TreeMap(props, context) {
        var _this = _super.call(this, props, context) || this;

        return _this._onBreadcrumbItemClicked = function (ev, item) {
          _this._zoomTo(item.key);
        }, _this._onNodeClick = function (ev) {
          _this._zoomTo(ev.currentTarget.id);
        }, _this._createD3TreeMap(_this.props.width, _this.props.height, _this.props.data), _this.state = {
          height: _this.props.height,
          width: _this.props.width,
          data: _this.props.data,
          xScaleFactor: 1,
          yScaleFactor: 1,
          xScaleFunction: d3_scale_1.scaleLinear().range([0, _this.props.width]),
          yScaleFunction: d3_scale_1.scaleLinear().range([0, _this.props.height]),
          zoomEnabled: !1,
          breadCrumbItems: [{
            text: _this.props.data.name,
            key: 0,
            onClick: _this._onBreadcrumbItemClicked
          }],
          selectedId: 0,
          scopedNodes: _this._nodes,
          selectedNode: _this._treemap(_this._rootData),
          totalNodes: _this._nodes.length,
          selectedNodeTotalNodes: _this._nodes.length
        }, _this;
      }

      return __extends(TreeMap, _super), TreeMap.prototype.componentWillReceiveProps = function (nextProps) {
        nextProps.height === this.props.height && nextProps.width === this.props.width || this.setState({
          width: nextProps.width,
          height: nextProps.height,
          xScaleFunction: d3_scale_1.scaleLinear().range([0, nextProps.width]),
          yScaleFunction: d3_scale_1.scaleLinear().range([0, nextProps.height])
        }), this._createD3TreeMap(nextProps.width, nextProps.height, nextProps.data), this.setState({
          data: nextProps.data,
          width: nextProps.width,
          height: nextProps.height,
          xScaleFactor: 1,
          yScaleFactor: 1,
          xScaleFunction: d3_scale_1.scaleLinear().range([0, nextProps.width]),
          yScaleFunction: d3_scale_1.scaleLinear().range([0, nextProps.height]),
          zoomEnabled: !1,
          breadCrumbItems: [{
            text: nextProps.data.name,
            key: 0,
            onClick: this._onBreadcrumbItemClicked
          }],
          selectedId: 0,
          scopedNodes: this._nodes,
          selectedNode: this._treemap(this._rootData),
          totalNodes: this._nodes.length,
          selectedNodeTotalNodes: this._nodes.length
        });
      }, TreeMap.prototype.render = function () {
        var _this = this,
            _a = this.state,
            width = _a.width,
            height = _a.height,
            breadCrumbItems = _a.breadCrumbItems,
            selectedNode = _a.selectedNode,
            totalNodes = _a.totalNodes,
            data = _a.data;

        this._createD3TreeMap(width, height, data);

        var reactNodes = [],
            iterateAllChildren = function iterateAllChildren(mainNode, level) {
          reactNodes = reactNodes.concat(_this._getNode(mainNode)), level < 1 && mainNode.hasOwnProperty("children") && 0 < mainNode.children.length && mainNode.children.forEach(function (element) {
            iterateAllChildren(element, level + 1);
          });
        };

        iterateAllChildren(selectedNode, 0);

        var highestBgColor = this._nodesbgColorFunction(totalNodes),
            lowestBgColor = this._nodesbgColorFunction(1);

        return React.createElement("div", null, !1 === this.props.disableBreadcrumb ? React.createElement(Breadcrumb_1.BreadcrumbStyled, {
          bgColor: lowestBgColor,
          hoverBgColor: highestBgColor,
          currentBgColor: highestBgColor,
          items: breadCrumbItems
        }) : null, React.createElement("svg", {
          className: styles.mainSvg,
          height: height,
          width: width
        }, reactNodes));
      }, TreeMap.prototype._createD3TreeMap = function (width, height, data) {
        this._treemap = d3_hierarchy_1.treemap().size([width, height]).paddingOuter(3).paddingTop(19).paddingInner(1).round(!0), this._rootData = d3_hierarchy_1.hierarchy(data).sum(function (s) {
          return s.value;
        }).sort(function (a, b) {
          return b.height - a.height || b.value - a.value;
        });
        var d,
            numberItemId = 0;

        switch (this._nodes = this._treemap(this._rootData).each(function (item) {
          item.customId = numberItemId++;
        }).descendants(), this._valueFormatFunction = d3_format_1.format(this.props.valueFormat), this.props.colorModel) {
          case ITreeMapProps_1.ColorModel.Depth:
            d = [0, Utils_1.Utils.getDepth(data) - 1];
            break;

          case ITreeMapProps_1.ColorModel.Value:
            d = d3_array_1.extent(this._nodes, function (n) {
              if (null !== n.parent) return n.value;
            });
            break;

          case ITreeMapProps_1.ColorModel.NumberOfChildren:
            d = d3_array_1.extent(this._nodes, function (n) {
              return null !== n.parent ? n.descendants().length : 1;
            });
        }

        this.props.hasOwnProperty("bgColorRangeLow") && this.props.hasOwnProperty("bgColorRangeHigh") ? this._nodesbgColorFunction = d3_scale_1.scaleLinear().domain(d).interpolate(d3_interpolate_1.interpolateHcl).range([this.props.bgColorRangeLow, this.props.bgColorRangeHigh]) : this._nodesbgColorFunction = d3_scale_1.scaleSequential(chromatic.interpolateGreens).domain(d);
      }, TreeMap.prototype._getNode = function (node) {
        var backgroundColor,
            _a = this.props,
            treemapId = (_a.valueFormat, _a.id),
            _b = this.state,
            width = _b.width,
            height = _b.height,
            totalNodes = _b.totalNodes,
            name = node.data.name,
            id = node.customId,
            url = node.data.link,
            hasChildren = !!(node.children && 0 < node.children.length),
            valueWithFormat = this._valueFormatFunction(node.value),
            nodeTotalNodes = node.descendants().length - 1;

        switch (this.props.colorModel) {
          case ITreeMapProps_1.ColorModel.Depth:
            backgroundColor = this._nodesbgColorFunction(node.depth), null === node.parent && (backgroundColor = this._nodesbgColorFunction(0));
            break;

          case ITreeMapProps_1.ColorModel.Value:
            backgroundColor = this._nodesbgColorFunction(node.value), null === node.parent && (backgroundColor = this._nodesbgColorFunction(1));
            break;

          case ITreeMapProps_1.ColorModel.NumberOfChildren:
            backgroundColor = this._nodesbgColorFunction(nodeTotalNodes), null === node.parent && (backgroundColor = this._nodesbgColorFunction(1));
        }

        var colorText = Utils_1.Utils.getHighContrastColorFromString(backgroundColor);
        return React.createElement(NodeContainer_1.default, __assign({}, node, {
          id: id,
          treemapId: treemapId,
          xScaleFactor: this.state.xScaleFactor,
          yScaleFactor: this.state.yScaleFactor,
          xScaleFunction: this.state.xScaleFunction,
          yScaleFunction: this.state.yScaleFunction,
          zoomEnabled: this.state.zoomEnabled,
          key: id,
          url: url,
          bgColor: backgroundColor,
          label: name,
          name: name,
          fontSize: 14,
          textColor: colorText,
          className: "node",
          hasChildren: hasChildren,
          onClick: this._onNodeClick,
          valueWithFormat: valueWithFormat,
          globalHeight: height,
          globalWidth: width,
          nodeTotalNodes: nodeTotalNodes,
          globalTotalNodes: totalNodes,
          isSelectedNode: id === this.state.selectedId,
          valueUnit: this.props.valueUnit,
          hideNumberOfChildren: this.props.hideNumberOfChildren,
          hideValue: this.props.hideValue
        }));
      }, TreeMap.prototype._zoomTo = function (nodeId) {
        var _this = this,
            _a = this.state,
            selectedId = _a.selectedId,
            xScaleFunction = _a.xScaleFunction,
            yScaleFunction = _a.yScaleFunction,
            width = _a.width,
            height = _a.height;

        if (selectedId !== nodeId) {
          var currentNodeArray = this._nodes.filter(function (item) {
            return item.customId.toString() === nodeId.toString();
          });

          if (0 < currentNodeArray.length) {
            var currentNode = currentNodeArray[0],
                scopedNodes = currentNode.descendants(),
                x = currentNode.x0,
                y = currentNode.y0,
                dx = currentNode.x1 - currentNode.x0,
                dy = currentNode.y1 - currentNode.y0,
                xScaleFactor = width / dx,
                yScaleFactor = height / dy,
                breadCrumbItems = this._treemap(this._rootData).path(currentNode).map(function (n) {
              return {
                text: n.data.name,
                key: n.customId,
                onClick: _this._onBreadcrumbItemClicked
              };
            });

            this.setState({
              xScaleFactor: xScaleFactor,
              yScaleFactor: yScaleFactor,
              xScaleFunction: xScaleFunction.domain([x, x + dx]),
              yScaleFunction: yScaleFunction.domain([y, y + dy]),
              zoomEnabled: null !== currentNode.parent,
              selectedId: nodeId,
              selectedNode: currentNode,
              scopedNodes: scopedNodes,
              selectedNodeTotalNodes: scopedNodes.length,
              breadCrumbItems: breadCrumbItems
            });
          } else console.warn("No node found for " + nodeId);
        }
      }, TreeMap.defaultProps = {
        id: "myTreeMap",
        data: null,
        height: 600,
        width: 600,
        valueFormat: ",d",
        valueUnit: "MB",
        disableBreadcrumb: !1,
        colorModel: ITreeMapProps_1.ColorModel.NumberOfChildren
      }, TreeMap;
    }(React.Component);

    exports.default = TreeMap;
  }, function (module, exports, __webpack_require__) {
    "use strict";

    var _extendStatics2,
        __extends = this && this.__extends || (_extendStatics2 = function extendStatics(d, b) {
      return (_extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          b.hasOwnProperty(p) && (d[p] = b[p]);
        }
      })(d, b);
    }, function (d, b) {
      function __() {
        this.constructor = d;
      }

      _extendStatics2(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
    }),
        __assign = this && this.__assign || function () {
      return (__assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          for (var p in s = arguments[i]) {
            Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var React = __webpack_require__(1),
        Node_1 = __webpack_require__(17),
        NodeContainer = function (_super) {
      function NodeContainer(props, context) {
        return _super.call(this, props, context) || this;
      }

      return __extends(NodeContainer, _super), NodeContainer.prototype.render = function () {
        return this._getNestedFolderTypeNode();
      }, NodeContainer.prototype._getNestedFolderTypeNode = function () {
        var _a = this.props,
            x0 = _a.x0,
            x1 = _a.x1,
            y0 = _a.y0,
            y1 = _a.y1,
            xScaleFactor = (_a.bgColor, _a.name, _a.id, _a.label, _a.textColor, _a.valueWithFormat, _a.className, _a.fontSize, _a.hasChildren, _a.xScaleFactor),
            yScaleFactor = _a.yScaleFactor,
            xScaleFunction = _a.xScaleFunction,
            yScaleFunction = _a.yScaleFunction,
            zoomEnabled = _a.zoomEnabled,
            url = (_a.onClick, _a.isSelectedNode, _a.nodeTotalNodes, _a.url),
            treemapId = _a.treemapId,
            xTranslated = !0 === zoomEnabled ? xScaleFunction(x0) : x0,
            yTranslated = !0 === zoomEnabled ? yScaleFunction(y0) : y0,
            width = xScaleFactor * (x1 - x0),
            height = yScaleFactor * (y1 - y0);
        return React.createElement(Node_1.default, __assign({}, this.props, {
          xTranslated: xTranslated,
          yTranslated: yTranslated,
          height: height,
          width: width,
          url: url,
          treemapId: treemapId
        }));
      }, NodeContainer;
    }(React.Component);

    exports.default = NodeContainer;
  }, function (module, exports, __webpack_require__) {
    "use strict";

    var _extendStatics3,
        __extends = this && this.__extends || (_extendStatics3 = function extendStatics(d, b) {
      return (_extendStatics3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          b.hasOwnProperty(p) && (d[p] = b[p]);
        }
      })(d, b);
    }, function (d, b) {
      function __() {
        this.constructor = d;
      }

      _extendStatics3(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
    });

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var React = __webpack_require__(1),
        styles = __webpack_require__(18),
        Node = function (_super) {
      function Node() {
        return null !== _super && _super.apply(this, arguments) || this;
      }

      return __extends(Node, _super), Node.prototype.render = function () {
        return this._getNestedFolderTypeNode();
      }, Node.prototype._getNestedFolderTypeNode = function () {
        var _a = this.props,
            bgColor = _a.bgColor,
            onClick = _a.onClick,
            id = (_a.name, _a.id),
            label = _a.label,
            valueWithFormat = _a.valueWithFormat,
            valueUnit = _a.valueUnit,
            hasChildren = _a.hasChildren,
            xTranslated = _a.xTranslated,
            yTranslated = _a.yTranslated,
            isSelectedNode = _a.isSelectedNode,
            width = _a.width,
            height = _a.height,
            fontSize = _a.fontSize,
            nodeTotalNodes = (_a.textColor, _a.nodeTotalNodes),
            globalTotalNodes = _a.globalTotalNodes,
            url = _a.url,
            hideNumberOfChildren = _a.hideNumberOfChildren,
            treemapId = _a.treemapId,
            cursor = !0 === hasChildren && !1 === isSelectedNode ? "pointer" : "auto",
            itemsWidth = this._getNumberItemsWidthByNumberOfChars(fontSize, nodeTotalNodes.toString().length),
            clipWidth = itemsWidth < width ? width - itemsWidth : width;

        return React.createElement("g", {
          transform: "translate(" + xTranslated + "," + yTranslated + ")",
          className: styles.node + " " + (nodeTotalNodes === globalTotalNodes ? styles.rootNode : null),
          id: id.toString(),
          onClick: hasChildren ? onClick : null,
          style: {
            cursor: cursor
          }
        }, React.createElement("rect", {
          id: "rect-" + id,
          width: width,
          height: height,
          fill: bgColor
        }), React.createElement("clipPath", {
          id: "clip-".concat(treemapId, "-", id.toString())
        }, React.createElement("rect", {
          width: Math.max(0, clipWidth - 5),
          height: height
        })), React.createElement("a", {
          href: url,
          target: "_blank"
        }, React.createElement("text", {
          clipPath: "url(#clip-".concat(treemapId, "-", id.toString(), ")")
        }, this._getLabelNewLine())), !hideNumberOfChildren && this._getNumberOfItemsRect(), React.createElement("title", null, label + "\n" + valueWithFormat + " " + valueUnit + "\n" + nodeTotalNodes + "/" + globalTotalNodes));
      }, Node.prototype._getNumberItemsHeightByFontSize = function (fontSize) {
        return fontSize;
      }, Node.prototype._getNumberItemsWidthByNumberOfChars = function (fontSize, numberOfChars) {
        return fontSize / 2 * numberOfChars + 5;
      }, Node.prototype._getNumberOfItemsRect = function () {
        var _a = this.props,
            bgColor = _a.bgColor,
            name = _a.name,
            width = _a.width,
            height = _a.height,
            fontSize = _a.fontSize,
            textColor = _a.textColor,
            nodeTotalNodes = _a.nodeTotalNodes,
            itemsWidth = this._getNumberItemsWidthByNumberOfChars(fontSize, nodeTotalNodes.toString().length),
            itemsHeight = this._getNumberItemsHeightByFontSize(fontSize);

        if (itemsWidth < width && itemsHeight < height) return React.createElement("g", null, React.createElement("rect", {
          id: "rectNumberItems-" + name,
          x: width - itemsWidth - 2,
          y: 2,
          width: itemsWidth,
          height: itemsHeight,
          fill: bgColor,
          fillOpacity: .9,
          stroke: textColor
        }), React.createElement("text", {
          fontSize: fontSize,
          fill: textColor,
          x: width - itemsWidth,
          y: fontSize
        }, nodeTotalNodes));
      }, Node.prototype._getLabelNewLine = function () {
        var _a = this.props,
            label = _a.label,
            textColor = _a.textColor,
            fontSize = _a.fontSize,
            valueWithFormat = _a.valueWithFormat,
            valueUnit = _a.valueUnit,
            hasChildren = _a.hasChildren,
            hideValue = (_a.nodeTotalNodes, _a.globalTotalNodes, _a.hideValue);

        if (!0 === hasChildren) {
          var fullLabel = hideValue ? label : label + " (" + valueWithFormat + " " + valueUnit + ")";
          return React.createElement("tspan", {
            fontSize: fontSize,
            fill: textColor,
            dx: 4,
            dy: fontSize
          }, fullLabel);
        }

        if (label) return (fullLabel = hideValue ? label.split(/(?=[A-Z][^A-Z])/g) : label.split(/(?=[A-Z][^A-Z])/g).concat("(" + valueWithFormat + " " + valueUnit + ")")).map(function (item, index) {
          return React.createElement("tspan", {
            fontSize: fontSize,
            fill: textColor,
            key: index,
            x: 4,
            dy: fontSize
          }, item);
        });
      }, Node;
    }(React.Component);

    exports.default = Node;
  }, function (module, exports, __webpack_require__) {
    module.exports = {
      node: "Node.module_node_2sWtP",
      rootNode: "Node.module_rootNode_3yZfJ"
    };
  }, function (module, exports, __webpack_require__) {
    "use strict";

    var _extendStatics4,
        __extends = this && this.__extends || (_extendStatics4 = function extendStatics(d, b) {
      return (_extendStatics4 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          b.hasOwnProperty(p) && (d[p] = b[p]);
        }
      })(d, b);
    }, function (d, b) {
      function __() {
        this.constructor = d;
      }

      _extendStatics4(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
    }),
        __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
      return Object.defineProperty ? Object.defineProperty(cooked, "raw", {
        value: raw
      }) : cooked.raw = raw, cooked;
    };

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var templateObject_1,
        React = __webpack_require__(1),
        Utils_1 = __webpack_require__(9),
        styled = __webpack_require__(20),
        Breadcrumb = function (_super) {
      function Breadcrumb() {
        return null !== _super && _super.apply(this, arguments) || this;
      }

      return __extends(Breadcrumb, _super), Breadcrumb.prototype.render = function () {
        return React.createElement("div", {
          className: this.props.className
        }, this._renderItems());
      }, Breadcrumb.prototype._renderItems = function () {
        var _this = this,
            items = this.props.items;

        if (items && items.hasOwnProperty("length") && 0 < items.length) return items.map(function (item) {
          return React.createElement("a", {
            id: item.key,
            key: item.key,
            onClick: _this._onBreadcrumbClicked.bind(_this, item),
            href: item.href
          }, item.text);
        });
      }, Breadcrumb.prototype._onBreadcrumbClicked = function (item, ev) {
        item.onClick && item.onClick(ev, item);
      }, Breadcrumb;
    }(React.Component);

    exports.Breadcrumb = Breadcrumb, exports.BreadcrumbStyled = styled.default(Breadcrumb)(templateObject_1 = templateObject_1 || __makeTemplateObject(["\n    text-align: center;\n    display: block;\n    overflow: hidden;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif;\n\n    > a {\n        text-decoration: none;\n        outline: none;\n        display: block;\n        float: left;\n        font-size: 12px;\n        line-height: 36px;\n        color: black;\n        padding: 0 10px 0 30px;\n        position: relative;\n        cursor: pointer;\n        background-color: #ffffff;\n        background-color: ", ";\n    }\n\n    a:first-child {\n        padding-left: 16px;\n    }\n\n    a::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: -18px;\n        width: 36px;\n        height: 36px;\n        transform: scale(.707) rotate(45deg);\n        z-index: 1;\n        box-shadow: 2px -2px 0 2px rgb(206, 230, 140);\n        box-shadow: 1px -1px 0 0px ", ";\n        border-radius: 0 5px 0 50px;\n        background-color: #ffffff;\n        background-color: ", ";\n        color: rgb(206, 230, 140);\n        color: ", ";\n    }\n\n    a:hover, a:hover::after {\n        background-color: rgb(206, 230, 140);\n        background-color: ", ";\n        color: #ffffff;\n        color: ", ";\n    }\n\n    a:last-child {\n        padding-right: 20px;\n        background-color: rgb(206, 230, 140);\n        background-color: ", ";\n        color: #ffffff;\n        color: ", ";\n        cursor: auto;\n    }\n    a:last-child::after {\n        background-color: rgb(206, 230, 140);\n        background-color: ", ";\n        color: #ffffff;\n        color: ", ";\n    }\n"], ["\n    text-align: center;\n    display: block;\n    overflow: hidden;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif;\n\n    > a {\n        text-decoration: none;\n        outline: none;\n        display: block;\n        float: left;\n        font-size: 12px;\n        line-height: 36px;\n        color: black;\n        padding: 0 10px 0 30px;\n        position: relative;\n        cursor: pointer;\n        background-color: #ffffff;\n        background-color: ", ";\n    }\n\n    a:first-child {\n        padding-left: 16px;\n    }\n\n    a::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: -18px;\n        width: 36px;\n        height: 36px;\n        transform: scale(.707) rotate(45deg);\n        z-index: 1;\n        box-shadow: 2px -2px 0 2px rgb(206, 230, 140);\n        box-shadow: 1px -1px 0 0px ", ";\n        border-radius: 0 5px 0 50px;\n        background-color: #ffffff;\n        background-color: ", ";\n        color: rgb(206, 230, 140);\n        color: ", ";\n    }\n\n    a:hover, a:hover::after {\n        background-color: rgb(206, 230, 140);\n        background-color: ", ";\n        color: #ffffff;\n        color: ", ";\n    }\n\n    a:last-child {\n        padding-right: 20px;\n        background-color: rgb(206, 230, 140);\n        background-color: ", ";\n        color: #ffffff;\n        color: ", ";\n        cursor: auto;\n    }\n    a:last-child::after {\n        background-color: rgb(206, 230, 140);\n        background-color: ", ";\n        color: #ffffff;\n        color: ", ";\n    }\n"]), function (props) {
      return props.bgColor;
    }, function (props) {
      return props.currentBgColor;
    }, function (props) {
      return props.bgColor;
    }, function (props) {
      return Utils_1.Utils.getHighContrastColorFromString(props.bgColor);
    }, function (props) {
      return props.hoverBgColor;
    }, function (props) {
      return Utils_1.Utils.getHighContrastColorFromString(props.hoverBgColor);
    }, function (props) {
      return props.currentBgColor;
    }, function (props) {
      return Utils_1.Utils.getHighContrastColorFromString(props.currentBgColor);
    }, function (props) {
      return props.currentBgColor;
    }, function (props) {
      return Utils_1.Utils.getHighContrastColorFromString(props.currentBgColor);
    });
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), function (process) {
      __webpack_require__.d(__webpack_exports__, "createGlobalStyle", function () {
        return createGlobalStyle;
      }), __webpack_require__.d(__webpack_exports__, "css", function () {
        return css;
      }), __webpack_require__.d(__webpack_exports__, "isStyledComponent", function () {
        return isStyledComponent;
      }), __webpack_require__.d(__webpack_exports__, "keyframes", function () {
        return keyframes;
      }), __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function () {
        return ServerStyleSheet;
      }), __webpack_require__.d(__webpack_exports__, "StyleSheetConsumer", function () {
        return StyleSheetConsumer;
      }), __webpack_require__.d(__webpack_exports__, "StyleSheetContext", function () {
        return StyleSheetContext;
      }), __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function () {
        return StyleSheetManager;
      }), __webpack_require__.d(__webpack_exports__, "ThemeConsumer", function () {
        return ThemeConsumer;
      }), __webpack_require__.d(__webpack_exports__, "ThemeContext", function () {
        return ThemeContext;
      }), __webpack_require__.d(__webpack_exports__, "ThemeProvider", function () {
        return ThemeProvider;
      }), __webpack_require__.d(__webpack_exports__, "withTheme", function () {
        return withTheme;
      }), __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function () {
        return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
      });

      var stylis_stylis_min__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5),
          stylis_stylis_min__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(stylis_stylis_min__WEBPACK_IMPORTED_MODULE_0__),
          stylis_rule_sheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10),
          stylis_rule_sheet__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(stylis_rule_sheet__WEBPACK_IMPORTED_MODULE_1__),
          react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1),
          react__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__),
          _emotion_unitless__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11),
          react_is__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6),
          memoize_one__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7),
          _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_7__ = (__webpack_require__(23), __webpack_require__(12)),
          merge_anything__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13),
          interleave = function interleave(strings, interpolations) {
        for (var result = [strings[0]], i = 0, len = interpolations.length; i < len; i += 1) {
          result.push(interpolations[i], strings[i + 1]);
        }

        return result;
      },
          _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      },
          classCallCheck = function classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
      },
          createClass = function createClass(Constructor, protoProps, staticProps) {
        return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
      };

      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
          }
        }

        return target;
      },
          inherits = function inherits(subClass, superClass) {
        if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
      },
          objectWithoutProperties = function objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
        }

        return target;
      },
          possibleConstructorReturn = function possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !call || "object" != typeof call && "function" != typeof call ? self : call;
      },
          isPlainObject = function isPlainObject(x) {
        return "object" === (void 0 === x ? "undefined" : _typeof(x)) && x.constructor === Object;
      },
          EMPTY_ARRAY = Object.freeze([]),
          EMPTY_OBJECT = Object.freeze({});

      function isFunction(test) {
        return "function" == typeof test;
      }

      function getComponentName(target) {
        return target.displayName || target.name || "Component";
      }

      function isStyledComponent(target) {
        return target && "string" == typeof target.styledComponentId;
      }

      var SC_ATTR = void 0 !== process && (Object({
        NODE_ENV: "production"
      }).REACT_APP_SC_ATTR || Object({
        NODE_ENV: "production"
      }).SC_ATTR) || "data-styled",
          IS_BROWSER = "undefined" != typeof window && "HTMLElement" in window,
          DISABLE_SPEEDY = "boolean" == typeof SC_DISABLE_SPEEDY && SC_DISABLE_SPEEDY || void 0 !== process && (Object({
        NODE_ENV: "production"
      }).REACT_APP_SC_DISABLE_SPEEDY || Object({
        NODE_ENV: "production"
      }).SC_DISABLE_SPEEDY) || !1,
          STATIC_EXECUTION_CONTEXT = {};

      function extractComps(maybeCSS) {
        var css = "" + (maybeCSS || ""),
            existingComponents = [];
        return css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
          return existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
          }), match;
        }), existingComponents.map(function (_ref, i) {
          var componentId = _ref.componentId,
              matchIndex = _ref.matchIndex,
              nextComp = existingComponents[i + 1];
          return {
            componentId: componentId,
            cssFromDOM: nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex)
          };
        });
      }

      var StyledComponentsError = function (_Error) {
        function StyledComponentsError(code) {
          classCallCheck(this, StyledComponentsError);

          for (var _len = arguments.length, interpolations = Array(1 < _len ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            interpolations[_key - 1] = arguments[_key];
          }

          var _this = possibleConstructorReturn(this, _Error.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (0 < interpolations.length ? " Additional arguments: " + interpolations.join(", ") : "")));

          return possibleConstructorReturn(_this);
        }

        return inherits(StyledComponentsError, _Error), StyledComponentsError;
      }(Error),
          SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm,
          COMMENT_REGEX = /^\s*\/\/.*$/gm,
          stylisSplitter = new stylis_stylis_min__WEBPACK_IMPORTED_MODULE_0___default.a({
        global: !1,
        cascade: !0,
        keyframe: !1,
        prefix: !1,
        compress: !1,
        semicolon: !0
      }),
          stylis = new stylis_stylis_min__WEBPACK_IMPORTED_MODULE_0___default.a({
        global: !1,
        cascade: !0,
        keyframe: !1,
        prefix: !0,
        compress: !1,
        semicolon: !1
      }),
          parsingRules = [],
          returnRulesPlugin = function returnRulesPlugin(context) {
        if (-2 === context) {
          var parsedRules = parsingRules;
          return parsingRules = [], parsedRules;
        }
      },
          parseRulesPlugin = stylis_rule_sheet__WEBPACK_IMPORTED_MODULE_1___default()(function (rule) {
        parsingRules.push(rule);
      }),
          _componentId = void 0,
          _selector = void 0,
          _selectorRegexp = void 0,
          selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
        return 0 < offset && -1 !== string.slice(0, offset).indexOf(_selector) && string.slice(offset - _selector.length, offset) !== _selector ? "." + _componentId : match;
      };

      stylis.use([function (context, _, selectors) {
        2 === context && selectors.length && 0 < selectors[0].lastIndexOf(_selector) && (selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer));
      }, parseRulesPlugin, returnRulesPlugin]), stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

      function stringifyRules(rules, selector, prefix, argument_3) {
        var componentId = 3 < arguments.length && void 0 !== argument_3 ? argument_3 : "&",
            flatCSS = rules.join("").replace(COMMENT_REGEX, ""),
            cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS;
        return _componentId = componentId, _selector = selector, _selectorRegexp = new RegExp("\\" + _selector + "\\b", "g"), stylis(prefix || !selector ? "" : selector, cssStr);
      }

      function getNonce() {
        return __webpack_require__.nc;
      }

      function makeServerTag(namesArg, markersArg) {
        var names = void 0 === namesArg ? Object.create(null) : namesArg,
            markers = void 0 === markersArg ? Object.create(null) : markersArg,
            insertMarker = function insertMarker(id) {
          var prev = markers[id];
          return void 0 !== prev ? prev : markers[id] = [""];
        },
            css = function css() {
          var str = "";

          for (var id in markers) {
            var cssForId = markers[id][0];
            cssForId && (str += makeTextMarker(id) + cssForId);
          }

          return str;
        };

        return {
          clone: function clone() {
            var namesClone = function (names) {
              var clone = Object.create(null);

              for (var id in names) {
                clone[id] = _extends({}, names[id]);
              }

              return clone;
            }(names),
                markersClone = Object.create(null);

            for (var id in markers) {
              markersClone[id] = [markers[id][0]];
            }

            return makeServerTag(namesClone, markersClone);
          },
          css: css,
          getIds: getIdsFromMarkersFactory(markers),
          hasNameForId: hasNameForId(names),
          insertMarker: insertMarker,
          insertRules: function insertRules(id, cssRules, name) {
            insertMarker(id)[0] += cssRules.join(" "), addNameForId(names, id, name);
          },
          removeRules: function removeRules(id) {
            var marker = markers[id];
            void 0 !== marker && (marker[0] = "", resetIdNames(names, id));
          },
          sealed: !1,
          styleTag: null,
          toElement: wrapAsElement(css, names),
          toHTML: wrapAsHtmlTag(css, names)
        };
      }

      var addNameForId = function addNameForId(names, id, name) {
        name && ((names[id] || (names[id] = Object.create(null)))[name] = !0);
      },
          resetIdNames = function resetIdNames(names, id) {
        names[id] = Object.create(null);
      },
          hasNameForId = function hasNameForId(names) {
        return function (id, name) {
          return void 0 !== names[id] && names[id][name];
        };
      },
          stringifyNames = function stringifyNames(names) {
        var str = "";

        for (var id in names) {
          str += Object.keys(names[id]).join(" ") + " ";
        }

        return str.trim();
      },
          sheetForTag = function sheetForTag(tag) {
        if (tag.sheet) return tag.sheet;

        for (var size = document.styleSheets.length, i = 0; i < size; i += 1) {
          var sheet = document.styleSheets[i];
          if (sheet.ownerNode === tag) return sheet;
        }

        throw new StyledComponentsError(10);
      },
          safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
        if (!cssRule) return !1;
        var maxIndex = sheet.cssRules.length;

        try {
          sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
        } catch (err) {
          return !1;
        }

        return !0;
      },
          makeTextMarker = function makeTextMarker(id) {
        return "\n/* sc-component-id: " + id + " */\n";
      },
          addUpUntilIndex = function addUpUntilIndex(sizes, index) {
        for (var totalUpToIndex = 0, i = 0; i <= index; i += 1) {
          totalUpToIndex += sizes[i];
        }

        return totalUpToIndex;
      },
          wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
        return function (additionalAttrs) {
          var nonce = getNonce();
          return "<style " + [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', 'data-styled-version="4.3.1"', additionalAttrs].filter(Boolean).join(" ") + ">" + css() + "</style>";
        };
      },
          wrapAsElement = function wrapAsElement(css, names) {
        return function () {
          var _props,
              props = ((_props = {})[SC_ATTR] = stringifyNames(names), _props["data-styled-version"] = "4.3.1", _props),
              nonce = getNonce();

          return nonce && (props.nonce = nonce), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("style", _extends({}, props, {
            dangerouslySetInnerHTML: {
              __html: css()
            }
          }));
        };
      },
          getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
        return function () {
          return Object.keys(markers);
        };
      },
          makeTextNode = function makeTextNode(id) {
        return document.createTextNode(makeTextMarker(id));
      },
          makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
        if (!IS_BROWSER || forceServer) return makeServerTag();

        var el = function (target, tagEl, insertBefore) {
          var el = document.createElement("style");
          el.setAttribute(SC_ATTR, ""), el.setAttribute("data-styled-version", "4.3.1");
          var nonce = getNonce();
          if (nonce && el.setAttribute("nonce", nonce), el.appendChild(document.createTextNode("")), target && !tagEl) target.appendChild(el);else {
            if (!tagEl || !target || !tagEl.parentNode) throw new StyledComponentsError(6);
            tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
          }
          return el;
        }(target, tagEl, insertBefore);

        return DISABLE_SPEEDY ? function (el, getImportRuleTag) {
          var names = Object.create(null),
              markers = Object.create(null),
              extractImport = void 0 !== getImportRuleTag,
              usedImportRuleTag = !1,
              insertMarker = function insertMarker(id) {
            var prev = markers[id];
            return void 0 !== prev ? prev : (markers[id] = makeTextNode(id), el.appendChild(markers[id]), names[id] = Object.create(null), markers[id]);
          },
              css = function css() {
            var str = "";

            for (var id in markers) {
              str += markers[id].data;
            }

            return str;
          };

          return {
            clone: function clone() {
              throw new StyledComponentsError(5);
            },
            css: css,
            getIds: getIdsFromMarkersFactory(markers),
            hasNameForId: hasNameForId(names),
            insertMarker: insertMarker,
            insertRules: function insertRules(id, cssRules, name) {
              for (var marker = insertMarker(id), importRules = [], cssRulesSize = cssRules.length, i = 0; i < cssRulesSize; i += 1) {
                var rule = cssRules[i],
                    mayHaveImport = extractImport;
                if (mayHaveImport && -1 !== rule.indexOf("@import")) importRules.push(rule);else {
                  mayHaveImport = !1;
                  var separator = i === cssRulesSize - 1 ? "" : " ";
                  marker.appendData(rule + separator);
                }
              }

              addNameForId(names, id, name), extractImport && 0 < importRules.length && (usedImportRuleTag = !0, getImportRuleTag().insertRules(id + "-import", importRules));
            },
            removeRules: function removeRules(id) {
              var marker = markers[id];

              if (void 0 !== marker) {
                var newMarker = makeTextNode(id);
                el.replaceChild(newMarker, marker), markers[id] = newMarker, resetIdNames(names, id), extractImport && usedImportRuleTag && getImportRuleTag().removeRules(id + "-import");
              }
            },
            sealed: !1,
            styleTag: el,
            toElement: wrapAsElement(css, names),
            toHTML: wrapAsHtmlTag(css, names)
          };
        }(el, getImportRuleTag) : function (el, getImportRuleTag) {
          var names = Object.create(null),
              markers = Object.create(null),
              sizes = [],
              extractImport = void 0 !== getImportRuleTag,
              usedImportRuleTag = !1,
              insertMarker = function insertMarker(id) {
            var prev = markers[id];
            return void 0 !== prev ? prev : (markers[id] = sizes.length, sizes.push(0), resetIdNames(names, id), markers[id]);
          },
              css = function css() {
            var cssRules = sheetForTag(el).cssRules,
                str = "";

            for (var id in markers) {
              str += makeTextMarker(id);

              for (var marker = markers[id], end = addUpUntilIndex(sizes, marker), i = end - sizes[marker]; i < end; i += 1) {
                var rule = cssRules[i];
                void 0 !== rule && (str += rule.cssText);
              }
            }

            return str;
          };

          return {
            clone: function clone() {
              throw new StyledComponentsError(5);
            },
            css: css,
            getIds: getIdsFromMarkersFactory(markers),
            hasNameForId: hasNameForId(names),
            insertMarker: insertMarker,
            insertRules: function insertRules(id, cssRules, name) {
              for (var marker = insertMarker(id), sheet = sheetForTag(el), insertIndex = addUpUntilIndex(sizes, marker), injectedRules = 0, importRules = [], cssRulesSize = cssRules.length, i = 0; i < cssRulesSize; i += 1) {
                var cssRule = cssRules[i],
                    mayHaveImport = extractImport;
                mayHaveImport && -1 !== cssRule.indexOf("@import") ? importRules.push(cssRule) : safeInsertRule(sheet, cssRule, insertIndex + injectedRules) && (mayHaveImport = !1, injectedRules += 1);
              }

              extractImport && 0 < importRules.length && (usedImportRuleTag = !0, getImportRuleTag().insertRules(id + "-import", importRules)), sizes[marker] += injectedRules, addNameForId(names, id, name);
            },
            removeRules: function removeRules(id) {
              var marker = markers[id];

              if (void 0 !== marker) {
                var size = sizes[marker];
                !function (sheet, removalIndex, size) {
                  for (var lowerBound = removalIndex - size, i = removalIndex; lowerBound < i; i -= 1) {
                    sheet.deleteRule(i);
                  }
                }(sheetForTag(el), addUpUntilIndex(sizes, marker) - 1, size), sizes[marker] = 0, resetIdNames(names, id), extractImport && usedImportRuleTag && getImportRuleTag().removeRules(id + "-import");
              }
            },
            sealed: !1,
            styleTag: el,
            toElement: wrapAsElement(css, names),
            toHTML: wrapAsHtmlTag(css, names)
          };
        }(el, getImportRuleTag);
      },
          SPLIT_REGEX = /\s+/,
          MAX_SIZE = void 0;

      MAX_SIZE = IS_BROWSER ? DISABLE_SPEEDY ? 40 : 1e3 : -1;

      var sheetRunningId = 0,
          master = void 0,
          StyleSheet = function () {
        function StyleSheet() {
          var _this = this,
              target = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : IS_BROWSER ? document.head : null,
              forceServer = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];

          classCallCheck(this, StyleSheet), this.getImportRuleTag = function () {
            var importRuleTag = _this.importRuleTag;
            if (void 0 !== importRuleTag) return importRuleTag;
            var firstTag = _this.tags[0];
            return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, !0);
          }, sheetRunningId += 1, this.id = sheetRunningId, this.forceServer = forceServer, this.target = forceServer ? null : target, this.tagMap = {}, this.deferred = {}, this.rehydratedNames = {}, this.ignoreRehydratedNames = {}, this.tags = [], this.capacity = 1, this.clones = [];
        }

        return StyleSheet.prototype.rehydrate = function () {
          if (!IS_BROWSER || this.forceServer) return this;
          var els = [],
              extracted = [],
              isStreamed = !1,
              nodes = document.querySelectorAll("style[" + SC_ATTR + '][data-styled-version="4.3.1"]'),
              nodesSize = nodes.length;
          if (!nodesSize) return this;

          for (var i = 0; i < nodesSize; i += 1) {
            var el = nodes[i];
            isStreamed = isStreamed || !!el.getAttribute("data-styled-streamed");

            for (var name, elNames = (el.getAttribute(SC_ATTR) || "").trim().split(SPLIT_REGEX), elNamesSize = elNames.length, j = 0; j < elNamesSize; j += 1) {
              name = elNames[j], this.rehydratedNames[name] = !0;
            }

            extracted.push.apply(extracted, extractComps(el.textContent)), els.push(el);
          }

          var extractedSize = extracted.length;
          if (!extractedSize) return this;
          var tag = this.makeTag(null);
          !function (tag, els, extracted) {
            for (var i = 0, len = extracted.length; i < len; i += 1) {
              var _extracted$i = extracted[i],
                  componentId = _extracted$i.componentId,
                  cssFromDOM = _extracted$i.cssFromDOM,
                  cssRules = stylisSplitter("", cssFromDOM);
              tag.insertRules(componentId, cssRules);
            }

            for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
              var el = els[_i];
              el.parentNode && el.parentNode.removeChild(el);
            }
          }(tag, els, extracted), this.capacity = Math.max(1, MAX_SIZE - extractedSize), this.tags.push(tag);

          for (var _j = 0; _j < extractedSize; _j += 1) {
            this.tagMap[extracted[_j].componentId] = tag;
          }

          return this;
        }, StyleSheet.reset = function (argument_0) {
          master = new StyleSheet(void 0, 0 < arguments.length && void 0 !== argument_0 && argument_0).rehydrate();
        }, StyleSheet.prototype.clone = function () {
          var sheet = new StyleSheet(this.target, this.forceServer);
          return this.clones.push(sheet), sheet.tags = this.tags.map(function (tag) {
            for (var ids = tag.getIds(), newTag = tag.clone(), i = 0; i < ids.length; i += 1) {
              sheet.tagMap[ids[i]] = newTag;
            }

            return newTag;
          }), sheet.rehydratedNames = _extends({}, this.rehydratedNames), sheet.deferred = _extends({}, this.deferred), sheet;
        }, StyleSheet.prototype.sealAllTags = function () {
          this.capacity = 1, this.tags.forEach(function (tag) {
            tag.sealed = !0;
          });
        }, StyleSheet.prototype.makeTag = function (tag) {
          var lastEl = tag ? tag.styleTag : null;
          return makeTag(this.target, lastEl, this.forceServer, !1, this.getImportRuleTag);
        }, StyleSheet.prototype.getTagForId = function (id) {
          var prev = this.tagMap[id];
          if (void 0 !== prev && !prev.sealed) return prev;
          var tag = this.tags[this.tags.length - 1];
          return this.capacity -= 1, 0 === this.capacity && (this.capacity = MAX_SIZE, tag = this.makeTag(tag), this.tags.push(tag)), this.tagMap[id] = tag;
        }, StyleSheet.prototype.hasId = function (id) {
          return void 0 !== this.tagMap[id];
        }, StyleSheet.prototype.hasNameForId = function (id, name) {
          if (void 0 === this.ignoreRehydratedNames[id] && this.rehydratedNames[name]) return !0;
          var tag = this.tagMap[id];
          return void 0 !== tag && tag.hasNameForId(id, name);
        }, StyleSheet.prototype.deferredInject = function (id, cssRules) {
          if (void 0 === this.tagMap[id]) {
            for (var clones = this.clones, i = 0; i < clones.length; i += 1) {
              clones[i].deferredInject(id, cssRules);
            }

            this.getTagForId(id).insertMarker(id), this.deferred[id] = cssRules;
          }
        }, StyleSheet.prototype.inject = function (id, cssRules, name) {
          for (var clones = this.clones, i = 0; i < clones.length; i += 1) {
            clones[i].inject(id, cssRules, name);
          }

          var tag = this.getTagForId(id);

          if (void 0 !== this.deferred[id]) {
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name), this.deferred[id] = void 0;
          } else tag.insertRules(id, cssRules, name);
        }, StyleSheet.prototype.remove = function (id) {
          var tag = this.tagMap[id];

          if (void 0 !== tag) {
            for (var clones = this.clones, i = 0; i < clones.length; i += 1) {
              clones[i].remove(id);
            }

            tag.removeRules(id), this.ignoreRehydratedNames[id] = !0, this.deferred[id] = void 0;
          }
        }, StyleSheet.prototype.toHTML = function () {
          return this.tags.map(function (tag) {
            return tag.toHTML();
          }).join("");
        }, StyleSheet.prototype.toReactElements = function () {
          var id = this.id;
          return this.tags.map(function (tag, i) {
            var key = "sc-" + id + "-" + i;
            return Object(react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(tag.toElement(), {
              key: key
            });
          });
        }, createClass(StyleSheet, null, [{
          key: "master",
          get: function get() {
            return master = master || new StyleSheet().rehydrate();
          }
        }, {
          key: "instance",
          get: function get() {
            return StyleSheet.master;
          }
        }]), StyleSheet;
      }(),
          Keyframes = function () {
        function Keyframes(name, rules) {
          var _this = this;

          classCallCheck(this, Keyframes), this.inject = function (styleSheet) {
            styleSheet.hasNameForId(_this.id, _this.name) || styleSheet.inject(_this.id, _this.rules, _this.name);
          }, this.toString = function () {
            throw new StyledComponentsError(12, String(_this.name));
          }, this.name = name, this.rules = rules, this.id = "sc-keyframes-" + name;
        }

        return Keyframes.prototype.getName = function () {
          return this.name;
        }, Keyframes;
      }(),
          uppercasePattern = /([A-Z])/g,
          msPattern = /^ms-/;

      function hyphenateStyleName(string) {
        return string.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
      }

      var isFalsish = function isFalsish(chunk) {
        return null == chunk || !1 === chunk || "" === chunk;
      },
          objToCssArray = function objToCssArray(obj, prevKey) {
        var rules = [];
        return Object.keys(obj).forEach(function (key) {
          if (!isFalsish(obj[key])) {
            if (isPlainObject(obj[key])) return rules.push.apply(rules, objToCssArray(obj[key], key)), rules;
            if (isFunction(obj[key])) return rules.push(hyphenateStyleName(key) + ":", obj[key], ";"), rules;
            rules.push(hyphenateStyleName(key) + ": " + function (name, value) {
              return null == value || "boolean" == typeof value || "" === value ? "" : "number" != typeof value || 0 === value || name in _emotion_unitless__WEBPACK_IMPORTED_MODULE_3__.a ? String(value).trim() : value + "px";
            }(key, obj[key]) + ";");
          }

          return rules;
        }), prevKey ? [prevKey + " {"].concat(rules, ["}"]) : rules;
      };

      function flatten(chunk, executionContext, styleSheet) {
        if (Array.isArray(chunk)) {
          for (var result, ruleSet = [], i = 0, len = chunk.length; i < len; i += 1) {
            null !== (result = flatten(chunk[i], executionContext, styleSheet)) && (Array.isArray(result) ? ruleSet.push.apply(ruleSet, result) : ruleSet.push(result));
          }

          return ruleSet;
        }

        return isFalsish(chunk) ? null : isStyledComponent(chunk) ? "." + chunk.styledComponentId : isFunction(chunk) ? function (test) {
          return "function" == typeof test && !(test.prototype && test.prototype.isReactComponent);
        }(chunk) && executionContext ? flatten(chunk(executionContext), executionContext, styleSheet) : chunk : chunk instanceof Keyframes ? styleSheet ? (chunk.inject(styleSheet), chunk.getName()) : chunk : isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
      }

      function css(styles) {
        for (var _len = arguments.length, interpolations = Array(1 < _len ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          interpolations[_key - 1] = arguments[_key];
        }

        return isFunction(styles) || isPlainObject(styles) ? flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations))) : flatten(interleave(styles, interpolations));
      }

      function murmurhash(c) {
        for (var b, e = 0 | c.length, a = 0 | e, d = 0; 4 <= e;) {
          b = 1540483477 * (65535 & (b = 255 & c.charCodeAt(d) | (255 & c.charCodeAt(++d)) << 8 | (255 & c.charCodeAt(++d)) << 16 | (255 & c.charCodeAt(++d)) << 24)) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (65535 & a) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ (b = 1540483477 * (65535 & (b ^= b >>> 24)) + ((1540483477 * (b >>> 16) & 65535) << 16)), e -= 4, ++d;
        }

        switch (e) {
          case 3:
            a ^= (255 & c.charCodeAt(d + 2)) << 16;

          case 2:
            a ^= (255 & c.charCodeAt(d + 1)) << 8;

          case 1:
            a = 1540483477 * (65535 & (a ^= 255 & c.charCodeAt(d))) + ((1540483477 * (a >>> 16) & 65535) << 16);
        }

        return ((a = 1540483477 * (65535 & (a ^= a >>> 13)) + ((1540483477 * (a >>> 16) & 65535) << 16)) ^ a >>> 15) >>> 0;
      }

      var charsLength = 52,
          getAlphabeticChar = function getAlphabeticChar(code) {
        return String.fromCharCode(code + (25 < code ? 39 : 97));
      };

      function generateAlphabeticName(code) {
        var name = "",
            x = void 0;

        for (x = code; charsLength < x; x = Math.floor(x / charsLength)) {
          name = getAlphabeticChar(x % charsLength) + name;
        }

        return getAlphabeticChar(x % charsLength) + name;
      }

      function isStaticRules(rules, attrs) {
        for (var i = 0; i < rules.length; i += 1) {
          var rule = rules[i];
          if (Array.isArray(rule) && !isStaticRules(rule, attrs)) return !1;
          if (isFunction(rule) && !isStyledComponent(rule)) return !1;
        }

        return !attrs.some(function (x) {
          return isFunction(x) || function (obj) {
            for (var key in obj) {
              if (isFunction(obj[key])) return !0;
            }

            return !1;
          }(x);
        });
      }

      var _TYPE_STATICS,
          hasher = function hasher(str) {
        return generateAlphabeticName(murmurhash(str));
      },
          ComponentStyle = function () {
        function ComponentStyle(rules, attrs, componentId) {
          classCallCheck(this, ComponentStyle), this.rules = rules, this.isStatic = isStaticRules(rules, attrs), this.componentId = componentId, StyleSheet.master.hasId(componentId) || StyleSheet.master.deferredInject(componentId, []);
        }

        return ComponentStyle.prototype.generateAndInjectStyles = function (executionContext, styleSheet) {
          var isStatic = this.isStatic,
              componentId = this.componentId,
              lastClassName = this.lastClassName;
          if (IS_BROWSER && isStatic && "string" == typeof lastClassName && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
          var flatCSS = flatten(this.rules, executionContext, styleSheet),
              name = hasher(this.componentId + flatCSS.join(""));
          return styleSheet.hasNameForId(componentId, name) || styleSheet.inject(this.componentId, stringifyRules(flatCSS, "." + name, void 0, componentId), name), this.lastClassName = name;
        }, ComponentStyle.generateName = function (str) {
          return hasher(str);
        }, ComponentStyle;
      }(),
          determineTheme = function determineTheme(props, fallbackTheme) {
        var defaultProps = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : EMPTY_OBJECT,
            isDefaultTheme = !!defaultProps && props.theme === defaultProps.theme;
        return props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
      },
          escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g,
          dashesAtEnds = /(^-|-$)/g;

      function escape(str) {
        return str.replace(escapeRegex, "-").replace(dashesAtEnds, "");
      }

      function isTag(target) {
        return "string" == typeof target && !0;
      }

      var REACT_STATICS = {
        childContextTypes: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDerivedStateFromProps: !0,
        propTypes: !0,
        type: !0
      },
          KNOWN_STATICS = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
      },
          TYPE_STATICS = ((_TYPE_STATICS = {})[react_is__WEBPACK_IMPORTED_MODULE_4__.ForwardRef] = {
        $$typeof: !0,
        render: !0
      }, _TYPE_STATICS),
          defineProperty$1 = Object.defineProperty,
          getOwnPropertyNames = Object.getOwnPropertyNames,
          _Object$getOwnPropert = Object.getOwnPropertySymbols,
          getOwnPropertySymbols = void 0 === _Object$getOwnPropert ? function () {
        return [];
      } : _Object$getOwnPropert,
          getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
          getPrototypeOf = Object.getPrototypeOf,
          objectPrototype = Object.prototype,
          arrayPrototype = Array.prototype;

      function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if ("string" == typeof sourceComponent) return targetComponent;
        var inheritedComponent = getPrototypeOf(sourceComponent);
        inheritedComponent && inheritedComponent !== objectPrototype && hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);

        for (var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent), getOwnPropertySymbols(sourceComponent)), targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS, sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS, i = keys.length, descriptor = void 0, key = void 0; i--;) {
          if (key = keys[i], !(KNOWN_STATICS[key] || blacklist && blacklist[key] || sourceStatics && sourceStatics[key] || targetStatics && targetStatics[key]) && (descriptor = getOwnPropertyDescriptor(sourceComponent, key))) try {
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {}
        }

        return targetComponent;
      }

      var ThemeContext = Object(react__WEBPACK_IMPORTED_MODULE_2__.createContext)(),
          ThemeConsumer = ThemeContext.Consumer,
          ThemeProvider = function (_Component) {
        function ThemeProvider(props) {
          classCallCheck(this, ThemeProvider);

          var _this = possibleConstructorReturn(this, _Component.call(this, props));

          return _this.getContext = Object(memoize_one__WEBPACK_IMPORTED_MODULE_5__.a)(_this.getContext.bind(_this)), _this.renderInner = _this.renderInner.bind(_this), _this;
        }

        return inherits(ThemeProvider, _Component), ThemeProvider.prototype.render = function () {
          return this.props.children ? react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(ThemeContext.Consumer, null, this.renderInner) : null;
        }, ThemeProvider.prototype.renderInner = function (outerTheme) {
          var context = this.getContext(this.props.theme, outerTheme);
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(ThemeContext.Provider, {
            value: context
          }, react__WEBPACK_IMPORTED_MODULE_2___default.a.Children.only(this.props.children));
        }, ThemeProvider.prototype.getTheme = function (theme, outerTheme) {
          if (isFunction(theme)) return theme(outerTheme);
          if (null === theme || Array.isArray(theme) || "object" !== (void 0 === theme ? "undefined" : _typeof(theme))) throw new StyledComponentsError(8);
          return _extends({}, outerTheme, theme);
        }, ThemeProvider.prototype.getContext = function (theme, outerTheme) {
          return this.getTheme(theme, outerTheme);
        }, ThemeProvider;
      }(react__WEBPACK_IMPORTED_MODULE_2__.Component),
          ServerStyleSheet = function () {
        function ServerStyleSheet() {
          classCallCheck(this, ServerStyleSheet), this.masterSheet = StyleSheet.master, this.instance = this.masterSheet.clone(), this.sealed = !1;
        }

        return ServerStyleSheet.prototype.seal = function () {
          if (!this.sealed) {
            var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1), this.sealed = !0;
          }
        }, ServerStyleSheet.prototype.collectStyles = function (children) {
          if (this.sealed) throw new StyledComponentsError(2);
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(StyleSheetManager, {
            sheet: this.instance
          }, children);
        }, ServerStyleSheet.prototype.getStyleTags = function () {
          return this.seal(), this.instance.toHTML();
        }, ServerStyleSheet.prototype.getStyleElement = function () {
          return this.seal(), this.instance.toReactElements();
        }, ServerStyleSheet.prototype.interleaveWithNodeStream = function (readableStream) {
          throw new StyledComponentsError(3);
        }, ServerStyleSheet;
      }(),
          StyleSheetContext = Object(react__WEBPACK_IMPORTED_MODULE_2__.createContext)(),
          StyleSheetConsumer = StyleSheetContext.Consumer,
          StyleSheetManager = function (_Component) {
        function StyleSheetManager(props) {
          classCallCheck(this, StyleSheetManager);

          var _this = possibleConstructorReturn(this, _Component.call(this, props));

          return _this.getContext = Object(memoize_one__WEBPACK_IMPORTED_MODULE_5__.a)(_this.getContext), _this;
        }

        return inherits(StyleSheetManager, _Component), StyleSheetManager.prototype.getContext = function (sheet, target) {
          if (sheet) return sheet;
          if (target) return new StyleSheet(target);
          throw new StyledComponentsError(4);
        }, StyleSheetManager.prototype.render = function () {
          var _props = this.props,
              children = _props.children,
              sheet = _props.sheet,
              target = _props.target;
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(StyleSheetContext.Provider, {
            value: this.getContext(sheet, target)
          }, children);
        }, StyleSheetManager;
      }(react__WEBPACK_IMPORTED_MODULE_2__.Component),
          identifiers = {};

      var StyledComponent = function (_Component) {
        function StyledComponent() {
          classCallCheck(this, StyledComponent);

          var _this = possibleConstructorReturn(this, _Component.call(this));

          return _this.attrs = {}, _this.renderOuter = _this.renderOuter.bind(_this), _this.renderInner = _this.renderInner.bind(_this), _this;
        }

        return inherits(StyledComponent, _Component), StyledComponent.prototype.render = function () {
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(StyleSheetConsumer, null, this.renderOuter);
        }, StyledComponent.prototype.renderOuter = function (argument_0) {
          var styleSheet = 0 < arguments.length && void 0 !== argument_0 ? argument_0 : StyleSheet.master;
          return this.styleSheet = styleSheet, this.props.forwardedComponent.componentStyle.isStatic ? this.renderInner() : react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(ThemeConsumer, null, this.renderInner);
        }, StyledComponent.prototype.renderInner = function (theme) {
          var _props$forwardedCompo = this.props.forwardedComponent,
              componentStyle = _props$forwardedCompo.componentStyle,
              defaultProps = _props$forwardedCompo.defaultProps,
              foldedComponentIds = (_props$forwardedCompo.displayName, _props$forwardedCompo.foldedComponentIds),
              styledComponentId = _props$forwardedCompo.styledComponentId,
              target = _props$forwardedCompo.target,
              generatedClassName = void 0;
          generatedClassName = componentStyle.isStatic ? this.generateAndInjectStyles(EMPTY_OBJECT, this.props) : this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);

          var elementToBeCreated = this.props.as || this.attrs.as || target,
              isTargetTag = isTag(elementToBeCreated),
              propsForElement = {},
              computedProps = _extends({}, this.attrs, this.props),
              key = void 0;

          for (key in computedProps) {
            "forwardedComponent" !== key && "as" !== key && ("forwardedRef" === key ? propsForElement.ref = computedProps[key] : "forwardedAs" === key ? propsForElement.as = computedProps[key] : isTargetTag && !Object(_emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_7__.a)(key) || (propsForElement[key] = computedProps[key]));
          }

          return this.props.style && this.attrs.style && (propsForElement.style = _extends({}, this.attrs.style, this.props.style)), propsForElement.className = Array.prototype.concat(foldedComponentIds, this.props.className, styledComponentId, this.attrs.className, generatedClassName).filter(Boolean).join(" "), Object(react__WEBPACK_IMPORTED_MODULE_2__.createElement)(elementToBeCreated, propsForElement);
        }, StyledComponent.prototype.buildExecutionContext = function (theme, props, attrs) {
          var _this2 = this,
              context = _extends({}, props, {
            theme: theme
          });

          return attrs.length && (this.attrs = {}, attrs.forEach(function (attrDef) {
            var fn,
                resolvedAttrDef = attrDef,
                attrDefWasFn = !1,
                attr = void 0,
                key = void 0;

            for (key in isFunction(resolvedAttrDef) && (resolvedAttrDef = resolvedAttrDef(context), attrDefWasFn = !0), resolvedAttrDef) {
              attr = resolvedAttrDef[key], attrDefWasFn || !isFunction(attr) || (fn = attr) && fn.prototype && fn.prototype.isReactComponent || isStyledComponent(attr) || (attr = attr(context)), _this2.attrs[key] = attr, context[key] = attr;
            }
          })), context;
        }, StyledComponent.prototype.generateAndInjectStyles = function (theme, props) {
          var _props$forwardedCompo2 = props.forwardedComponent,
              attrs = _props$forwardedCompo2.attrs,
              componentStyle = _props$forwardedCompo2.componentStyle;
          _props$forwardedCompo2.warnTooManyClasses;
          return componentStyle.isStatic && !attrs.length ? componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet) : componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
        }, StyledComponent;
      }(react__WEBPACK_IMPORTED_MODULE_2__.Component);

      function createStyledComponent(target, options, rules) {
        var isTargetStyledComp = isStyledComponent(target),
            isClass = !isTag(target),
            _options$displayName = options.displayName,
            displayName = void 0 === _options$displayName ? function (target) {
          return isTag(target) ? "styled." + target : "Styled(" + getComponentName(target) + ")";
        }(target) : _options$displayName,
            _options$componentId = options.componentId,
            componentId = void 0 === _options$componentId ? function (_ComponentStyle, _displayName, parentComponentId) {
          var displayName = "string" != typeof _displayName ? "sc" : escape(_displayName),
              nr = (identifiers[displayName] || 0) + 1;
          identifiers[displayName] = nr;

          var componentId = displayName + "-" + _ComponentStyle.generateName(displayName + nr);

          return parentComponentId ? parentComponentId + "-" + componentId : componentId;
        }(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
            _options$ParentCompon = options.ParentComponent,
            ParentComponent = void 0 === _options$ParentCompon ? StyledComponent : _options$ParentCompon,
            _options$attrs = options.attrs,
            attrs = void 0 === _options$attrs ? EMPTY_ARRAY : _options$attrs,
            styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + "-" + options.componentId : options.componentId || componentId,
            finalAttrs = isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs,
            componentStyle = new ComponentStyle(isTargetStyledComp ? target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId),
            WrappedStyledComponent = void 0,
            forwardRef = function forwardRef(props, ref) {
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(ParentComponent, _extends({}, props, {
            forwardedComponent: WrappedStyledComponent,
            forwardedRef: ref
          }));
        };

        return forwardRef.displayName = displayName, (WrappedStyledComponent = react__WEBPACK_IMPORTED_MODULE_2___default.a.forwardRef(forwardRef)).displayName = displayName, WrappedStyledComponent.attrs = finalAttrs, WrappedStyledComponent.componentStyle = componentStyle, WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY, WrappedStyledComponent.styledComponentId = styledComponentId, WrappedStyledComponent.target = isTargetStyledComp ? target.target : target, WrappedStyledComponent.withComponent = function (tag) {
          var previousComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ["componentId"]),
              newComponentId = previousComponentId && previousComponentId + "-" + (isTag(tag) ? tag : escape(getComponentName(tag)));
          return createStyledComponent(tag, _extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId,
            ParentComponent: ParentComponent
          }), rules);
        }, Object.defineProperty(WrappedStyledComponent, "defaultProps", {
          get: function get() {
            return this._foldedDefaultProps;
          },
          set: function set(obj) {
            this._foldedDefaultProps = isTargetStyledComp ? Object(merge_anything__WEBPACK_IMPORTED_MODULE_8__.a)(target.defaultProps, obj) : obj;
          }
        }), WrappedStyledComponent.toString = function () {
          return "." + WrappedStyledComponent.styledComponentId;
        }, isClass && hoistNonReactStatics(WrappedStyledComponent, target, {
          attrs: !0,
          componentStyle: !0,
          displayName: !0,
          foldedComponentIds: !0,
          styledComponentId: !0,
          target: !0,
          withComponent: !0
        }), WrappedStyledComponent;
      }

      var styled = function styled(tag) {
        return function constructWithOptions(componentConstructor, tag, argument_2) {
          var options = 2 < arguments.length && void 0 !== argument_2 ? argument_2 : EMPTY_OBJECT;
          if (!Object(react_is__WEBPACK_IMPORTED_MODULE_4__.isValidElementType)(tag)) throw new StyledComponentsError(1, String(tag));

          var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(void 0, arguments));
          };

          return templateFunction.withConfig = function (config) {
            return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
          }, templateFunction.attrs = function (attrs) {
            return constructWithOptions(componentConstructor, tag, _extends({}, options, {
              attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
            }));
          }, templateFunction;
        }(createStyledComponent, tag);
      };

      ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (domElement) {
        styled[domElement] = styled(domElement);
      });

      var GlobalStyle = function () {
        function GlobalStyle(rules, componentId) {
          classCallCheck(this, GlobalStyle), this.rules = rules, this.componentId = componentId, this.isStatic = isStaticRules(rules, EMPTY_ARRAY), StyleSheet.master.hasId(componentId) || StyleSheet.master.deferredInject(componentId, []);
        }

        return GlobalStyle.prototype.createStyles = function (executionContext, styleSheet) {
          var css = stringifyRules(flatten(this.rules, executionContext, styleSheet), "");
          styleSheet.inject(this.componentId, css);
        }, GlobalStyle.prototype.removeStyles = function (styleSheet) {
          var componentId = this.componentId;
          styleSheet.hasId(componentId) && styleSheet.remove(componentId);
        }, GlobalStyle.prototype.renderStyles = function (executionContext, styleSheet) {
          this.removeStyles(styleSheet), this.createStyles(executionContext, styleSheet);
        }, GlobalStyle;
      }();

      function createGlobalStyle(strings) {
        for (var _len = arguments.length, interpolations = Array(1 < _len ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          interpolations[_key - 1] = arguments[_key];
        }

        var rules = css.apply(void 0, [strings].concat(interpolations)),
            id = "sc-global-" + murmurhash(JSON.stringify(rules)),
            style = new GlobalStyle(rules, id),
            GlobalStyleComponent = function (_React$Component) {
          function GlobalStyleComponent(props) {
            classCallCheck(this, GlobalStyleComponent);

            var _this = possibleConstructorReturn(this, _React$Component.call(this, props)),
                _this$constructor = _this.constructor,
                globalStyle = _this$constructor.globalStyle,
                styledComponentId = _this$constructor.styledComponentId;

            return IS_BROWSER && (window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1), _this.state = {
              globalStyle: globalStyle,
              styledComponentId: styledComponentId
            }, _this;
          }

          return inherits(GlobalStyleComponent, _React$Component), GlobalStyleComponent.prototype.componentWillUnmount = function () {
            window.scCGSHMRCache[this.state.styledComponentId] && (window.scCGSHMRCache[this.state.styledComponentId] -= 1), 0 === window.scCGSHMRCache[this.state.styledComponentId] && this.state.globalStyle.removeStyles(this.styleSheet);
          }, GlobalStyleComponent.prototype.render = function () {
            var _this2 = this;

            return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(StyleSheetConsumer, null, function (styleSheet) {
              _this2.styleSheet = styleSheet || StyleSheet.master;
              var globalStyle = _this2.state.globalStyle;
              return globalStyle.isStatic ? (globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet), null) : react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(ThemeConsumer, null, function (theme) {
                var defaultProps = _this2.constructor.defaultProps,
                    context = _extends({}, _this2.props);

                return void 0 !== theme && (context.theme = determineTheme(_this2.props, theme, defaultProps)), globalStyle.renderStyles(context, _this2.styleSheet), null;
              });
            });
          }, GlobalStyleComponent;
        }(react__WEBPACK_IMPORTED_MODULE_2___default.a.Component);

        return GlobalStyleComponent.globalStyle = style, GlobalStyleComponent.styledComponentId = id, GlobalStyleComponent;
      }

      IS_BROWSER && (window.scCGSHMRCache = {});

      var replaceWhitespace = function replaceWhitespace(str) {
        return str.replace(/\s|\\n/g, "");
      };

      function keyframes(strings) {
        for (var _len = arguments.length, interpolations = Array(1 < _len ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          interpolations[_key - 1] = arguments[_key];
        }

        var rules = css.apply(void 0, [strings].concat(interpolations)),
            name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
        return new Keyframes(name, stringifyRules(rules, name, "@keyframes"));
      }

      var withTheme = function withTheme(Component$$1) {
        var WithTheme = react__WEBPACK_IMPORTED_MODULE_2___default.a.forwardRef(function (props, ref) {
          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(ThemeConsumer, null, function (theme) {
            var defaultProps = Component$$1.defaultProps,
                themeProp = determineTheme(props, theme, defaultProps);
            return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(Component$$1, _extends({}, props, {
              theme: themeProp,
              ref: ref
            }));
          });
        });
        return hoistNonReactStatics(WithTheme, Component$$1), WithTheme.displayName = "WithTheme(" + getComponentName(Component$$1) + ")", WithTheme;
      },
          __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
        StyleSheet: StyleSheet
      };

      __webpack_exports__.default = styled;
    }.call(this, __webpack_require__(21));
  }, function (module, exports) {
    var cachedSetTimeout,
        cachedClearTimeout,
        process = module.exports = {};

    function defaultSetTimout() {
      throw new Error("setTimeout has not been defined");
    }

    function defaultClearTimeout() {
      throw new Error("clearTimeout has not been defined");
    }

    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) return setTimeout(fun, 0);
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) return cachedSetTimeout = setTimeout, setTimeout(fun, 0);

      try {
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }

    !function () {
      try {
        cachedSetTimeout = "function" == typeof setTimeout ? setTimeout : defaultSetTimout;
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }

      try {
        cachedClearTimeout = "function" == typeof clearTimeout ? clearTimeout : defaultClearTimeout;
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    }();
    var currentQueue,
        queue = [],
        draining = !1,
        queueIndex = -1;

    function cleanUpNextTick() {
      draining && currentQueue && (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
    }

    function drainQueue() {
      if (!draining) {
        var timeout = runTimeout(cleanUpNextTick);
        draining = !0;

        for (var len = queue.length; len;) {
          for (currentQueue = queue, queue = []; ++queueIndex < len;) {
            currentQueue && currentQueue[queueIndex].run();
          }

          queueIndex = -1, len = queue.length;
        }

        currentQueue = null, draining = !1, function (marker) {
          if (cachedClearTimeout === clearTimeout) return clearTimeout(marker);
          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) return cachedClearTimeout = clearTimeout, clearTimeout(marker);

          try {
            cachedClearTimeout(marker);
          } catch (e) {
            try {
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              return cachedClearTimeout.call(this, marker);
            }
          }
        }(timeout);
      }
    }

    function Item(fun, array) {
      this.fun = fun, this.array = array;
    }

    function noop() {}

    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (1 < arguments.length) for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
      queue.push(new Item(fun, args)), 1 !== queue.length || draining || runTimeout(drainQueue);
    }, Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, process.title = "browser", process.browser = !0, process.env = {}, process.argv = [], process.version = "", process.versions = {}, process.on = noop, process.addListener = noop, process.once = noop, process.off = noop, process.removeListener = noop, process.removeAllListeners = noop, process.emit = noop, process.prependListener = noop, process.prependOnceListener = noop, process.listeners = function (name) {
      return [];
    }, process.binding = function (name) {
      throw new Error("process.binding is not supported");
    }, process.cwd = function () {
      return "/";
    }, process.chdir = function (dir) {
      throw new Error("process.chdir is not supported");
    }, process.umask = function () {
      return 0;
    };
  }, function (module, exports, __webpack_require__) {
    "use strict";
    /** @license React v16.8.6
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var b = "function" == typeof Symbol && Symbol.for,
        c = b ? Symbol.for("react.element") : 60103,
        d = b ? Symbol.for("react.portal") : 60106,
        e = b ? Symbol.for("react.fragment") : 60107,
        f = b ? Symbol.for("react.strict_mode") : 60108,
        g = b ? Symbol.for("react.profiler") : 60114,
        h = b ? Symbol.for("react.provider") : 60109,
        k = b ? Symbol.for("react.context") : 60110,
        l = b ? Symbol.for("react.async_mode") : 60111,
        m = b ? Symbol.for("react.concurrent_mode") : 60111,
        n = b ? Symbol.for("react.forward_ref") : 60112,
        p = b ? Symbol.for("react.suspense") : 60113,
        q = b ? Symbol.for("react.memo") : 60115,
        r = b ? Symbol.for("react.lazy") : 60116;

    function t(a) {
      if ("object" == typeof a && null !== a) {
        var u = a.$$typeof;

        switch (u) {
          case c:
            switch (a = a.type) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;

              default:
                switch (a = a && a.$$typeof) {
                  case k:
                  case n:
                  case h:
                    return a;

                  default:
                    return u;
                }

            }

          case r:
          case q:
          case d:
            return u;
        }
      }
    }

    function v(a) {
      return t(a) === m;
    }

    exports.typeOf = t, exports.AsyncMode = l, exports.ConcurrentMode = m, exports.ContextConsumer = k, exports.ContextProvider = h, exports.Element = c, exports.ForwardRef = n, exports.Fragment = e, exports.Lazy = r, exports.Memo = q, exports.Portal = d, exports.Profiler = g, exports.StrictMode = f, exports.Suspense = p, exports.isValidElementType = function (a) {
      return "string" == typeof a || "function" == typeof a || a === e || a === m || a === g || a === f || a === p || "object" == typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
    }, exports.isAsyncMode = function (a) {
      return v(a) || t(a) === l;
    }, exports.isConcurrentMode = v, exports.isContextConsumer = function (a) {
      return t(a) === k;
    }, exports.isContextProvider = function (a) {
      return t(a) === h;
    }, exports.isElement = function (a) {
      return "object" == typeof a && null !== a && a.$$typeof === c;
    }, exports.isForwardRef = function (a) {
      return t(a) === n;
    }, exports.isFragment = function (a) {
      return t(a) === e;
    }, exports.isLazy = function (a) {
      return t(a) === r;
    }, exports.isMemo = function (a) {
      return t(a) === q;
    }, exports.isPortal = function (a) {
      return t(a) === d;
    }, exports.isProfiler = function (a) {
      return t(a) === g;
    }, exports.isStrictMode = function (a) {
      return t(a) === f;
    }, exports.isSuspense = function (a) {
      return t(a) === p;
    };
  }, function (module, exports, __webpack_require__) {
    module.exports = __webpack_require__(24)();
  }, function (module, exports, __webpack_require__) {
    "use strict";

    var ReactPropTypesSecret = __webpack_require__(25);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, module.exports = function () {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret !== ReactPropTypesSecret) {
          var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw err.name = "Invariant Violation", err;
        }
      }

      function getShim() {
        return shim;
      }

      var ReactPropTypes = {
        array: shim.isRequired = shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return ReactPropTypes.PropTypes = ReactPropTypes;
    };
  }, function (module, exports, __webpack_require__) {
    "use strict";

    module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (module, exports, __webpack_require__) {
    module.exports = {
      mainSvg: "TreeMap.module_mainSvg_3UpOl"
    };
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);

    var src = __webpack_require__(2);

    function Map() {}

    function map(object, f) {
      var map = new Map();
      if (object instanceof Map) object.each(function (value, key) {
        map.set(key, value);
      });else if (Array.isArray(object)) {
        var o,
            i = -1,
            n = object.length;
        if (null == f) for (; ++i < n;) {
          map.set(i, object[i]);
        } else for (; ++i < n;) {
          map.set(f(o = object[i], i, object), o);
        }
      } else if (object) for (var key in object) {
        map.set(key, object[key]);
      }
      return map;
    }

    Map.prototype = map.prototype = {
      constructor: Map,
      has: function has(key) {
        return "$" + key in this;
      },
      get: function get(key) {
        return this["$" + key];
      },
      set: function set(key, value) {
        return this["$" + key] = value, this;
      },
      remove: function remove(key) {
        var property = "$" + key;
        return property in this && delete this[property];
      },
      clear: function clear() {
        for (var property in this) {
          "$" === property[0] && delete this[property];
        }
      },
      keys: function keys() {
        var keys = [];

        for (var property in this) {
          "$" === property[0] && keys.push(property.slice(1));
        }

        return keys;
      },
      values: function values() {
        var values = [];

        for (var property in this) {
          "$" === property[0] && values.push(this[property]);
        }

        return values;
      },
      entries: function entries() {
        var entries = [];

        for (var property in this) {
          "$" === property[0] && entries.push({
            key: property.slice(1),
            value: this[property]
          });
        }

        return entries;
      },
      size: function size() {
        var size = 0;

        for (var property in this) {
          "$" === property[0] && ++size;
        }

        return size;
      },
      empty: function empty() {
        for (var property in this) {
          if ("$" === property[0]) return !1;
        }

        return !0;
      },
      each: function each(f) {
        for (var property in this) {
          "$" === property[0] && f(this[property], property.slice(1), this);
        }
      }
    };
    var src_map = map;

    function Set() {}

    var proto = src_map.prototype;
    Set.prototype = {
      constructor: Set,
      has: proto.has,
      add: function add(value) {
        return this["$" + (value += "")] = value, this;
      },
      remove: proto.remove,
      clear: proto.clear,
      values: proto.keys,
      size: proto.size,
      empty: proto.empty,
      each: proto.each
    };
    var array_array = Array.prototype,
        array_map = array_array.map,
        slice = array_array.slice,
        implicit = {
      name: "implicit"
    };

    function ordinal(range) {
      var index = src_map(),
          domain = [],
          unknown = implicit;

      function scale(d) {
        var key = d + "",
            i = index.get(key);

        if (!i) {
          if (unknown !== implicit) return unknown;
          index.set(key, i = domain.push(d));
        }

        return range[(i - 1) % range.length];
      }

      return range = null == range ? [] : slice.call(range), scale.domain = function (_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = src_map();

        for (var d, key, i = -1, n = _.length; ++i < n;) {
          index.has(key = (d = _[i]) + "") || index.set(key, domain.push(d));
        }

        return scale;
      }, scale.range = function (_) {
        return arguments.length ? (range = slice.call(_), scale) : range.slice();
      }, scale.unknown = function (_) {
        return arguments.length ? (unknown = _, scale) : unknown;
      }, scale.copy = function () {
        return ordinal().domain(domain).range(range).unknown(unknown);
      }, scale;
    }

    function band() {
      var step,
          bandwidth,
          scale = ordinal().unknown(void 0),
          domain = scale.domain,
          ordinalRange = scale.range,
          range = [0, 1],
          round = !1,
          paddingInner = 0,
          paddingOuter = 0,
          align = .5;

      function rescale() {
        var n = domain().length,
            reverse = range[1] < range[0],
            start = range[reverse - 0],
            stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + 2 * paddingOuter), round && (step = Math.floor(step)), start += (stop - start - step * (n - paddingInner)) * align, bandwidth = step * (1 - paddingInner), round && (start = Math.round(start), bandwidth = Math.round(bandwidth));
        var values = Object(src.range)(n).map(function (i) {
          return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
      }

      return delete scale.unknown, scale.domain = function (_) {
        return arguments.length ? (domain(_), rescale()) : domain();
      }, scale.range = function (_) {
        return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
      }, scale.rangeRound = function (_) {
        return range = [+_[0], +_[1]], round = !0, rescale();
      }, scale.bandwidth = function () {
        return bandwidth;
      }, scale.step = function () {
        return step;
      }, scale.round = function (_) {
        return arguments.length ? (round = !!_, rescale()) : round;
      }, scale.padding = function (_) {
        return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
      }, scale.paddingInner = function (_) {
        return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
      }, scale.paddingOuter = function (_) {
        return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
      }, scale.align = function (_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
      }, scale.copy = function () {
        return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
      }, rescale();
    }

    function point() {
      return function pointish(scale) {
        var copy = scale.copy;
        return scale.padding = scale.paddingOuter, delete scale.paddingInner, delete scale.paddingOuter, scale.copy = function () {
          return pointish(copy());
        }, scale;
      }(band().paddingInner(1));
    }

    var d3_interpolate_src = __webpack_require__(3),
        constant = function constant(x) {
      return function () {
        return x;
      };
    },
        number = function number(x) {
      return +x;
    },
        unit = [0, 1];

    function deinterpolateLinear(a, b) {
      return (b -= a = +a) ? function (x) {
        return (x - a) / b;
      } : constant(b);
    }

    function bimap(domain, range, deinterpolate, reinterpolate) {
      var d0 = domain[0],
          d1 = domain[1],
          r0 = range[0],
          r1 = range[1];
      return r0 = d1 < d0 ? (d0 = deinterpolate(d1, d0), reinterpolate(r1, r0)) : (d0 = deinterpolate(d0, d1), reinterpolate(r0, r1)), function (x) {
        return r0(d0(x));
      };
    }

    function polymap(domain, range, deinterpolate, reinterpolate) {
      var j = Math.min(domain.length, range.length) - 1,
          d = new Array(j),
          r = new Array(j),
          i = -1;

      for (domain[j] < domain[0] && (domain = domain.slice().reverse(), range = range.slice().reverse()); ++i < j;) {
        d[i] = deinterpolate(domain[i], domain[i + 1]), r[i] = reinterpolate(range[i], range[i + 1]);
      }

      return function (x) {
        var i = Object(src.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
      };
    }

    function copy(source, target) {
      return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
    }

    function continuous(deinterpolate, reinterpolate) {
      var piecewise,
          output,
          input,
          domain = unit,
          range = unit,
          interpolate = d3_interpolate_src.interpolate,
          clamp = !1;

      function rescale() {
        return piecewise = 2 < Math.min(domain.length, range.length) ? polymap : bimap, output = input = null, scale;
      }

      function scale(x) {
        return (output = output || piecewise(domain, range, clamp ? function (deinterpolate) {
          return function (a, b) {
            var d = deinterpolate(a = +a, b = +b);
            return function (x) {
              return x <= a ? 0 : b <= x ? 1 : d(x);
            };
          };
        }(deinterpolate) : deinterpolate, interpolate))(+x);
      }

      return scale.invert = function (y) {
        return (input = input || piecewise(range, domain, deinterpolateLinear, clamp ? function (reinterpolate) {
          return function (a, b) {
            var r = reinterpolate(a = +a, b = +b);
            return function (t) {
              return t <= 0 ? a : 1 <= t ? b : r(t);
            };
          };
        }(reinterpolate) : reinterpolate))(+y);
      }, scale.domain = function (_) {
        return arguments.length ? (domain = array_map.call(_, number), rescale()) : domain.slice();
      }, scale.range = function (_) {
        return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
      }, scale.rangeRound = function (_) {
        return range = slice.call(_), interpolate = d3_interpolate_src.interpolateRound, rescale();
      }, scale.clamp = function (_) {
        return arguments.length ? (clamp = !!_, rescale()) : clamp;
      }, scale.interpolate = function (_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
      }, rescale();
    }

    var d3_format_src = __webpack_require__(4),
        src_tickFormat = function src_tickFormat(domain, count, specifier) {
      var precision,
          start = domain[0],
          stop = domain[domain.length - 1],
          step = Object(src.tickStep)(start, stop, null == count ? 10 : count);

      switch ((specifier = Object(d3_format_src.formatSpecifier)(null == specifier ? ",f" : specifier)).type) {
        case "s":
          var value = Math.max(Math.abs(start), Math.abs(stop));
          return null != specifier.precision || isNaN(precision = Object(d3_format_src.precisionPrefix)(step, value)) || (specifier.precision = precision), Object(d3_format_src.formatPrefix)(specifier, value);

        case "":
        case "e":
        case "g":
        case "p":
        case "r":
          null != specifier.precision || isNaN(precision = Object(d3_format_src.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop)))) || (specifier.precision = precision - ("e" === specifier.type));
          break;

        case "f":
        case "%":
          null != specifier.precision || isNaN(precision = Object(d3_format_src.precisionFixed)(step)) || (specifier.precision = precision - 2 * ("%" === specifier.type));
      }

      return Object(d3_format_src.format)(specifier);
    };

    function linearish(scale) {
      var domain = scale.domain;
      return scale.ticks = function (count) {
        var d = domain();
        return Object(src.ticks)(d[0], d[d.length - 1], null == count ? 10 : count);
      }, scale.tickFormat = function (count, specifier) {
        return src_tickFormat(domain(), count, specifier);
      }, scale.nice = function (count) {
        null == count && (count = 10);
        var step,
            d = domain(),
            i0 = 0,
            i1 = d.length - 1,
            start = d[i0],
            stop = d[i1];
        return stop < start && (step = start, start = stop, stop = step, step = i0, i0 = i1, i1 = step), 0 < (step = Object(src.tickIncrement)(start, stop, count)) ? (start = Math.floor(start / step) * step, stop = Math.ceil(stop / step) * step, step = Object(src.tickIncrement)(start, stop, count)) : step < 0 && (start = Math.ceil(start * step) / step, stop = Math.floor(stop * step) / step, step = Object(src.tickIncrement)(start, stop, count)), 0 < step ? (d[i0] = Math.floor(start / step) * step, d[i1] = Math.ceil(stop / step) * step, domain(d)) : step < 0 && (d[i0] = Math.ceil(start * step) / step, d[i1] = Math.floor(stop * step) / step, domain(d)), scale;
      }, scale;
    }

    function linear() {
      var scale = continuous(deinterpolateLinear, d3_interpolate_src.interpolateNumber);
      return scale.copy = function () {
        return copy(scale, linear());
      }, linearish(scale);
    }

    function identity() {
      var domain = [0, 1];

      function scale(x) {
        return +x;
      }

      return (scale.invert = scale).domain = scale.range = function (_) {
        return arguments.length ? (domain = array_map.call(_, number), scale) : domain.slice();
      }, scale.copy = function () {
        return identity().domain(domain);
      }, linearish(scale);
    }

    var nice = function nice(domain, interval) {
      var t,
          i0 = 0,
          i1 = (domain = domain.slice()).length - 1,
          x0 = domain[i0],
          x1 = domain[i1];
      return x1 < x0 && (t = i0, i0 = i1, i1 = t, t = x0, x0 = x1, x1 = t), domain[i0] = interval.floor(x0), domain[i1] = interval.ceil(x1), domain;
    };

    function log_deinterpolate(a, b) {
      return (b = Math.log(b / a)) ? function (x) {
        return Math.log(x / a) / b;
      } : constant(b);
    }

    function log_reinterpolate(a, b) {
      return a < 0 ? function (t) {
        return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
      } : function (t) {
        return Math.pow(b, t) * Math.pow(a, 1 - t);
      };
    }

    function pow10(x) {
      return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
    }

    function powp(base) {
      return 10 === base ? pow10 : base === Math.E ? Math.exp : function (x) {
        return Math.pow(base, x);
      };
    }

    function logp(base) {
      return base === Math.E ? Math.log : 10 === base && Math.log10 || 2 === base && Math.log2 || (base = Math.log(base), function (x) {
        return Math.log(x) / base;
      });
    }

    function reflect(f) {
      return function (x) {
        return -f(-x);
      };
    }

    function log() {
      var scale = continuous(log_deinterpolate, log_reinterpolate).domain([1, 10]),
          domain = scale.domain,
          base = 10,
          logs = logp(10),
          pows = powp(10);

      function rescale() {
        return logs = logp(base), pows = powp(base), domain()[0] < 0 && (logs = reflect(logs), pows = reflect(pows)), scale;
      }

      return scale.base = function (_) {
        return arguments.length ? (base = +_, rescale()) : base;
      }, scale.domain = function (_) {
        return arguments.length ? (domain(_), rescale()) : domain();
      }, scale.ticks = function (count) {
        var r,
            d = domain(),
            u = d[0],
            v = d[d.length - 1];
        (r = v < u) && (i = u, u = v, v = i);
        var p,
            k,
            t,
            i = logs(u),
            j = logs(v),
            n = null == count ? 10 : +count,
            z = [];

        if (!(base % 1) && j - i < n) {
          if (i = Math.round(i) - 1, j = Math.round(j) + 1, 0 < u) {
            for (; i < j; ++i) {
              for (k = 1, p = pows(i); k < base; ++k) {
                if (!((t = p * k) < u)) {
                  if (v < t) break;
                  z.push(t);
                }
              }
            }
          } else for (; i < j; ++i) {
            for (k = base - 1, p = pows(i); 1 <= k; --k) {
              if (!((t = p * k) < u)) {
                if (v < t) break;
                z.push(t);
              }
            }
          }
        } else z = Object(src.ticks)(i, j, Math.min(j - i, n)).map(pows);

        return r ? z.reverse() : z;
      }, scale.tickFormat = function (count, specifier) {
        if (null == specifier && (specifier = 10 === base ? ".0e" : ","), "function" != typeof specifier && (specifier = Object(d3_format_src.format)(specifier)), count === 1 / 0) return specifier;
        null == count && (count = 10);
        var k = Math.max(1, base * count / scale.ticks().length);
        return function (d) {
          var i = d / pows(Math.round(logs(d)));
          return i * base < base - .5 && (i *= base), i <= k ? specifier(d) : "";
        };
      }, scale.nice = function () {
        return domain(nice(domain(), {
          floor: function floor(x) {
            return pows(Math.floor(logs(x)));
          },
          ceil: function ceil(x) {
            return pows(Math.ceil(logs(x)));
          }
        }));
      }, scale.copy = function () {
        return copy(scale, log().base(base));
      }, scale;
    }

    function raise(x, exponent) {
      return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    }

    function pow() {
      var exponent = 1,
          scale = continuous(function (a, b) {
        return (b = raise(b, exponent) - (a = raise(a, exponent))) ? function (x) {
          return (raise(x, exponent) - a) / b;
        } : constant(b);
      }, function (a, b) {
        return b = raise(b, exponent) - (a = raise(a, exponent)), function (t) {
          return raise(a + b * t, 1 / exponent);
        };
      }),
          domain = scale.domain;
      return scale.exponent = function (_) {
        return arguments.length ? (exponent = +_, domain(domain())) : exponent;
      }, scale.copy = function () {
        return copy(scale, pow().exponent(exponent));
      }, linearish(scale);
    }

    function sqrt() {
      return pow().exponent(.5);
    }

    function quantile() {
      var domain = [],
          range = [],
          thresholds = [];

      function rescale() {
        var i = 0,
            n = Math.max(1, range.length);

        for (thresholds = new Array(n - 1); ++i < n;) {
          thresholds[i - 1] = Object(src.quantile)(domain, i / n);
        }

        return scale;
      }

      function scale(x) {
        if (!isNaN(x = +x)) return range[Object(src.bisect)(thresholds, x)];
      }

      return scale.invertExtent = function (y) {
        var i = range.indexOf(y);
        return i < 0 ? [NaN, NaN] : [0 < i ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
      }, scale.domain = function (_) {
        if (!arguments.length) return domain.slice();
        domain = [];

        for (var d, i = 0, n = _.length; i < n; ++i) {
          null == (d = _[i]) || isNaN(d = +d) || domain.push(d);
        }

        return domain.sort(src.ascending), rescale();
      }, scale.range = function (_) {
        return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
      }, scale.quantiles = function () {
        return thresholds.slice();
      }, scale.copy = function () {
        return quantile().domain(domain).range(range);
      }, scale;
    }

    function quantize() {
      var x0 = 0,
          x1 = 1,
          n = 1,
          domain = [.5],
          range = [0, 1];

      function scale(x) {
        if (x <= x) return range[Object(src.bisect)(domain, x, 0, n)];
      }

      function rescale() {
        var i = -1;

        for (domain = new Array(n); ++i < n;) {
          domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        }

        return scale;
      }

      return scale.domain = function (_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
      }, scale.range = function (_) {
        return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
      }, scale.invertExtent = function (y) {
        var i = range.indexOf(y);
        return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : n <= i ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
      }, scale.copy = function () {
        return quantize().domain([x0, x1]).range(range);
      }, linearish(scale);
    }

    function threshold() {
      var domain = [.5],
          range = [0, 1],
          n = 1;

      function scale(x) {
        if (x <= x) return range[Object(src.bisect)(domain, x, 0, n)];
      }

      return scale.domain = function (_) {
        return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
      }, scale.range = function (_) {
        return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
      }, scale.invertExtent = function (y) {
        var i = range.indexOf(y);
        return [domain[i - 1], domain[i]];
      }, scale.copy = function () {
        return threshold().domain(domain).range(range);
      }, scale;
    }

    var t0 = new Date(),
        t1 = new Date();

    function newInterval(floori, offseti, count, field) {
      function interval(date) {
        return floori(date = new Date(+date)), date;
      }

      return (interval.floor = interval).ceil = function (date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
      }, interval.round = function (date) {
        var d0 = interval(date),
            d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
      }, interval.offset = function (date, step) {
        return offseti(date = new Date(+date), null == step ? 1 : Math.floor(step)), date;
      }, interval.range = function (start, stop, step) {
        var previous,
            range = [];
        if (start = interval.ceil(start), step = null == step ? 1 : Math.floor(step), !(start < stop && 0 < step)) return range;

        for (; range.push(previous = new Date(+start)), offseti(start, step), floori(start), previous < start && start < stop;) {
          ;
        }

        return range;
      }, interval.filter = function (test) {
        return newInterval(function (date) {
          if (date <= date) for (; floori(date), !test(date);) {
            date.setTime(date - 1);
          }
        }, function (date, step) {
          if (date <= date) if (step < 0) for (; ++step <= 0;) {
            for (; offseti(date, -1), !test(date);) {
              ;
            }
          } else for (; 0 <= --step;) {
            for (; offseti(date, 1), !test(date);) {
              ;
            }
          }
        });
      }, count && (interval.count = function (start, end) {
        return t0.setTime(+start), t1.setTime(+end), floori(t0), floori(t1), Math.floor(count(t0, t1));
      }, interval.every = function (step) {
        return step = Math.floor(step), isFinite(step) && 0 < step ? 1 < step ? interval.filter(field ? function (d) {
          return field(d) % step == 0;
        } : function (d) {
          return interval.count(0, d) % step == 0;
        }) : interval : null;
      }), interval;
    }

    var millisecond_millisecond = newInterval(function () {}, function (date, step) {
      date.setTime(+date + step);
    }, function (start, end) {
      return end - start;
    });

    millisecond_millisecond.every = function (k) {
      return k = Math.floor(k), isFinite(k) && 0 < k ? 1 < k ? newInterval(function (date) {
        date.setTime(Math.floor(date / k) * k);
      }, function (date, step) {
        date.setTime(+date + step * k);
      }, function (start, end) {
        return (end - start) / k;
      }) : millisecond_millisecond : null;
    };

    var src_millisecond = millisecond_millisecond,
        second_second = (millisecond_millisecond.range, newInterval(function (date) {
      date.setTime(1e3 * Math.floor(date / 1e3));
    }, function (date, step) {
      date.setTime(+date + 1e3 * step);
    }, function (start, end) {
      return (end - start) / 1e3;
    }, function (date) {
      return date.getUTCSeconds();
    })),
        src_second = second_second,
        minute_minute = (second_second.range, newInterval(function (date) {
      date.setTime(6e4 * Math.floor(date / 6e4));
    }, function (date, step) {
      date.setTime(+date + 6e4 * step);
    }, function (start, end) {
      return (end - start) / 6e4;
    }, function (date) {
      return date.getMinutes();
    })),
        src_minute = minute_minute,
        hour_hour = (minute_minute.range, newInterval(function (date) {
      var offset = 6e4 * date.getTimezoneOffset() % 36e5;
      offset < 0 && (offset += 36e5), date.setTime(36e5 * Math.floor((+date - offset) / 36e5) + offset);
    }, function (date, step) {
      date.setTime(+date + 36e5 * step);
    }, function (start, end) {
      return (end - start) / 36e5;
    }, function (date) {
      return date.getHours();
    })),
        src_hour = hour_hour,
        day_day = (hour_hour.range, newInterval(function (date) {
      date.setHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setDate(date.getDate() + step);
    }, function (start, end) {
      return (end - start - 6e4 * (end.getTimezoneOffset() - start.getTimezoneOffset())) / 864e5;
    }, function (date) {
      return date.getDate() - 1;
    })),
        src_day = day_day;
    day_day.range;

    function weekday(i) {
      return newInterval(function (date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7), date.setHours(0, 0, 0, 0);
      }, function (date, step) {
        date.setDate(date.getDate() + 7 * step);
      }, function (start, end) {
        return (end - start - 6e4 * (end.getTimezoneOffset() - start.getTimezoneOffset())) / 6048e5;
      });
    }

    var sunday = weekday(0),
        monday = weekday(1),
        tuesday = weekday(2),
        wednesday = weekday(3),
        thursday = weekday(4),
        friday = weekday(5),
        saturday = weekday(6),
        month_month = (sunday.range, monday.range, tuesday.range, wednesday.range, thursday.range, friday.range, saturday.range, newInterval(function (date) {
      date.setDate(1), date.setHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setMonth(date.getMonth() + step);
    }, function (start, end) {
      return end.getMonth() - start.getMonth() + 12 * (end.getFullYear() - start.getFullYear());
    }, function (date) {
      return date.getMonth();
    })),
        src_month = month_month,
        year_year = (month_month.range, newInterval(function (date) {
      date.setMonth(0, 1), date.setHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setFullYear(date.getFullYear() + step);
    }, function (start, end) {
      return end.getFullYear() - start.getFullYear();
    }, function (date) {
      return date.getFullYear();
    }));

    year_year.every = function (k) {
      return isFinite(k = Math.floor(k)) && 0 < k ? newInterval(function (date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k), date.setMonth(0, 1), date.setHours(0, 0, 0, 0);
      }, function (date, step) {
        date.setFullYear(date.getFullYear() + step * k);
      }) : null;
    };

    var src_year = year_year,
        utcMinute = (year_year.range, newInterval(function (date) {
      date.setUTCSeconds(0, 0);
    }, function (date, step) {
      date.setTime(+date + 6e4 * step);
    }, function (start, end) {
      return (end - start) / 6e4;
    }, function (date) {
      return date.getUTCMinutes();
    })),
        src_utcMinute = utcMinute,
        utcHour = (utcMinute.range, newInterval(function (date) {
      date.setUTCMinutes(0, 0, 0);
    }, function (date, step) {
      date.setTime(+date + 36e5 * step);
    }, function (start, end) {
      return (end - start) / 36e5;
    }, function (date) {
      return date.getUTCHours();
    })),
        src_utcHour = utcHour,
        utcDay = (utcHour.range, newInterval(function (date) {
      date.setUTCHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setUTCDate(date.getUTCDate() + step);
    }, function (start, end) {
      return (end - start) / 864e5;
    }, function (date) {
      return date.getUTCDate() - 1;
    })),
        src_utcDay = utcDay;
    utcDay.range;

    function utcWeekday(i) {
      return newInterval(function (date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7), date.setUTCHours(0, 0, 0, 0);
      }, function (date, step) {
        date.setUTCDate(date.getUTCDate() + 7 * step);
      }, function (start, end) {
        return (end - start) / 6048e5;
      });
    }

    var utcSunday = utcWeekday(0),
        utcMonday = utcWeekday(1),
        utcTuesday = utcWeekday(2),
        utcWednesday = utcWeekday(3),
        utcThursday = utcWeekday(4),
        utcFriday = utcWeekday(5),
        utcSaturday = utcWeekday(6),
        utcMonth = (utcSunday.range, utcMonday.range, utcTuesday.range, utcWednesday.range, utcThursday.range, utcFriday.range, utcSaturday.range, newInterval(function (date) {
      date.setUTCDate(1), date.setUTCHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setUTCMonth(date.getUTCMonth() + step);
    }, function (start, end) {
      return end.getUTCMonth() - start.getUTCMonth() + 12 * (end.getUTCFullYear() - start.getUTCFullYear());
    }, function (date) {
      return date.getUTCMonth();
    })),
        src_utcMonth = utcMonth,
        utcYear = (utcMonth.range, newInterval(function (date) {
      date.setUTCMonth(0, 1), date.setUTCHours(0, 0, 0, 0);
    }, function (date, step) {
      date.setUTCFullYear(date.getUTCFullYear() + step);
    }, function (start, end) {
      return end.getUTCFullYear() - start.getUTCFullYear();
    }, function (date) {
      return date.getUTCFullYear();
    }));

    utcYear.every = function (k) {
      return isFinite(k = Math.floor(k)) && 0 < k ? newInterval(function (date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k), date.setUTCMonth(0, 1), date.setUTCHours(0, 0, 0, 0);
      }, function (date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
      }) : null;
    };

    var src_utcYear = utcYear;
    utcYear.range;

    function localDate(d) {
      if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        return date.setFullYear(d.y), date;
      }

      return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
    }

    function utcDate(d) {
      if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        return date.setUTCFullYear(d.y), date;
      }

      return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
    }

    function newYear(y) {
      return {
        y: y,
        m: 0,
        d: 1,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    }

    var defaultLocale_locale,
        timeFormat,
        utcFormat,
        utcParse,
        locale,
        locale_dateTime,
        locale_date,
        locale_time,
        locale_periods,
        locale_weekdays,
        locale_shortWeekdays,
        locale_months,
        locale_shortMonths,
        periodRe,
        periodLookup,
        weekdayRe,
        weekdayLookup,
        shortWeekdayRe,
        shortWeekdayLookup,
        monthRe,
        monthLookup,
        shortMonthRe,
        shortMonthLookup,
        formats,
        utcFormats,
        parses,
        pads = {
      "-": "",
      _: " ",
      0: "0"
    },
        numberRe = /^\s*\d+/,
        percentRe = /^%/,
        requoteRe = /[\\^$*+?|[\]().{}]/g;

    function pad(value, fill, width) {
      var sign = value < 0 ? "-" : "",
          string = (sign ? -value : value) + "",
          length = string.length;
      return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
    }

    function requote(s) {
      return s.replace(requoteRe, "\\$&");
    }

    function formatRe(names) {
      return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
    }

    function formatLookup(names) {
      for (var map = {}, i = -1, n = names.length; ++i < n;) {
        map[names[i].toLowerCase()] = i;
      }

      return map;
    }

    function parseWeekdayNumberSunday(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 1));
      return n ? (d.w = +n[0], i + n[0].length) : -1;
    }

    function parseWeekdayNumberMonday(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 1));
      return n ? (d.u = +n[0], i + n[0].length) : -1;
    }

    function parseWeekNumberSunday(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.U = +n[0], i + n[0].length) : -1;
    }

    function parseWeekNumberISO(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.V = +n[0], i + n[0].length) : -1;
    }

    function parseWeekNumberMonday(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.W = +n[0], i + n[0].length) : -1;
    }

    function parseFullYear(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 4));
      return n ? (d.y = +n[0], i + n[0].length) : -1;
    }

    function parseYear(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.y = +n[0] + (68 < +n[0] ? 1900 : 2e3), i + n[0].length) : -1;
    }

    function parseZone(d, string, i) {
      var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
      return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
    }

    function parseMonthNumber(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
    }

    function parseDayOfMonth(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.d = +n[0], i + n[0].length) : -1;
    }

    function parseDayOfYear(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 3));
      return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
    }

    function parseHour24(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.H = +n[0], i + n[0].length) : -1;
    }

    function parseMinutes(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.M = +n[0], i + n[0].length) : -1;
    }

    function parseSeconds(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 2));
      return n ? (d.S = +n[0], i + n[0].length) : -1;
    }

    function parseMilliseconds(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 3));
      return n ? (d.L = +n[0], i + n[0].length) : -1;
    }

    function parseMicroseconds(d, string, i) {
      var n = numberRe.exec(string.slice(i, i + 6));
      return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
    }

    function parseLiteralPercent(d, string, i) {
      var n = percentRe.exec(string.slice(i, i + 1));
      return n ? i + n[0].length : -1;
    }

    function parseUnixTimestamp(d, string, i) {
      var n = numberRe.exec(string.slice(i));
      return n ? (d.Q = +n[0], i + n[0].length) : -1;
    }

    function parseUnixTimestampSeconds(d, string, i) {
      var n = numberRe.exec(string.slice(i));
      return n ? (d.Q = 1e3 * +n[0], i + n[0].length) : -1;
    }

    function formatDayOfMonth(d, p) {
      return pad(d.getDate(), p, 2);
    }

    function formatHour24(d, p) {
      return pad(d.getHours(), p, 2);
    }

    function formatHour12(d, p) {
      return pad(d.getHours() % 12 || 12, p, 2);
    }

    function formatDayOfYear(d, p) {
      return pad(1 + src_day.count(src_year(d), d), p, 3);
    }

    function formatMilliseconds(d, p) {
      return pad(d.getMilliseconds(), p, 3);
    }

    function formatMicroseconds(d, p) {
      return formatMilliseconds(d, p) + "000";
    }

    function formatMonthNumber(d, p) {
      return pad(d.getMonth() + 1, p, 2);
    }

    function formatMinutes(d, p) {
      return pad(d.getMinutes(), p, 2);
    }

    function formatSeconds(d, p) {
      return pad(d.getSeconds(), p, 2);
    }

    function formatWeekdayNumberMonday(d) {
      var day = d.getDay();
      return 0 === day ? 7 : day;
    }

    function formatWeekNumberSunday(d, p) {
      return pad(sunday.count(src_year(d), d), p, 2);
    }

    function formatWeekNumberISO(d, p) {
      var day = d.getDay();
      return d = 4 <= day || 0 === day ? thursday(d) : thursday.ceil(d), pad(thursday.count(src_year(d), d) + (4 === src_year(d).getDay()), p, 2);
    }

    function formatWeekdayNumberSunday(d) {
      return d.getDay();
    }

    function formatWeekNumberMonday(d, p) {
      return pad(monday.count(src_year(d), d), p, 2);
    }

    function locale_formatYear(d, p) {
      return pad(d.getFullYear() % 100, p, 2);
    }

    function formatFullYear(d, p) {
      return pad(d.getFullYear() % 1e4, p, 4);
    }

    function formatZone(d) {
      var z = d.getTimezoneOffset();
      return (0 < z ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
    }

    function formatUTCDayOfMonth(d, p) {
      return pad(d.getUTCDate(), p, 2);
    }

    function formatUTCHour24(d, p) {
      return pad(d.getUTCHours(), p, 2);
    }

    function formatUTCHour12(d, p) {
      return pad(d.getUTCHours() % 12 || 12, p, 2);
    }

    function formatUTCDayOfYear(d, p) {
      return pad(1 + src_utcDay.count(src_utcYear(d), d), p, 3);
    }

    function formatUTCMilliseconds(d, p) {
      return pad(d.getUTCMilliseconds(), p, 3);
    }

    function formatUTCMicroseconds(d, p) {
      return formatUTCMilliseconds(d, p) + "000";
    }

    function formatUTCMonthNumber(d, p) {
      return pad(d.getUTCMonth() + 1, p, 2);
    }

    function formatUTCMinutes(d, p) {
      return pad(d.getUTCMinutes(), p, 2);
    }

    function formatUTCSeconds(d, p) {
      return pad(d.getUTCSeconds(), p, 2);
    }

    function formatUTCWeekdayNumberMonday(d) {
      var dow = d.getUTCDay();
      return 0 === dow ? 7 : dow;
    }

    function formatUTCWeekNumberSunday(d, p) {
      return pad(utcSunday.count(src_utcYear(d), d), p, 2);
    }

    function formatUTCWeekNumberISO(d, p) {
      var day = d.getUTCDay();
      return d = 4 <= day || 0 === day ? utcThursday(d) : utcThursday.ceil(d), pad(utcThursday.count(src_utcYear(d), d) + (4 === src_utcYear(d).getUTCDay()), p, 2);
    }

    function formatUTCWeekdayNumberSunday(d) {
      return d.getUTCDay();
    }

    function formatUTCWeekNumberMonday(d, p) {
      return pad(utcMonday.count(src_utcYear(d), d), p, 2);
    }

    function formatUTCYear(d, p) {
      return pad(d.getUTCFullYear() % 100, p, 2);
    }

    function formatUTCFullYear(d, p) {
      return pad(d.getUTCFullYear() % 1e4, p, 4);
    }

    function formatUTCZone() {
      return "+0000";
    }

    function formatLiteralPercent() {
      return "%";
    }

    function formatUnixTimestamp(d) {
      return +d;
    }

    function formatUnixTimestampSeconds(d) {
      return Math.floor(+d / 1e3);
    }

    function newFormat(specifier, formats) {
      return function (date) {
        var c,
            pad,
            format,
            string = [],
            i = -1,
            j = 0,
            n = specifier.length;

        for (date instanceof Date || (date = new Date(+date)); ++i < n;) {
          37 === specifier.charCodeAt(i) && (string.push(specifier.slice(j, i)), null != (pad = pads[c = specifier.charAt(++i)]) ? c = specifier.charAt(++i) : pad = "e" === c ? " " : "0", (format = formats[c]) && (c = format(date, pad)), string.push(c), j = i + 1);
        }

        return string.push(specifier.slice(j, i)), string.join("");
      };
    }

    function newParse(specifier, newDate) {
      return function (string) {
        var week,
            day,
            d = newYear(1900);
        if (parseSpecifier(d, specifier, string += "", 0) != string.length) return null;
        if ("Q" in d) return new Date(d.Q);

        if ("p" in d && (d.H = d.H % 12 + 12 * d.p), "V" in d) {
          if (d.V < 1 || 53 < d.V) return null;
          "w" in d || (d.w = 1), "Z" in d ? (week = 4 < (day = (week = utcDate(newYear(d.y))).getUTCDay()) || 0 === day ? utcMonday.ceil(week) : utcMonday(week), week = src_utcDay.offset(week, 7 * (d.V - 1)), d.y = week.getUTCFullYear(), d.m = week.getUTCMonth(), d.d = week.getUTCDate() + (d.w + 6) % 7) : (week = 4 < (day = (week = newDate(newYear(d.y))).getDay()) || 0 === day ? monday.ceil(week) : monday(week), week = src_day.offset(week, 7 * (d.V - 1)), d.y = week.getFullYear(), d.m = week.getMonth(), d.d = week.getDate() + (d.w + 6) % 7);
        } else ("W" in d || "U" in d) && ("w" in d || (d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0), day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay(), d.m = 0, d.d = "W" in d ? (d.w + 6) % 7 + 7 * d.W - (day + 5) % 7 : d.w + 7 * d.U - (day + 6) % 7);

        return "Z" in d ? (d.H += d.Z / 100 | 0, d.M += d.Z % 100, utcDate(d)) : newDate(d);
      };
    }

    function parseSpecifier(d, specifier, string, j) {
      for (var c, parse, i = 0, n = specifier.length, m = string.length; i < n;) {
        if (m <= j) return -1;

        if (37 === (c = specifier.charCodeAt(i++))) {
          if (c = specifier.charAt(i++), !(parse = parses[c in pads ? specifier.charAt(i++) : c]) || (j = parse(d, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) return -1;
      }

      return j;
    }

    locale_dateTime = (locale = {
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }).dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths, periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths), utcFormats = {
      a: function a(d) {
        return locale_shortWeekdays[d.getUTCDay()];
      },
      A: function A(d) {
        return locale_weekdays[d.getUTCDay()];
      },
      b: function b(d) {
        return locale_shortMonths[d.getUTCMonth()];
      },
      B: function B(d) {
        return locale_months[d.getUTCMonth()];
      },
      c: null,
      d: formatUTCDayOfMonth,
      e: formatUTCDayOfMonth,
      f: formatUTCMicroseconds,
      H: formatUTCHour24,
      I: formatUTCHour12,
      j: formatUTCDayOfYear,
      L: formatUTCMilliseconds,
      m: formatUTCMonthNumber,
      M: formatUTCMinutes,
      p: function p(d) {
        return locale_periods[+(12 <= d.getUTCHours())];
      },
      Q: formatUnixTimestamp,
      s: formatUnixTimestampSeconds,
      S: formatUTCSeconds,
      u: formatUTCWeekdayNumberMonday,
      U: formatUTCWeekNumberSunday,
      V: formatUTCWeekNumberISO,
      w: formatUTCWeekdayNumberSunday,
      W: formatUTCWeekNumberMonday,
      x: null,
      X: null,
      y: formatUTCYear,
      Y: formatUTCFullYear,
      Z: formatUTCZone,
      "%": formatLiteralPercent
    }, parses = {
      a: function a(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
      },
      A: function A(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
      },
      b: function b(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
      },
      B: function B(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
      },
      c: function c(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
      },
      d: parseDayOfMonth,
      e: parseDayOfMonth,
      f: parseMicroseconds,
      H: parseHour24,
      I: parseHour24,
      j: parseDayOfYear,
      L: parseMilliseconds,
      m: parseMonthNumber,
      M: parseMinutes,
      p: function p(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
      },
      Q: parseUnixTimestamp,
      s: parseUnixTimestampSeconds,
      S: parseSeconds,
      u: parseWeekdayNumberMonday,
      U: parseWeekNumberSunday,
      V: parseWeekNumberISO,
      w: parseWeekdayNumberSunday,
      W: parseWeekNumberMonday,
      x: function x(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
      },
      X: function X(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
      },
      y: parseYear,
      Y: parseFullYear,
      Z: parseZone,
      "%": parseLiteralPercent
    }, (formats = {
      a: function a(d) {
        return locale_shortWeekdays[d.getDay()];
      },
      A: function A(d) {
        return locale_weekdays[d.getDay()];
      },
      b: function b(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function B(d) {
        return locale_months[d.getMonth()];
      },
      c: null,
      d: formatDayOfMonth,
      e: formatDayOfMonth,
      f: formatMicroseconds,
      H: formatHour24,
      I: formatHour12,
      j: formatDayOfYear,
      L: formatMilliseconds,
      m: formatMonthNumber,
      M: formatMinutes,
      p: function p(d) {
        return locale_periods[+(12 <= d.getHours())];
      },
      Q: formatUnixTimestamp,
      s: formatUnixTimestampSeconds,
      S: formatSeconds,
      u: formatWeekdayNumberMonday,
      U: formatWeekNumberSunday,
      V: formatWeekNumberISO,
      w: formatWeekdayNumberSunday,
      W: formatWeekNumberMonday,
      x: null,
      X: null,
      y: locale_formatYear,
      Y: formatFullYear,
      Z: formatZone,
      "%": formatLiteralPercent
    }).x = newFormat(locale_date, formats), formats.X = newFormat(locale_time, formats), formats.c = newFormat(locale_dateTime, formats), utcFormats.x = newFormat(locale_date, utcFormats), utcFormats.X = newFormat(locale_time, utcFormats), utcFormats.c = newFormat(locale_dateTime, utcFormats), timeFormat = (defaultLocale_locale = {
      format: function format(specifier) {
        var f = newFormat(specifier += "", formats);
        return f.toString = function () {
          return specifier;
        }, f;
      },
      parse: function parse(specifier) {
        var p = newParse(specifier += "", localDate);
        return p.toString = function () {
          return specifier;
        }, p;
      },
      utcFormat: function utcFormat(specifier) {
        var f = newFormat(specifier += "", utcFormats);
        return f.toString = function () {
          return specifier;
        }, f;
      },
      utcParse: function utcParse(specifier) {
        var p = newParse(specifier, utcDate);
        return p.toString = function () {
          return specifier;
        }, p;
      }
    }).format, defaultLocale_locale.parse, utcFormat = defaultLocale_locale.utcFormat, utcParse = defaultLocale_locale.utcParse;
    Date.prototype.toISOString || utcFormat("%Y-%m-%dT%H:%M:%S.%LZ");
    +new Date("2000-01-01T00:00:00.000Z") || utcParse("%Y-%m-%dT%H:%M:%S.%LZ");
    var time_durationSecond = 1e3,
        time_durationMinute = 60 * time_durationSecond,
        time_durationHour = 60 * time_durationMinute,
        time_durationDay = 24 * time_durationHour,
        time_durationWeek = 7 * time_durationDay,
        durationMonth = 30 * time_durationDay,
        durationYear = 365 * time_durationDay;

    function time_date(t) {
      return new Date(t);
    }

    function time_number(t) {
      return t instanceof Date ? +t : +new Date(+t);
    }

    function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
      var scale = continuous(deinterpolateLinear, d3_interpolate_src.interpolateNumber),
          invert = scale.invert,
          domain = scale.domain,
          formatMillisecond = format(".%L"),
          formatSecond = format(":%S"),
          formatMinute = format("%I:%M"),
          formatHour = format("%I %p"),
          formatDay = format("%a %d"),
          formatWeek = format("%b %d"),
          formatMonth = format("%B"),
          formatYear = format("%Y"),
          tickIntervals = [[second, 1, time_durationSecond], [second, 5, 5 * time_durationSecond], [second, 15, 15 * time_durationSecond], [second, 30, 30 * time_durationSecond], [minute, 1, time_durationMinute], [minute, 5, 5 * time_durationMinute], [minute, 15, 15 * time_durationMinute], [minute, 30, 30 * time_durationMinute], [hour, 1, time_durationHour], [hour, 3, 3 * time_durationHour], [hour, 6, 6 * time_durationHour], [hour, 12, 12 * time_durationHour], [day, 1, time_durationDay], [day, 2, 2 * time_durationDay], [week, 1, time_durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];

      function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
      }

      function tickInterval(interval, start, stop, step) {
        if (null == interval && (interval = 10), "number" == typeof interval) {
          var target = Math.abs(stop - start) / interval,
              i = Object(src.bisector)(function (i) {
            return i[2];
          }).right(tickIntervals, target);
          interval = i === tickIntervals.length ? (step = Object(src.tickStep)(start / durationYear, stop / durationYear, interval), year) : i ? (step = (i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i])[1], i[0]) : (step = Math.max(Object(src.tickStep)(start, stop, interval), 1), millisecond);
        }

        return null == step ? interval : interval.every(step);
      }

      return scale.invert = function (y) {
        return new Date(invert(y));
      }, scale.domain = function (_) {
        return arguments.length ? domain(array_map.call(_, time_number)) : domain().map(time_date);
      }, scale.ticks = function (interval, step) {
        var t,
            d = domain(),
            t0 = d[0],
            t1 = d[d.length - 1],
            r = t1 < t0;
        return r && (t = t0, t0 = t1, t1 = t), t = (t = tickInterval(interval, t0, t1, step)) ? t.range(t0, t1 + 1) : [], r ? t.reverse() : t;
      }, scale.tickFormat = function (count, specifier) {
        return null == specifier ? tickFormat : format(specifier);
      }, scale.nice = function (interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain(nice(d, interval)) : scale;
      }, scale.copy = function () {
        return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
      }, scale;
    }

    function time() {
      return calendar(src_year, src_month, sunday, src_day, src_hour, src_minute, src_second, src_millisecond, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
    }

    function utcTime() {
      return calendar(src_utcYear, src_utcMonth, utcSunday, src_utcDay, src_utcHour, src_utcMinute, src_second, src_millisecond, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
    }

    function sequential(interpolator) {
      var x0 = 0,
          x1 = 1,
          k10 = 1,
          clamp = !1;

      function scale(x) {
        var t = (x - x0) * k10;
        return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
      }

      return scale.domain = function (_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], k10 = x0 === x1 ? 0 : 1 / (x1 - x0), scale) : [x0, x1];
      }, scale.clamp = function (_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
      }, scale.interpolator = function (_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
      }, scale.copy = function () {
        return sequential(interpolator).domain([x0, x1]).clamp(clamp);
      }, linearish(scale);
    }

    function diverging(interpolator) {
      var x0 = 0,
          x1 = .5,
          x2 = 1,
          k10 = 1,
          k21 = 1,
          clamp = !1;

      function scale(x) {
        var t = .5 + ((x = +x) - x1) * (x < x1 ? k10 : k21);
        return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
      }

      return scale.domain = function (_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], x2 = +_[2], k10 = x0 === x1 ? 0 : .5 / (x1 - x0), k21 = x1 === x2 ? 0 : .5 / (x2 - x1), scale) : [x0, x1, x2];
      }, scale.clamp = function (_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
      }, scale.interpolator = function (_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
      }, scale.copy = function () {
        return diverging(interpolator).domain([x0, x1, x2]).clamp(clamp);
      }, linearish(scale);
    }

    __webpack_require__.d(__webpack_exports__, "scaleBand", function () {
      return band;
    }), __webpack_require__.d(__webpack_exports__, "scalePoint", function () {
      return point;
    }), __webpack_require__.d(__webpack_exports__, "scaleIdentity", function () {
      return identity;
    }), __webpack_require__.d(__webpack_exports__, "scaleLinear", function () {
      return linear;
    }), __webpack_require__.d(__webpack_exports__, "scaleLog", function () {
      return log;
    }), __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function () {
      return ordinal;
    }), __webpack_require__.d(__webpack_exports__, "scaleImplicit", function () {
      return implicit;
    }), __webpack_require__.d(__webpack_exports__, "scalePow", function () {
      return pow;
    }), __webpack_require__.d(__webpack_exports__, "scaleSqrt", function () {
      return sqrt;
    }), __webpack_require__.d(__webpack_exports__, "scaleQuantile", function () {
      return quantile;
    }), __webpack_require__.d(__webpack_exports__, "scaleQuantize", function () {
      return quantize;
    }), __webpack_require__.d(__webpack_exports__, "scaleThreshold", function () {
      return threshold;
    }), __webpack_require__.d(__webpack_exports__, "scaleTime", function () {
      return time;
    }), __webpack_require__.d(__webpack_exports__, "scaleUtc", function () {
      return utcTime;
    }), __webpack_require__.d(__webpack_exports__, "scaleSequential", function () {
      return sequential;
    }), __webpack_require__.d(__webpack_exports__, "scaleDiverging", function () {
      return diverging;
    });
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);

    function ramp(scheme) {
      return Object(src.interpolateRgbBasis)(scheme[scheme.length - 1]);
    }

    function rainbow(t) {
      (t < 0 || 1 < t) && (t -= Math.floor(t));
      var ts = Math.abs(t - .5);
      return c.h = 360 * t - 100, c.s = 1.5 - 1.5 * ts, c.l = .8 - .9 * ts, c + "";
    }

    function sinebow(t) {
      var x;
      return t = (.5 - t) * Math.PI, sinebow_c.r = 255 * (x = Math.sin(t)) * x, sinebow_c.g = 255 * (x = Math.sin(t + pi_1_3)) * x, sinebow_c.b = 255 * (x = Math.sin(t + pi_2_3)) * x, sinebow_c + "";
    }

    var colors = function colors(specifier) {
      for (var n = specifier.length / 6 | 0, colors = new Array(n), i = 0; i < n;) {
        colors[i] = "#" + specifier.slice(6 * i, 6 * ++i);
      }

      return colors;
    },
        category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"),
        Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"),
        Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"),
        Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"),
        Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"),
        Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"),
        Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"),
        Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"),
        Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"),
        src = __webpack_require__(3),
        BrBG_scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors),
        BrBG = ramp(BrBG_scheme),
        PRGn_scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors),
        PRGn = ramp(PRGn_scheme),
        PiYG_scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors),
        PiYG = ramp(PiYG_scheme),
        PuOr_scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors),
        PuOr = ramp(PuOr_scheme),
        RdBu_scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors),
        RdBu = ramp(RdBu_scheme),
        RdGy_scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors),
        RdGy = ramp(RdGy_scheme),
        RdYlBu_scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors),
        RdYlBu = ramp(RdYlBu_scheme),
        RdYlGn_scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors),
        RdYlGn = ramp(RdYlGn_scheme),
        Spectral_scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors),
        Spectral = ramp(Spectral_scheme),
        BuGn_scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors),
        BuGn = ramp(BuGn_scheme),
        BuPu_scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors),
        BuPu = ramp(BuPu_scheme),
        GnBu_scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors),
        GnBu = ramp(GnBu_scheme),
        OrRd_scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors),
        OrRd = ramp(OrRd_scheme),
        PuBuGn_scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors),
        PuBuGn = ramp(PuBuGn_scheme),
        PuBu_scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors),
        PuBu = ramp(PuBu_scheme),
        PuRd_scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors),
        PuRd = ramp(PuRd_scheme),
        RdPu_scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors),
        RdPu = ramp(RdPu_scheme),
        YlGnBu_scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors),
        YlGnBu = ramp(YlGnBu_scheme),
        YlGn_scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors),
        YlGn = ramp(YlGn_scheme),
        YlOrBr_scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors),
        YlOrBr = ramp(YlOrBr_scheme),
        YlOrRd_scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors),
        YlOrRd = ramp(YlOrRd_scheme),
        Blues_scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors),
        Blues = ramp(Blues_scheme),
        Greens_scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors),
        Greens = ramp(Greens_scheme),
        Greys_scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors),
        Greys = ramp(Greys_scheme),
        Purples_scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors),
        Purples = ramp(Purples_scheme),
        Reds_scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors),
        Reds = ramp(Reds_scheme),
        Oranges_scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors),
        Oranges = ramp(Oranges_scheme),
        d3_color_src = __webpack_require__(0),
        cubehelix = Object(src.interpolateCubehelixLong)(Object(d3_color_src.b)(300, .5, 0), Object(d3_color_src.b)(-240, .5, 1)),
        warm = Object(src.interpolateCubehelixLong)(Object(d3_color_src.b)(-100, .75, .35), Object(d3_color_src.b)(80, 1.5, .8)),
        cool = Object(src.interpolateCubehelixLong)(Object(d3_color_src.b)(260, .75, .35), Object(d3_color_src.b)(80, 1.5, .8)),
        c = Object(d3_color_src.b)(),
        sinebow_c = Object(d3_color_src.f)(),
        pi_1_3 = Math.PI / 3,
        pi_2_3 = 2 * Math.PI / 3;

    function viridis_ramp(range) {
      var n = range.length;
      return function (t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
      };
    }

    var viridis = viridis_ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")),
        magma = viridis_ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),
        inferno = viridis_ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),
        plasma = viridis_ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
    __webpack_require__.d(__webpack_exports__, "schemeCategory10", function () {
      return category10;
    }), __webpack_require__.d(__webpack_exports__, "schemeAccent", function () {
      return Accent;
    }), __webpack_require__.d(__webpack_exports__, "schemeDark2", function () {
      return Dark2;
    }), __webpack_require__.d(__webpack_exports__, "schemePaired", function () {
      return Paired;
    }), __webpack_require__.d(__webpack_exports__, "schemePastel1", function () {
      return Pastel1;
    }), __webpack_require__.d(__webpack_exports__, "schemePastel2", function () {
      return Pastel2;
    }), __webpack_require__.d(__webpack_exports__, "schemeSet1", function () {
      return Set1;
    }), __webpack_require__.d(__webpack_exports__, "schemeSet2", function () {
      return Set2;
    }), __webpack_require__.d(__webpack_exports__, "schemeSet3", function () {
      return Set3;
    }), __webpack_require__.d(__webpack_exports__, "interpolateBrBG", function () {
      return BrBG;
    }), __webpack_require__.d(__webpack_exports__, "schemeBrBG", function () {
      return BrBG_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePRGn", function () {
      return PRGn;
    }), __webpack_require__.d(__webpack_exports__, "schemePRGn", function () {
      return PRGn_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePiYG", function () {
      return PiYG;
    }), __webpack_require__.d(__webpack_exports__, "schemePiYG", function () {
      return PiYG_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePuOr", function () {
      return PuOr;
    }), __webpack_require__.d(__webpack_exports__, "schemePuOr", function () {
      return PuOr_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRdBu", function () {
      return RdBu;
    }), __webpack_require__.d(__webpack_exports__, "schemeRdBu", function () {
      return RdBu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRdGy", function () {
      return RdGy;
    }), __webpack_require__.d(__webpack_exports__, "schemeRdGy", function () {
      return RdGy_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRdYlBu", function () {
      return RdYlBu;
    }), __webpack_require__.d(__webpack_exports__, "schemeRdYlBu", function () {
      return RdYlBu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRdYlGn", function () {
      return RdYlGn;
    }), __webpack_require__.d(__webpack_exports__, "schemeRdYlGn", function () {
      return RdYlGn_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateSpectral", function () {
      return Spectral;
    }), __webpack_require__.d(__webpack_exports__, "schemeSpectral", function () {
      return Spectral_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateBuGn", function () {
      return BuGn;
    }), __webpack_require__.d(__webpack_exports__, "schemeBuGn", function () {
      return BuGn_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateBuPu", function () {
      return BuPu;
    }), __webpack_require__.d(__webpack_exports__, "schemeBuPu", function () {
      return BuPu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateGnBu", function () {
      return GnBu;
    }), __webpack_require__.d(__webpack_exports__, "schemeGnBu", function () {
      return GnBu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateOrRd", function () {
      return OrRd;
    }), __webpack_require__.d(__webpack_exports__, "schemeOrRd", function () {
      return OrRd_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePuBuGn", function () {
      return PuBuGn;
    }), __webpack_require__.d(__webpack_exports__, "schemePuBuGn", function () {
      return PuBuGn_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePuBu", function () {
      return PuBu;
    }), __webpack_require__.d(__webpack_exports__, "schemePuBu", function () {
      return PuBu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePuRd", function () {
      return PuRd;
    }), __webpack_require__.d(__webpack_exports__, "schemePuRd", function () {
      return PuRd_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRdPu", function () {
      return RdPu;
    }), __webpack_require__.d(__webpack_exports__, "schemeRdPu", function () {
      return RdPu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateYlGnBu", function () {
      return YlGnBu;
    }), __webpack_require__.d(__webpack_exports__, "schemeYlGnBu", function () {
      return YlGnBu_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateYlGn", function () {
      return YlGn;
    }), __webpack_require__.d(__webpack_exports__, "schemeYlGn", function () {
      return YlGn_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateYlOrBr", function () {
      return YlOrBr;
    }), __webpack_require__.d(__webpack_exports__, "schemeYlOrBr", function () {
      return YlOrBr_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateYlOrRd", function () {
      return YlOrRd;
    }), __webpack_require__.d(__webpack_exports__, "schemeYlOrRd", function () {
      return YlOrRd_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateBlues", function () {
      return Blues;
    }), __webpack_require__.d(__webpack_exports__, "schemeBlues", function () {
      return Blues_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateGreens", function () {
      return Greens;
    }), __webpack_require__.d(__webpack_exports__, "schemeGreens", function () {
      return Greens_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateGreys", function () {
      return Greys;
    }), __webpack_require__.d(__webpack_exports__, "schemeGreys", function () {
      return Greys_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePurples", function () {
      return Purples;
    }), __webpack_require__.d(__webpack_exports__, "schemePurples", function () {
      return Purples_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateReds", function () {
      return Reds;
    }), __webpack_require__.d(__webpack_exports__, "schemeReds", function () {
      return Reds_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateOranges", function () {
      return Oranges;
    }), __webpack_require__.d(__webpack_exports__, "schemeOranges", function () {
      return Oranges_scheme;
    }), __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function () {
      return cubehelix;
    }), __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function () {
      return rainbow;
    }), __webpack_require__.d(__webpack_exports__, "interpolateWarm", function () {
      return warm;
    }), __webpack_require__.d(__webpack_exports__, "interpolateCool", function () {
      return cool;
    }), __webpack_require__.d(__webpack_exports__, "interpolateSinebow", function () {
      return sinebow;
    }), __webpack_require__.d(__webpack_exports__, "interpolateViridis", function () {
      return viridis;
    }), __webpack_require__.d(__webpack_exports__, "interpolateMagma", function () {
      return magma;
    }), __webpack_require__.d(__webpack_exports__, "interpolateInferno", function () {
      return inferno;
    }), __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function () {
      return plasma;
    });
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    function defaultSeparation(a, b) {
      return a.parent === b.parent ? 1 : 2;
    }

    function meanXReduce(x, c) {
      return x + c.x;
    }

    function maxYReduce(y, c) {
      return Math.max(y, c.y);
    }

    __webpack_require__.r(__webpack_exports__);

    var cluster = function cluster() {
      var separation = defaultSeparation,
          dx = 1,
          dy = 1,
          nodeSize = !1;

      function cluster(root) {
        var previousNode,
            x = 0;
        root.eachAfter(function (node) {
          var children = node.children;
          children ? (node.x = function (children) {
            return children.reduce(meanXReduce, 0) / children.length;
          }(children), node.y = function (children) {
            return 1 + children.reduce(maxYReduce, 0);
          }(children)) : (node.x = previousNode ? x += separation(node, previousNode) : 0, node.y = 0, previousNode = node);
        });

        var left = function (node) {
          for (var children; children = node.children;) {
            node = children[0];
          }

          return node;
        }(root),
            right = function (node) {
          for (var children; children = node.children;) {
            node = children[children.length - 1];
          }

          return node;
        }(root),
            x0 = left.x - separation(left, right) / 2,
            x1 = right.x + separation(right, left) / 2;

        return root.eachAfter(nodeSize ? function (node) {
          node.x = (node.x - root.x) * dx, node.y = (root.y - node.y) * dy;
        } : function (node) {
          node.x = (node.x - x0) / (x1 - x0) * dx, node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
      }

      return cluster.separation = function (x) {
        return arguments.length ? (separation = x, cluster) : separation;
      }, cluster.size = function (x) {
        return arguments.length ? (nodeSize = !1, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [dx, dy];
      }, cluster.nodeSize = function (x) {
        return arguments.length ? (nodeSize = !0, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [dx, dy] : null;
      }, cluster;
    };

    function _count(node) {
      var sum = 0,
          children = node.children,
          i = children && children.length;
      if (i) for (; 0 <= --i;) {
        sum += children[i].value;
      } else sum = 1;
      node.value = sum;
    }

    function hierarchy(data, children) {
      var node,
          child,
          childs,
          i,
          n,
          root = new Node(data),
          valued = +data.value && (root.value = data.value),
          nodes = [root];

      for (null == children && (children = defaultChildren); node = nodes.pop();) {
        if (valued && (node.value = +node.data.value), (childs = children(node.data)) && (n = childs.length)) for (node.children = new Array(n), i = n - 1; 0 <= i; --i) {
          nodes.push(child = node.children[i] = new Node(childs[i])), child.parent = node, child.depth = node.depth + 1;
        }
      }

      return root.eachBefore(computeHeight);
    }

    function defaultChildren(d) {
      return d.children;
    }

    function copyData(node) {
      node.data = node.data.data;
    }

    function computeHeight(node) {
      for (var height = 0; node.height = height, (node = node.parent) && node.height < ++height;) {
        ;
      }
    }

    function Node(data) {
      this.data = data, this.depth = this.height = 0, this.parent = null;
    }

    Node.prototype = hierarchy.prototype = {
      constructor: Node,
      count: function count() {
        return this.eachAfter(_count);
      },
      each: function each(callback) {
        var current,
            children,
            i,
            n,
            node = this,
            next = [node];

        do {
          for (current = next.reverse(), next = []; node = current.pop();) {
            if (callback(node), children = node.children) for (i = 0, n = children.length; i < n; ++i) {
              next.push(children[i]);
            }
          }
        } while (next.length);

        return this;
      },
      eachAfter: function eachAfter(callback) {
        for (var children, i, n, node = this, nodes = [node], next = []; node = nodes.pop();) {
          if (next.push(node), children = node.children) for (i = 0, n = children.length; i < n; ++i) {
            nodes.push(children[i]);
          }
        }

        for (; node = next.pop();) {
          callback(node);
        }

        return this;
      },
      eachBefore: function eachBefore(callback) {
        for (var children, i, node = this, nodes = [node]; node = nodes.pop();) {
          if (callback(node), children = node.children) for (i = children.length - 1; 0 <= i; --i) {
            nodes.push(children[i]);
          }
        }

        return this;
      },
      sum: function sum(value) {
        return this.eachAfter(function (node) {
          for (var sum = +value(node.data) || 0, children = node.children, i = children && children.length; 0 <= --i;) {
            sum += children[i].value;
          }

          node.value = sum;
        });
      },
      sort: function sort(compare) {
        return this.eachBefore(function (node) {
          node.children && node.children.sort(compare);
        });
      },
      path: function path(end) {
        for (var start = this, ancestor = function (a, b) {
          if (a === b) return a;
          var aNodes = a.ancestors(),
              bNodes = b.ancestors(),
              c = null;
          a = aNodes.pop(), b = bNodes.pop();

          for (; a === b;) {
            c = a, a = aNodes.pop(), b = bNodes.pop();
          }

          return c;
        }(start, end), nodes = [start]; start !== ancestor;) {
          start = start.parent, nodes.push(start);
        }

        for (var k = nodes.length; end !== ancestor;) {
          nodes.splice(k, 0, end), end = end.parent;
        }

        return nodes;
      },
      ancestors: function ancestors() {
        for (var node = this, nodes = [node]; node = node.parent;) {
          nodes.push(node);
        }

        return nodes;
      },
      descendants: function descendants() {
        var nodes = [];
        return this.each(function (node) {
          nodes.push(node);
        }), nodes;
      },
      leaves: function leaves() {
        var leaves = [];
        return this.eachBefore(function (node) {
          node.children || leaves.push(node);
        }), leaves;
      },
      links: function links() {
        var root = this,
            links = [];
        return root.each(function (node) {
          node !== root && links.push({
            source: node.parent,
            target: node
          });
        }), links;
      },
      copy: function copy() {
        return hierarchy(this).eachBefore(copyData);
      }
    };
    var slice = Array.prototype.slice;

    var enclose = function enclose(circles) {
      for (var p, e, i = 0, n = (circles = function (array) {
        for (var t, i, m = array.length; m;) {
          i = Math.random() * m-- | 0, t = array[m], array[m] = array[i], array[i] = t;
        }

        return array;
      }(slice.call(circles))).length, B = []; i < n;) {
        p = circles[i], e && enclosesWeak(e, p) ? ++i : (e = encloseBasis(B = extendBasis(B, p)), i = 0);
      }

      return e;
    };

    function extendBasis(B, p) {
      var i, j;
      if (enclosesWeakAll(p, B)) return [p];

      for (i = 0; i < B.length; ++i) {
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [B[i], p];
      }

      for (i = 0; i < B.length - 1; ++i) {
        for (j = i + 1; j < B.length; ++j) {
          if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [B[i], B[j], p];
        }
      }

      throw new Error();
    }

    function enclosesNot(a, b) {
      var dr = a.r - b.r,
          dx = b.x - a.x,
          dy = b.y - a.y;
      return dr < 0 || dr * dr < dx * dx + dy * dy;
    }

    function enclosesWeak(a, b) {
      var dr = a.r - b.r + 1e-6,
          dx = b.x - a.x,
          dy = b.y - a.y;
      return 0 < dr && dx * dx + dy * dy < dr * dr;
    }

    function enclosesWeakAll(a, B) {
      for (var i = 0; i < B.length; ++i) {
        if (!enclosesWeak(a, B[i])) return !1;
      }

      return !0;
    }

    function encloseBasis(B) {
      switch (B.length) {
        case 1:
          return function (a) {
            return {
              x: a.x,
              y: a.y,
              r: a.r
            };
          }(B[0]);

        case 2:
          return encloseBasis2(B[0], B[1]);

        case 3:
          return encloseBasis3(B[0], B[1], B[2]);
      }
    }

    function encloseBasis2(a, b) {
      var x1 = a.x,
          y1 = a.y,
          r1 = a.r,
          x2 = b.x,
          y2 = b.y,
          r2 = b.r,
          x21 = x2 - x1,
          y21 = y2 - y1,
          r21 = r2 - r1,
          l = Math.sqrt(x21 * x21 + y21 * y21);
      return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
      };
    }

    function encloseBasis3(a, b, c) {
      var x1 = a.x,
          y1 = a.y,
          r1 = a.r,
          x2 = b.x,
          y2 = b.y,
          r2 = b.r,
          x3 = c.x,
          y3 = c.y,
          r3 = c.r,
          a2 = x1 - x2,
          a3 = x1 - x3,
          b2 = y1 - y2,
          b3 = y1 - y3,
          c2 = r2 - r1,
          c3 = r3 - r1,
          d1 = x1 * x1 + y1 * y1 - r1 * r1,
          d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
          d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
          ab = a3 * b2 - a2 * b3,
          xa = (b2 * d3 - b3 * d2) / (2 * ab) - x1,
          xb = (b3 * c2 - b2 * c3) / ab,
          ya = (a3 * d2 - a2 * d3) / (2 * ab) - y1,
          yb = (a2 * c3 - a3 * c2) / ab,
          A = xb * xb + yb * yb - 1,
          B = 2 * (r1 + xa * xb + ya * yb),
          C = xa * xa + ya * ya - r1 * r1,
          r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
      return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
      };
    }

    function place(b, a, c) {
      var x,
          a2,
          y,
          b2,
          dx = b.x - a.x,
          dy = b.y - a.y,
          d2 = dx * dx + dy * dy;
      d2 ? (a2 = a.r + c.r, a2 *= a2, b2 = b.r + c.r, (b2 *= b2) < a2 ? (x = (d2 + b2 - a2) / (2 * d2), y = Math.sqrt(Math.max(0, b2 / d2 - x * x)), c.x = b.x - x * dx - y * dy, c.y = b.y - x * dy + y * dx) : (x = (d2 + a2 - b2) / (2 * d2), y = Math.sqrt(Math.max(0, a2 / d2 - x * x)), c.x = a.x + x * dx - y * dy, c.y = a.y + x * dy + y * dx)) : (c.x = a.x + c.r, c.y = a.y);
    }

    function intersects(a, b) {
      var dr = a.r + b.r - 1e-6,
          dx = b.x - a.x,
          dy = b.y - a.y;
      return 0 < dr && dx * dx + dy * dy < dr * dr;
    }

    function score(node) {
      var a = node._,
          b = node.next._,
          ab = a.r + b.r,
          dx = (a.x * b.r + b.x * a.r) / ab,
          dy = (a.y * b.r + b.y * a.r) / ab;
      return dx * dx + dy * dy;
    }

    function siblings_Node(circle) {
      this._ = circle, this.next = null, this.previous = null;
    }

    function packEnclose(circles) {
      if (!(n = circles.length)) return 0;
      var a, b, c, n, aa, ca, i, j, k, sj, sk;
      if ((a = circles[0]).x = 0, a.y = 0, !(1 < n)) return a.r;
      if (b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0, !(2 < n)) return a.r + b.r;
      place(b, a, c = circles[2]), a = new siblings_Node(a), b = new siblings_Node(b), c = new siblings_Node(c), a.next = c.previous = b, b.next = a.previous = c, c.next = b.previous = a;

      pack: for (i = 3; i < n; ++i) {
        place(a._, b._, c = circles[i]), c = new siblings_Node(c), j = b.next, k = a.previous, sj = b._.r, sk = a._.r;

        do {
          if (sj <= sk) {
            if (intersects(j._, c._)) {
              b = j, (a.next = b).previous = a, --i;
              continue pack;
            }

            sj += j._.r, j = j.next;
          } else {
            if (intersects(k._, c._)) {
              ((a = k).next = b).previous = a, --i;
              continue pack;
            }

            sk += k._.r, k = k.previous;
          }
        } while (j !== k.next);

        for (c.previous = a, c.next = b, a.next = b.previous = b = c, aa = score(a); (c = c.next) !== b;) {
          (ca = score(c)) < aa && (a = c, aa = ca);
        }

        b = a.next;
      }

      for (a = [b._], c = b; (c = c.next) !== b;) {
        a.push(c._);
      }

      for (c = enclose(a), i = 0; i < n; ++i) {
        (a = circles[i]).x -= c.x, a.y -= c.y;
      }

      return c.r;
    }

    function siblings(circles) {
      return packEnclose(circles), circles;
    }

    function required(f) {
      if ("function" != typeof f) throw new Error();
      return f;
    }

    function constantZero() {
      return 0;
    }

    function constant(x) {
      return function () {
        return x;
      };
    }

    function defaultRadius(d) {
      return Math.sqrt(d.value);
    }

    function src_pack() {
      var radius = null,
          dx = 1,
          dy = 1,
          padding = constantZero;

      function pack(root) {
        return root.x = dx / 2, root.y = dy / 2, radius ? root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, .5)).eachBefore(translateChild(1)) : root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(constantZero, 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r))), root;
      }

      return pack.radius = function (x) {
        return arguments.length ? (radius = function (f) {
          return null == f ? null : required(f);
        }(x), pack) : radius;
      }, pack.size = function (x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
      }, pack.padding = function (x) {
        return arguments.length ? (padding = "function" == typeof x ? x : constant(+x), pack) : padding;
      }, pack;
    }

    function radiusLeaf(radius) {
      return function (node) {
        node.children || (node.r = Math.max(0, +radius(node) || 0));
      };
    }

    function packChildren(padding, k) {
      return function (node) {
        if (children = node.children) {
          var children,
              i,
              e,
              n = children.length,
              r = padding(node) * k || 0;
          if (r) for (i = 0; i < n; ++i) {
            children[i].r += r;
          }
          if (e = packEnclose(children), r) for (i = 0; i < n; ++i) {
            children[i].r -= r;
          }
          node.r = e + r;
        }
      };
    }

    function translateChild(k) {
      return function (node) {
        var parent = node.parent;
        node.r *= k, parent && (node.x = parent.x + k * node.x, node.y = parent.y + k * node.y);
      };
    }

    function treemap_round(node) {
      node.x0 = Math.round(node.x0), node.y0 = Math.round(node.y0), node.x1 = Math.round(node.x1), node.y1 = Math.round(node.y1);
    }

    function src_partition() {
      var dx = 1,
          dy = 1,
          padding = 0,
          round = !1;

      function partition(root) {
        var n = root.height + 1;
        return root.x0 = root.y0 = padding, root.x1 = dx, root.y1 = dy / n, root.eachBefore(function (dy, n) {
          return function (node) {
            node.children && dice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0,
                y0 = node.y0,
                x1 = node.x1 - padding,
                y1 = node.y1 - padding;
            x1 < x0 && (x0 = x1 = (x0 + x1) / 2), y1 < y0 && (y0 = y1 = (y0 + y1) / 2), node.x0 = x0, node.y0 = y0, node.x1 = x1, node.y1 = y1;
          };
        }(dy, n)), round && root.eachBefore(treemap_round), root;
      }

      return partition.round = function (x) {
        return arguments.length ? (round = !!x, partition) : round;
      }, partition.size = function (x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
      }, partition.padding = function (x) {
        return arguments.length ? (padding = +x, partition) : padding;
      }, partition;
    }

    var dice = function dice(parent, x0, y0, x1, y1) {
      for (var node, nodes = parent.children, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value; ++i < n;) {
        (node = nodes[i]).y0 = y0, node.y1 = y1, node.x0 = x0, node.x1 = x0 += node.value * k;
      }
    },
        preroot = {
      depth: -1
    },
        ambiguous = {};

    function defaultId(d) {
      return d.id;
    }

    function defaultParentId(d) {
      return d.parentId;
    }

    function src_stratify() {
      var id = defaultId,
          parentId = defaultParentId;

      function stratify(data) {
        var d,
            i,
            root,
            parent,
            node,
            nodeId,
            nodeKey,
            n = data.length,
            nodes = new Array(n),
            nodeByKey = {};

        for (i = 0; i < n; ++i) {
          d = data[i], node = nodes[i] = new Node(d), null != (nodeId = id(d, i, data)) && (nodeId += "") && (nodeByKey[nodeKey = "$" + (node.id = nodeId)] = nodeKey in nodeByKey ? ambiguous : node);
        }

        for (i = 0; i < n; ++i) {
          if (node = nodes[i], null != (nodeId = parentId(data[i], i, data)) && (nodeId += "")) {
            if (!(parent = nodeByKey["$" + nodeId])) throw new Error("missing: " + nodeId);
            if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
            parent.children ? parent.children.push(node) : parent.children = [node], node.parent = parent;
          } else {
            if (root) throw new Error("multiple roots");
            root = node;
          }
        }

        if (!root) throw new Error("no root");
        if (root.parent = preroot, root.eachBefore(function (node) {
          node.depth = node.parent.depth + 1, --n;
        }).eachBefore(computeHeight), root.parent = null, 0 < n) throw new Error("cycle");
        return root;
      }

      return stratify.id = function (x) {
        return arguments.length ? (id = required(x), stratify) : id;
      }, stratify.parentId = function (x) {
        return arguments.length ? (parentId = required(x), stratify) : parentId;
      }, stratify;
    }

    function tree_defaultSeparation(a, b) {
      return a.parent === b.parent ? 1 : 2;
    }

    function nextLeft(v) {
      var children = v.children;
      return children ? children[0] : v.t;
    }

    function nextRight(v) {
      var children = v.children;
      return children ? children[children.length - 1] : v.t;
    }

    function moveSubtree(wm, wp, shift) {
      var change = shift / (wp.i - wm.i);
      wp.c -= change, wp.s += shift, wm.c += change, wp.z += shift, wp.m += shift;
    }

    function nextAncestor(vim, v, ancestor) {
      return vim.a.parent === v.parent ? vim.a : ancestor;
    }

    function TreeNode(node, i) {
      this._ = node, this.parent = null, this.children = null, this.A = null, (this.a = this).z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = i;
    }

    TreeNode.prototype = Object.create(Node.prototype);

    var tree = function tree() {
      var separation = tree_defaultSeparation,
          dx = 1,
          dy = 1,
          nodeSize = null;

      function tree(root) {
        var t = function (root) {
          for (var node, child, children, i, n, tree = new TreeNode(root, 0), nodes = [tree]; node = nodes.pop();) {
            if (children = node._.children) for (node.children = new Array(n = children.length), i = n - 1; 0 <= i; --i) {
              nodes.push(child = node.children[i] = new TreeNode(children[i], i)), child.parent = node;
            }
          }

          return (tree.parent = new TreeNode(null, 0)).children = [tree], tree;
        }(root);

        if (t.eachAfter(firstWalk), t.parent.m = -t.z, t.eachBefore(secondWalk), nodeSize) root.eachBefore(sizeNode);else {
          var left = root,
              right = root,
              bottom = root;
          root.eachBefore(function (node) {
            node.x < left.x && (left = node), node.x > right.x && (right = node), node.depth > bottom.depth && (bottom = node);
          });
          var s = left === right ? 1 : separation(left, right) / 2,
              tx = s - left.x,
              kx = dx / (right.x + s + tx),
              ky = dy / (bottom.depth || 1);
          root.eachBefore(function (node) {
            node.x = (node.x + tx) * kx, node.y = node.depth * ky;
          });
        }
        return root;
      }

      function firstWalk(v) {
        var children = v.children,
            siblings = v.parent.children,
            w = v.i ? siblings[v.i - 1] : null;

        if (children) {
          !function (v) {
            for (var w, shift = 0, change = 0, children = v.children, i = children.length; 0 <= --i;) {
              (w = children[i]).z += shift, w.m += shift, shift += w.s + (change += w.c);
            }
          }(v);
          var midpoint = (children[0].z + children[children.length - 1].z) / 2;
          w ? (v.z = w.z + separation(v._, w._), v.m = v.z - midpoint) : v.z = midpoint;
        } else w && (v.z = w.z + separation(v._, w._));

        v.parent.A = function (v, w, ancestor) {
          if (w) {
            for (var shift, vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m; vim = nextRight(vim), vip = nextLeft(vip), vim && vip;) {
              vom = nextLeft(vom), (vop = nextRight(vop)).a = v, 0 < (shift = vim.z + sim - vip.z - sip + separation(vim._, vip._)) && (moveSubtree(nextAncestor(vim, v, ancestor), v, shift), sip += shift, sop += shift), sim += vim.m, sip += vip.m, som += vom.m, sop += vop.m;
            }

            vim && !nextRight(vop) && (vop.t = vim, vop.m += sim - sop), vip && !nextLeft(vom) && (vom.t = vip, vom.m += sip - som, ancestor = v);
          }

          return ancestor;
        }(v, w, v.parent.A || siblings[0]);
      }

      function secondWalk(v) {
        v._.x = v.z + v.parent.m, v.m += v.parent.m;
      }

      function sizeNode(node) {
        node.x *= dx, node.y = node.depth * dy;
      }

      return tree.separation = function (x) {
        return arguments.length ? (separation = x, tree) : separation;
      }, tree.size = function (x) {
        return arguments.length ? (nodeSize = !1, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [dx, dy];
      }, tree.nodeSize = function (x) {
        return arguments.length ? (nodeSize = !0, dx = +x[0], dy = +x[1], tree) : nodeSize ? [dx, dy] : null;
      }, tree;
    },
        treemap_slice = function treemap_slice(parent, x0, y0, x1, y1) {
      for (var node, nodes = parent.children, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value; ++i < n;) {
        (node = nodes[i]).x0 = x0, node.x1 = x1, node.y0 = y0, node.y1 = y0 += node.value * k;
      }
    },
        phi = (1 + Math.sqrt(5)) / 2;

    function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
      for (var row, nodeValue, dx, dy, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta, rows = [], nodes = parent.children, i0 = 0, i1 = 0, n = nodes.length, value = parent.value; i0 < n;) {
        for (dx = x1 - x0, dy = y1 - y0; !(sumValue = nodes[i1++].value) && i1 < n;) {
          ;
        }

        for (minValue = maxValue = sumValue, beta = sumValue * sumValue * (alpha = Math.max(dy / dx, dx / dy) / (value * ratio)), minRatio = Math.max(maxValue / beta, beta / minValue); i1 < n; ++i1) {
          if (sumValue += nodeValue = nodes[i1].value, nodeValue < minValue && (minValue = nodeValue), maxValue < nodeValue && (maxValue = nodeValue), beta = sumValue * sumValue * alpha, minRatio < (newRatio = Math.max(maxValue / beta, beta / minValue))) {
            sumValue -= nodeValue;
            break;
          }

          minRatio = newRatio;
        }

        rows.push(row = {
          value: sumValue,
          dice: dx < dy,
          children: nodes.slice(i0, i1)
        }), row.dice ? dice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1) : treemap_slice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1), value -= sumValue, i0 = i1;
      }

      return rows;
    }

    function src_treemap() {
      var tile = squarify,
          round = !1,
          dx = 1,
          dy = 1,
          paddingStack = [0],
          paddingInner = constantZero,
          paddingTop = constantZero,
          paddingRight = constantZero,
          paddingBottom = constantZero,
          paddingLeft = constantZero;

      function treemap(root) {
        return root.x0 = root.y0 = 0, root.x1 = dx, root.y1 = dy, root.eachBefore(positionNode), paddingStack = [0], round && root.eachBefore(treemap_round), root;
      }

      function positionNode(node) {
        var p = paddingStack[node.depth],
            x0 = node.x0 + p,
            y0 = node.y0 + p,
            x1 = node.x1 - p,
            y1 = node.y1 - p;
        x1 < x0 && (x0 = x1 = (x0 + x1) / 2), y1 < y0 && (y0 = y1 = (y0 + y1) / 2), node.x0 = x0, node.y0 = y0, node.x1 = x1, node.y1 = y1, node.children && (p = paddingStack[node.depth + 1] = paddingInner(node) / 2, x0 += paddingLeft(node) - p, y0 += paddingTop(node) - p, (x1 -= paddingRight(node) - p) < x0 && (x0 = x1 = (x0 + x1) / 2), (y1 -= paddingBottom(node) - p) < y0 && (y0 = y1 = (y0 + y1) / 2), tile(node, x0, y0, x1, y1));
      }

      return treemap.round = function (x) {
        return arguments.length ? (round = !!x, treemap) : round;
      }, treemap.size = function (x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
      }, treemap.tile = function (x) {
        return arguments.length ? (tile = required(x), treemap) : tile;
      }, treemap.padding = function (x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
      }, treemap.paddingInner = function (x) {
        return arguments.length ? (paddingInner = "function" == typeof x ? x : constant(+x), treemap) : paddingInner;
      }, treemap.paddingOuter = function (x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
      }, treemap.paddingTop = function (x) {
        return arguments.length ? (paddingTop = "function" == typeof x ? x : constant(+x), treemap) : paddingTop;
      }, treemap.paddingRight = function (x) {
        return arguments.length ? (paddingRight = "function" == typeof x ? x : constant(+x), treemap) : paddingRight;
      }, treemap.paddingBottom = function (x) {
        return arguments.length ? (paddingBottom = "function" == typeof x ? x : constant(+x), treemap) : paddingBottom;
      }, treemap.paddingLeft = function (x) {
        return arguments.length ? (paddingLeft = "function" == typeof x ? x : constant(+x), treemap) : paddingLeft;
      }, treemap;
    }

    function binary(parent, x0, y0, x1, y1) {
      var i,
          sum,
          nodes = parent.children,
          n = nodes.length,
          sums = new Array(n + 1);

      for (sums[0] = sum = i = 0; i < n; ++i) {
        sums[i + 1] = sum += nodes[i].value;
      }

      !function partition(i, j, value, x0, y0, x1, y1) {
        if (j - 1 <= i) {
          var node = nodes[i];
          return node.x0 = x0, node.y0 = y0, node.x1 = x1, void (node.y1 = y1);
        }

        var valueOffset = sums[i],
            valueTarget = value / 2 + valueOffset,
            k = i + 1,
            hi = j - 1;

        for (; k < hi;) {
          var mid = k + hi >>> 1;
          sums[mid] < valueTarget ? k = 1 + mid : hi = mid;
        }

        valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k && --k;
        var valueLeft = sums[k] - valueOffset,
            valueRight = value - valueLeft;

        if (y1 - y0 < x1 - x0) {
          var xk = (x0 * valueRight + x1 * valueLeft) / value;
          partition(i, k, valueLeft, x0, y0, xk, y1), partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
          var yk = (y0 * valueRight + y1 * valueLeft) / value;
          partition(i, k, valueLeft, x0, y0, x1, yk), partition(k, j, valueRight, x0, yk, x1, y1);
        }
      }(0, n, parent.value, x0, y0, x1, y1);
    }

    function sliceDice(parent, x0, y0, x1, y1) {
      (1 & parent.depth ? treemap_slice : dice)(parent, x0, y0, x1, y1);
    }

    var squarify = function custom(ratio) {
      function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
      }

      return squarify.ratio = function (x) {
        return custom(1 < (x = +x) ? x : 1);
      }, squarify;
    }(phi),
        treemap_resquarify = function custom(ratio) {
      function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) for (var rows, row, nodes, i, n, j = -1, m = rows.length, value = parent.value; ++j < m;) {
          for (nodes = (row = rows[j]).children, i = row.value = 0, n = nodes.length; i < n; ++i) {
            row.value += nodes[i].value;
          }

          row.dice ? dice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value) : treemap_slice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1), value -= row.value;
        } else parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1), rows.ratio = ratio;
      }

      return resquarify.ratio = function (x) {
        return custom(1 < (x = +x) ? x : 1);
      }, resquarify;
    }(phi);

    __webpack_require__.d(__webpack_exports__, "cluster", function () {
      return cluster;
    }), __webpack_require__.d(__webpack_exports__, "hierarchy", function () {
      return hierarchy;
    }), __webpack_require__.d(__webpack_exports__, "pack", function () {
      return src_pack;
    }), __webpack_require__.d(__webpack_exports__, "packSiblings", function () {
      return siblings;
    }), __webpack_require__.d(__webpack_exports__, "packEnclose", function () {
      return enclose;
    }), __webpack_require__.d(__webpack_exports__, "partition", function () {
      return src_partition;
    }), __webpack_require__.d(__webpack_exports__, "stratify", function () {
      return src_stratify;
    }), __webpack_require__.d(__webpack_exports__, "tree", function () {
      return tree;
    }), __webpack_require__.d(__webpack_exports__, "treemap", function () {
      return src_treemap;
    }), __webpack_require__.d(__webpack_exports__, "treemapBinary", function () {
      return binary;
    }), __webpack_require__.d(__webpack_exports__, "treemapDice", function () {
      return dice;
    }), __webpack_require__.d(__webpack_exports__, "treemapSlice", function () {
      return treemap_slice;
    }), __webpack_require__.d(__webpack_exports__, "treemapSliceDice", function () {
      return sliceDice;
    }), __webpack_require__.d(__webpack_exports__, "treemapSquarify", function () {
      return squarify;
    }), __webpack_require__.d(__webpack_exports__, "treemapResquarify", function () {
      return treemap_resquarify;
    });
  }], installedModules = {}, __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 14);

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  var modules, installedModules;
});